<template>
  <div class="result-page-container">
    <el-carousel
      v-if="loading"
      arrow="always"
      indicator-position="outside"
      height="70vh"
      style="margin: 5rem 8rem 10rem 8rem"
    >
      <el-carousel-item>
        <div class="img_text">
          <el-image
            fit="contain"
            style="
              flex: 1 1 300px; /* 图片在宽度上至少300px，并且可以扩展 */
              max-width: 50%; /* 图片最大宽度为50% */
              border-radius: 12px;
            "
            :src="img_deepreport"
          ></el-image>
          <p class="ppt-textStyle">
            {{ $t("resultPage").retrievePapers }}<br />
            {{ $t("resultPage").exploreConcepts }}<br />
            {{ $t("resultPage").discoverConnections }}<br />
            {{ $t("resultPage").generateIdeas }}<br />
          </p>
        </div>
        <h3>{{ $t("resultPage").deepReportRunning }}</h3>
      </el-carousel-item>
      <el-carousel-item>
        <div class="img_text">
          <el-image
            fit="contain"
            style="
              flex: 1 1 300px; /* 图片在宽度上至少300px，并且可以扩展 */
              max-width: 50%;
              margin-left: 100px;
              border-radius: 12px;
            "
            :src="img_acemap"
          ></el-image>
          <p class="ppt-textStyle">
            {{ $t("resultPage").acemapDescription }}
          </p>
        </div>
        <h3>{{ $t("resultPage").deepReportRunning }}</h3>
      </el-carousel-item>
      <el-carousel-item>
        <div class="img_text">
          <el-image
            fit="contain"
            style="flex: 1 1 300px; max-width: 30%; margin-left: 100px"
            :src="img_quintuple"
          ></el-image>
          <p class="ppt-textStyle">
            {{ $t("resultPage").paperIntroduction }}
            <span style="font-style: oblique; font-weight: bold">
              {{ $t("resultPage").paperTitle }}
            </span>
            {{ $t("resultPage").paperAuthors }}
            {{ $t("resultPage").paperDescription }}
          </p>
        </div>
        <h3>{{ $t("resultPage").deepReportRunning }}</h3>
      </el-carousel-item>
    </el-carousel>
    <el-container
      v-loading="loading"
      element-loading-text="DeepReport is running..."
    >
      <el-main style="margin: 0 10px 0 10px; padding: 0">
        <div class="result-panel">
          <section class="search-box">
            <el-tooltip
              class="item"
              effect="light"
              placement="top"
              v-model="tooltip_visible"
              :disabled="tooltip_disable"
              :manual="true"
            >
              <div slot="content">
                {{ $t("resultPage").searchTooltip }}
              </div>
              <el-autocomplete
                :readonly="lowAuth"
                class="search-input-box"
                v-model="keywords"
                prefix-icon="el-icon-search"
                :fetch-suggestions="querySearch"
                placeholder="More than your input (ENGLISH ONLY)"
                @keyup.enter.native="searchReport"
              ></el-autocomplete>
            </el-tooltip>
            <div class="switch_mode_button">
              <el-slider
                v-model="switchValue"
                :min="0"
                :max="1"
                :step="1"
                :show-input="false"
                vertical
                :format-tooltip="switchFormatTooltip"
                height="35px"
                style="margin-top: 15px; margin-bottom: 15px"
              ></el-slider>
            </div>
            <el-button
              @click="searchReport"
              style="
                box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);
                background-color: #2d92ff;
                color: #fff;
                font-weight: bolder;
                font-family: 'Helvetica Neue', sans-serif;
                margin-left: 10px;
              "
              icon="el-icon-search"
              ><span class="search-button-text">
                {{ $t("search").search }}</span
              ></el-button
            >
            <el-tooltip
              class="item"
              effect="light"
              :content="$t('resultPage').downloadTooltip"
              placement="top-end"
              v-model="tooltip_visible"
              :disabled="tooltip_disable"
              :manual="true"
            >
              <el-button
                class="download_button"
                @click="download_file"
                :loading="this.fileLoading"
                v-show="conclusion_text !== '' || tooltip_visible"
                style="
                  box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);
                  background-color: #5c92ff;
                  color: #fff;
                  font-weight: bolder;
                  font-family: 'Helvetica Neue', sans-serif;
                "
                icon="el-icon-download"
              ></el-button>
            </el-tooltip>

            <el-tooltip
              class="item"
              effect="light"
              :content="$t('resultPage').feedbackTooltip"
              placement="top-start"
              v-model="tooltip_visible"
              :disabled="tooltip_disable"
              :manual="true"
            >
              <el-button
                class="feedback_button"
                @click="openFeedbackDialog"
                style="
                  box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);
                  background-color: #5c92ff;
                  color: #fff;
                  font-weight: bolder;
                  font-family: 'Helvetica Neue', sans-serif;
                "
                icon="el-icon-message"
              ></el-button>
            </el-tooltip>

            <el-button
              class="tooltip_button"
              @click="show_tooltip"
              v-show="conclusion_text !== ''"
              style="
                box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);
                background-color: #282cff;
                color: #fff;
                font-weight: bolder;
                font-family: 'Helvetica Neue', sans-serif;
              "
              icon="el-icon-question"
            ></el-button>
          </section>
          <section class="main-container">
            <section id="map-panel"></section>
            <section class="layout-left">
              <el-card class="future-topics-panel panel">
                <el-tooltip
                  class="item"
                  effect="light"
                  :content="$t('resultPage').futureDirectionsTooltip"
                  placement="bottom"
                  :manual="true"
                  v-model="tooltip_visible"
                  :disabled="tooltip_disable"
                >
                  <h2 class="title">
                    <i class="el-icon-present" style="margin-right: 5px"></i
                    >{{ $t("search").directions }}
                  </h2>
                </el-tooltip>
                <VuePerfectScrollbar
                  style="
                    height: calc(80%);
                    padding: 10px 5px;
                    border-radius: 10px;
                  "
                  v-loading="this.conclusion_text === ''"
                >
                  <article>
                    <details
                      class="future-research-info"
                      v-for="(item, index) in topics_ls"
                      :key="index"
                      @toggle="handleFutureDirectionToggle($event, item)"
                    >
                      <summary
                        style="
                          list-style: none;
                          cursor: pointer;
                          display: flex;
                          justify-content: space-between;
                          align-items: center;
                        "
                      >
                        <span>{{ displayTopics[index] }}</span>
                        <div>
                          <i
                            class="iconfont el-icon-plus"
                            style="margin-top: 5px"
                            @click="getFutureDirectionDetail(item)"
                          ></i>
                        </div>
                      </summary>
                      <div
                        style="
                          display: flex;
                          align-items: flex-start;
                          margin-top: 8px;
                        "
                      >
                        <div class="future-detail-block">
                          <div class="future-detail-main">
                            <!-- Content area: show content when exists, loading bar when not -->
                            <template v-if="item in topic_gpt_detail">
                              <!-- Expand button in detail content - only show when content exists -->
                              <el-tooltip
                                content="View Details"
                                placement="top"
                              >
                                <i
                                  class="el-icon-view"
                                  style="
                                    margin-right: 12px;
                                    margin-top: 2px;
                                    cursor: pointer;
                                    color: #409eff;
                                    flex-shrink: 0;
                                  "
                                  @click="expandTopicDetail(item)"
                                ></i>
                              </el-tooltip>

                              <span
                                style="
                                  font-size: 12px;
                                  color: gray;
                                  font-weight: normal;
                                  text-align: left;
                                  flex: 1;
                                "
                              >
                                {{ topic_gpt_detail[item] }}
                              </span>
                              <!-- Copy button as icon -->
                              <el-tooltip
                                content="Copy Content"
                                placement="top"
                              >
                                <i
                                  v-clipboard:copy="
                                    item + ':\n\n\n' + topic_gpt_detail[item]
                                  "
                                  class="el-icon-document-copy"
                                  @click="copyResponse"
                                  style="
                                    margin-left: 8px;
                                    cursor: pointer;
                                    transition: transform 0.2s;
                                    color: #409eff;
                                  "
                                  :style="{
                                    transform:
                                      hoveredCopyIcon === 'topic_' + item
                                        ? 'scale(1.2)'
                                        : 'scale(1)',
                                  }"
                                  @mouseenter="
                                    hoveredCopyIcon = 'topic_' + item
                                  "
                                  @mouseleave="hoveredCopyIcon = null"
                                ></i>
                              </el-tooltip>
                            </template>
                            <template v-else>
                              <div
                                class="loading-skeleton"
                                style="flex: 1"
                              ></div>
                            </template>
                          </div>

                          <div class="future-datasets">
                            <div class="dataset-section-title">
                              <i class="el-icon-coin"></i>
                              Recommended Datasets
                            </div>
                            <div
                              v-if="topicDatasetsLoading[item]"
                              class="dataset-loading"
                            >
                              <i class="el-icon-loading"></i>
                              Searching CNS datasets...
                            </div>
                            <div
                              v-else-if="
                                hasTopicDatasetResult(item) &&
                                getTopicDatasets(item).length
                              "
                              class="dataset-list compact"
                            >
                              <a
                                v-for="dataset in getTopicDatasets(item)"
                                :key="dataset.key"
                                :href="dataset.url"
                                target="_blank"
                                class="dataset-chip"
                                :title="dataset.desc || dataset.title"
                              >
                                {{ dataset.title }}
                              </a>
                            </div>
                            <div
                              v-else-if="hasTopicDatasetResult(item)"
                              class="dataset-empty"
                            >
                              No matched CNS datasets.
                            </div>
                            <div v-else class="dataset-loading">
                              Waiting to search CNS datasets...
                            </div>
                          </div>
                        </div>
                      </div>
                    </details>
                  </article>
                </VuePerfectScrollbar>
              </el-card>
              <el-card class="relation-panel panel">
                <el-tooltip
                  class="item"
                  effect="light"
                  placement="bottom"
                  v-model="tooltip_visible"
                  :disabled="tooltip_disable"
                  :manual="true"
                  style="margin: -10px 0 0 0"
                >
                  <div slot="content">
                    {{ $t("resultPage").newConnectionsTooltip }}
                  </div>
                  <h2 class="title" @click="openKnowledgeDialog">
                    <i class="el-icon-connection" style="margin-right: 5px"></i
                    >{{ $t("search").connections }}
                    <div
                      class="try-button"
                      style="
                        float: right;
                        margin-right: 7px;
                        cursor: pointer;
                        background: #ecf5ff;
                        padding: 1px 8px;
                        border-radius: 16px;
                        box-shadow: 0 2px 8px rgba(64, 158, 255, 0.5);
                        transition: all 0.3s ease;
                      "
                    >
                      <span style="font-size: 12px; color: #409eff">{{
                        $t("search").more
                      }}</span
                      >✨
                    </div>
                  </h2>
                </el-tooltip>

                <div
                  style="
                    height: calc(85%);
                    padding: 0 0;
                    border-radius: 12px;
                    width: 100%;
                    position: relative;
                  "
                  v-loading="this.conclusion_text === ''"
                >
                  <!-- 词云容器 -->
                  <div id="relation-cloud-wrap" ref="cloudContainer">
                    <span
                      v-for="(row, index) in new_relation_table"
                      :key="index"
                      class="relation-tag"
                      :data-index="index"
                      @click="handleTagClick($event, row, index)"
                    >
                      <el-popover
                        placement="right-end"
                        width="550"
                        trigger="click"
                        :ref="`popover-${index}`"
                        popper-class="relation-popover"
                      >
                        <!-- 美化的popover内容，与initMap函数getContent部分风格一致 -->
                        <div class="relation-popover-content">
                          <div class="edge-header">
                            <div class="edge-title">
                              <span>{{ row.source_name }}</span>
                              <span class="connector-span">×</span>
                              <span>{{ row.target_name }}</span>
                            </div>

                            <!-- 添加统计信息卡片，与initMap保持一致 -->
                            <div class="edge-stats-card">
                              <div class="edge-stat-item">
                                <div class="edge-stat-label">
                                  Connection Strength
                                </div>
                                <div class="edge-stat-value">
                                  {{ row.weight.toFixed(3) }}
                                </div>
                              </div>
                              <div class="edge-stat-item">
                                <div class="edge-stat-label">Year</div>
                                <div class="edge-stat-value">
                                  {{ row.year }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="tool-list"
                            style="
                              display: flex;
                              justify-content: flex-end;
                              margin: 10px 0;
                              padding-right: 20px;
                            "
                          >
                            <el-tooltip
                              class="item"
                              effect="dark"
                              content="Copy"
                              placement="top"
                            >
                              <i
                                v-clipboard:copy="knowledge_text"
                                style="
                                  margin-right: 10px;
                                  cursor: pointer;
                                  transition: transform 0.2s;
                                  color: rgb(30, 30, 30);
                                "
                                class="iconfont el-icon-document-copy"
                                @click="copyResponse"
                                :style="{
                                  transform:
                                    hoveredCopyIcon === 'knowledge'
                                      ? 'scale(1.2)'
                                      : 'scale(1)',
                                }"
                                @mouseenter="hoveredCopyIcon = 'knowledge'"
                                @mouseleave="hoveredCopyIcon = null"
                              ></i>
                            </el-tooltip>

                            <el-tooltip
                              class="item"
                              effect="dark"
                              content="Like"
                              placement="top"
                            >
                              <img
                                class="iconfont"
                                :src="isAgree === 1 ? agree_fill : agree"
                                width="14px"
                                style="
                                  margin-right: 10px;
                                  cursor: pointer;
                                  transition: transform 0.2s;
                                  color: #1e1e1e;
                                "
                                @click="giveEvaluate(1)"
                                :style="{
                                  transform:
                                    hoveredCopyIcon === 'like'
                                      ? 'scale(1.2)'
                                      : 'scale(1)',
                                }"
                                @mouseenter="hoveredCopyIcon = 'like'"
                                @mouseleave="hoveredCopyIcon = null"
                              />
                            </el-tooltip>
                            <el-tooltip
                              class="item"
                              effect="dark"
                              content="Dislike"
                              placement="top"
                            >
                              <img
                                class="iconfont"
                                :src="isAgree === 0 ? disagree_fill : disagree"
                                width="14px"
                                style="
                                  cursor: pointer;
                                  transition: transform 0.2s;
                                  color: #1e1e1e;
                                "
                                @click="giveEvaluate(0)"
                                :style="{
                                  transform:
                                    hoveredCopyIcon === 'dislike'
                                      ? 'scale(1.2)'
                                      : 'scale(1)',
                                }"
                                @mouseenter="hoveredCopyIcon = 'dislike'"
                                @mouseleave="hoveredCopyIcon = null"
                              />
                            </el-tooltip>
                          </div>
                          <div
                            class="knowledgeSingleText"
                            v-html="displayKnowledge"
                            v-loading="
                              knowledge_text ===
                              'Generated Idea: Please wait a minute.'
                            "
                            style="
                              background: rgba(255, 255, 255, 0.5);
                              backdrop-filter: blur(8px);
                              border-radius: 8px;
                              padding: 15px;
                              margin-top: 10px;
                            "
                          ></div>
                        </div>
                        <!-- 标签显示部分 -->
                        <template #reference>
                          <div class="tag-content">
                            <i class="el-icon-star-on tag-icon"></i>
                            <span class="tag-text">
                              {{ row.source_name }}
                              <i class="el-icon-close"></i>
                              {{ row.target_name }}
                            </span>
                          </div>
                        </template>
                      </el-popover>
                    </span>
                  </div>
                  <!-- nothing to show div-->
                  <div
                    v-if="new_relation_table.length === 0"
                    style="
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                      color: #c0c4cc;
                      font-size: 20px;
                    "
                  >
                    <i class="el-icon-orange"></i> nothing to show
                  </div>
                </div>
              </el-card>
            </section>
            <el-tooltip
              class="item"
              effect="light"
              :content="$t('resultPage').toolboxTooltip"
              placement="top"
              :manual="true"
              v-model="tooltip_visible"
              :disabled="tooltip_disable"
            >
              <section class="layout-middle">
                <el-progress
                  v-show="show_year_percentage"
                  :text-inside="true"
                  :stroke-width="20"
                  :percentage="year_percentage"
                  style="margin-bottom: 10px"
                  :format="year_format"
                ></el-progress>
                <el-card class="graph-panel panel">
                  <el-tooltip
                    class="item"
                    effect="light"
                    :content="$t('resultPage').showLabels"
                    placement="bottom"
                    style="width: 30px"
                  >
                    <i
                      class="graph-icon el-icon-info"
                      @click="refreshGraph_high_degree"
                      style="
                        display: inline-flex;
                        flex-direction: column;
                        align-items: center;
                        font-size: 18px;
                        cursor: pointer;
                      "
                      ><span style="font-size: 10px; margin-top: 2px">
                        {{ $t("resultPage").info }}</span
                      ></i
                    >
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="light"
                    :content="$t('resultPage').refreshGraph"
                    placement="bottom"
                    style="width: 30px"
                  >
                    <i
                      class="graph-icon el-icon-refresh"
                      @click="refreshGraph_noText"
                      style="
                        display: inline-flex;
                        flex-direction: column;
                        align-items: center;
                        font-size: 18px;
                        cursor: pointer;
                      "
                      ><span style="font-size: 10px; margin-top: 2px">
                        {{ $t("resultPage").refresh }}</span
                      ></i
                    >
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    :content="$t('resultPage').openCloseFisheye"
                    effect="light"
                    placement="bottom"
                    style="width: 30px"
                  >
                    <i
                      class="graph-icon el-icon-search"
                      @click="operate_fisheye"
                      style="
                        display: inline-flex;
                        flex-direction: column;
                        align-items: center;
                        font-size: 18px;
                        cursor: pointer;
                      "
                      ><span style="font-size: 10px; margin-top: 2px">
                        {{ $t("resultPage").fisheye }}</span
                      ></i
                    >
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="light"
                    :content="$t('resultPage').showInitialGraph"
                    placement="bottom"
                    style="width: 30px"
                  >
                    <i
                      class="graph-icon el-icon-time"
                      @click="ancient_graph"
                      style="
                        display: inline-flex;
                        flex-direction: column;
                        align-items: center;
                        font-size: 18px;
                        cursor: pointer;
                      "
                      ><span style="font-size: 10px; margin-top: 2px">
                        {{ $t("resultPage").initial }}</span
                      ></i
                    >
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="light"
                    :content="$t('resultPage').playNetworkEvolution"
                    placement="bottom"
                    style="width: 30px"
                  >
                    <i
                      class="graph-icon el-icon-video-play"
                      @click="year_animate"
                      style="
                        display: inline-flex;
                        flex-direction: column;
                        align-items: center;
                        font-size: 18px;
                        cursor: pointer;
                      "
                      ><span style="font-size: 10px; margin-top: 2px">
                        {{ $t("resultPage").evolution }}</span
                      ></i
                    >
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="light"
                    :content="$t('resultPage').showConceptFlow"
                    placement="bottom"
                    style="width: 30px"
                  >
                    <i
                      class="graph-icon el-icon-grape"
                      @click="showTreeDiagram"
                      style="
                        display: inline-flex;
                        flex-direction: column;
                        align-items: center;
                        font-size: 18px;
                        cursor: pointer;
                      "
                      ><span style="font-size: 10px; margin-top: 2px">
                        {{ $t("resultPage").tree }}</span
                      ></i
                    >
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="light"
                    :content="$t('resultPage').downloadGraphImage"
                    placement="bottom"
                    style="width: 30px"
                  >
                    <i
                      class="graph-icon el-icon-picture-outline"
                      @click="download_graph_image"
                      style="
                        display: inline-flex;
                        flex-direction: column;
                        align-items: center;
                        font-size: 18px;
                        cursor: pointer;
                      "
                      ><span style="font-size: 10px; margin-top: 2px">
                        {{ $t("resultPage").image }}</span
                      ></i
                    >
                  </el-tooltip>
                  <el-dropdown style="width: 30px" @command="changeLayout">
                    <i
                      class="graph-icon el-icon-magic-stick"
                      style="
                        display: inline-flex;
                        flex-direction: column;
                        align-items: center;
                        font-size: 18px;
                        padding-right: 1px;
                        cursor: pointer;
                      "
                      ><span style="font-size: 10px; margin-top: 2px">
                        {{ $t("resultPage").layout }}</span
                      ></i
                    >
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="circular">{{
                        $t("resultPage").circularLayout
                      }}</el-dropdown-item>
                      <el-dropdown-item command="concentric">{{
                        $t("resultPage").concentricLayout
                      }}</el-dropdown-item>
                      <el-dropdown-item command="grid">{{
                        $t("resultPage").gridLayout
                      }}</el-dropdown-item>
                      <el-dropdown-item command="force">{{
                        $t("resultPage").forceLayout
                      }}</el-dropdown-item>
                      <el-dropdown-item command="radial">{{
                        $t("resultPage").radialLayout
                      }}</el-dropdown-item>
                      <el-dropdown-item command="mds">{{
                        $t("resultPage").mdsLayout
                      }}</el-dropdown-item>
                      <el-dropdown-item command="fruchterman">{{
                        $t("resultPage").fruchtermanLayout
                      }}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-card>
              </section>
            </el-tooltip>
            <section class="layout-right">
              <el-card class="button-panel panel">
                <el-tooltip
                  class="item"
                  effect="light"
                  :content="$t('resultPage').networkAnalysisTooltip"
                  placement="top"
                  :manual="true"
                  v-model="tooltip_visible"
                  :disabled="tooltip_disable"
                >
                  <h2 class="title" style="margin-top: -5px">
                    <i
                      class="el-icon-data-analysis"
                      style="margin-right: 5px"
                    ></i
                    >{{ $t("search").analysis }}
                  </h2>
                </el-tooltip>
                <div style="height: calc(100% - 54px); margin-top: -7px">
                  <div
                    style="
                      display: grid;
                      grid-template-columns: 1fr 1fr;
                      gap: 5px;
                      margin: 25px 0 20px 0;
                    "
                  >
                    <div style="width: 100%">
                      <el-popover placement="right" width="400" trigger="click">
                        <div class="btn-group">
                          <el-button
                            v-for="(item, index) in btnList"
                            :key="index"
                            :class="[
                              classMap[item.color],
                              activeColor === item.color ? 'active-btn' : '',
                            ]"
                            style="
                              font-size: 14px;
                              padding: 5px;
                              margin: 5px;
                              border-radius: 5px;
                              cursor: pointer;
                            "
                            @click="handleSelectColor(item)"
                            v-show="item.type > 0"
                            >{{ item.type }} nodes - {{ item.text }}
                          </el-button>
                        </div>
                        <el-button
                          class="ana-button"
                          type="primary"
                          size="small"
                          plain
                          slot="reference"
                          @click="anaCommunity"
                          ><i
                            class="el-icon-orange"
                            style="margin-right: 10px"
                          ></i
                          >{{ $t("search").communityA }}</el-button
                        >
                      </el-popover>
                    </div>

                    <el-button
                      class="ana-button"
                      type="primary"
                      size="small"
                      plain
                      @click="anaNodes"
                      ><i
                        class="el-icon-data-analysis"
                        style="margin-right: 10px"
                      ></i
                      >{{ $t("search").conceptA }}</el-button
                    >
                    <el-button
                      class="ana-button"
                      type="primary"
                      size="small"
                      plain
                      @click="anaEdges"
                      ><i
                        class="el-icon-pie-chart"
                        style="margin-right: 10px"
                      ></i
                      >{{ $t("search").connectionA }}</el-button
                    >
                    <el-button
                      class="ana-button"
                      type="primary"
                      size="small"
                      plain
                      @click="anaCountry"
                      ><i class="el-icon-place" style="margin-right: 10px"></i
                      >{{ $t("search").countryA }}</el-button
                    >
                  </div>

                  <el-carousel
                    arrow="never"
                    ref="carousel"
                    :autoplay="false"
                    height="65vh"
                    style="
                      background-color: rgba(255, 255, 255, 0);
                      backdrop-filter: blur(8px);
                      -webkit-backdrop-filter: blur(8px);
                      color: #606266;
                      border-radius: 4px; /* 可选：加圆角优化视觉 */
                    "
                    indicator-position="none"
                  >
                    <el-carousel-item style="background-color: #ffffff">
                      <template>
                        <el-table
                          :data="
                            graph_data.nodes.filter(
                              (data) => data.style.fill !== '#ECF6FF'
                            )
                          "
                          style="padding: 0; font-size: 10px"
                          stripe
                          :default-sort="{
                            prop: 'degree',
                            order: 'descending',
                          }"
                          height="100%"
                          size="small"
                        >
                          <el-table-column
                            :label="$t('resultPage').node"
                            width="78"
                          >
                            <template slot-scope="scope">
                              <span
                                style="
                                  cursor: pointer;
                                  font-weight: bolder;
                                  margin-right: -20px;
                                  padding-right: 0;
                                "
                                @click="handleTableNodeClick(scope.row)"
                                >{{ scope.row.name }}</span
                              >
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="degree"
                            align="center"
                            :label="$t('resultPage').degree"
                            sortable
                            width="70"
                          >
                          </el-table-column>
                          <el-table-column
                            :label="$t('resultPage').centrality"
                            align="center"
                            width="50"
                          >
                            <template slot-scope="scope">
                              {{
                                scope.row.degree_centrality
                                  .toString()
                                  .slice(0, 5)
                              }}
                            </template>
                          </el-table-column>
                          <el-table-column
                            :label="$t('resultPage').betweenness"
                            align="center"
                            width="50"
                          >
                            <template slot-scope="scope">
                              {{ scope.row.betweenness.toString().slice(0, 5) }}
                            </template>
                          </el-table-column>
                          <el-table-column
                            :label="$t('resultPage').cluster"
                            align="center"
                            width="55"
                          >
                            <template slot-scope="scope">
                              {{ scope.row.clustering.toString().slice(0, 5) }}
                            </template>
                          </el-table-column>

                          <el-table-column
                            :label="$t('resultPage').group"
                            width="50"
                          >
                            <template slot-scope="scope">
                              <span
                                :style="{
                                  'background-color': scope.row.type,
                                  width: '20px',
                                  color: scope.row.type,
                                }"
                                >XX</span
                              >
                            </template>
                          </el-table-column>
                        </el-table>
                      </template>
                    </el-carousel-item>
                    <el-carousel-item style="background-color: #ffffff">
                      <template>
                        <el-table
                          :data="graph_data.edges"
                          style="padding: 0; font-size: 10px"
                          stripe
                          :default-sort="{ prop: 'year', order: 'descending' }"
                          height="100%"
                          size="small"
                        >
                          <el-table-column
                            :label="$t('resultPage').source"
                            width="100"
                          >
                            <template slot-scope="scope">
                              <span
                                style="
                                  cursor: pointer;
                                  font-weight: bolder;
                                  margin-right: -20px;
                                  padding-right: 0;
                                "
                                @click="handleTableRelClick(scope.row)"
                                >{{ scope.row.source_name }}</span
                              >
                            </template>
                          </el-table-column>

                          <el-table-column
                            :label="$t('resultPage').target"
                            width="100"
                          >
                            <template slot-scope="scope">
                              <span
                                style="
                                  cursor: pointer;
                                  font-weight: bolder;
                                  margin-right: -20px;
                                  padding-right: 0;
                                "
                                @click="handleTableRelClick(scope.row)"
                                >{{ scope.row.target_name }}</span
                              >
                            </template>
                          </el-table-column>

                          <el-table-column
                            :label="$t('resultPage').weight"
                            sortable
                            width="80"
                          >
                            <template slot-scope="scope">
                              {{ scope.row.weight.toString().slice(0, 5) }}
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="year"
                            :label="$t('resultPage').year"
                            sortable
                            width="70"
                          >
                          </el-table-column>
                        </el-table>
                      </template>
                    </el-carousel-item>
                    <el-carousel-item style="background-color: transparent">
                      <!-- 清除原背景，加内边距 -->
                      <div class="carousel-page">
                        <!-- 优化图表容器：半透明背景，避免图表遮挡磨砂 -->
                        <div
                          style="height: 20vh; margin-bottom: -50px"
                          id="analysis-bar-year"
                        >
                          <!-- ECharts图表需同步设置 backgroundColor: 'transparent'（在图表option中） -->
                        </div>
                        <el-divider
                          style="background-color: rgba(96, 98, 102, 0.2)"
                        ></el-divider>
                        <!-- 分割线半透明 -->
                        <div
                          style="height: 20vh; margin: -10px 0 0 0"
                          id="analysis-bar-concept-paper"
                        ></div>
                        <el-divider
                          style="background-color: rgba(96, 98, 102, 0.2)"
                        ></el-divider>
                        <div
                          style="height: 20vh; margin-top: -10px"
                          id="analysis-pie-concept"
                        ></div>
                      </div>
                    </el-carousel-item>
                    <el-carousel-item style="background-color: transparent">
                      <!-- 清除原背景，加内边距 -->
                      <div class="carousel-page">
                        <div
                          style="
                            height: 35vh;
                            margin-bottom: -5vh;
                            padding-bottom: -10px;
                          "
                          id="analysis-bar-country"
                        ></div>
                        <el-table
                          :data="instit_stats_ls"
                          max-height="350"
                          style="margin-top: -10px; font-size: 10px"
                          size="small"
                          stripe
                          :default-sort="{ prop: 'count', order: 'descending' }"
                          :header-row-style="{ height: '18px' }"
                          :row-style="{
                            color: isDarkMode ? '#e0e0e0' : '#333333',
                          }"
                        >
                          <el-table-column
                            :label="$t('resultPage').institution"
                            width="210"
                          >
                            <template slot-scope="scope">
                              <span
                                style="
                                  cursor: pointer;
                                  font-weight: bolder;
                                  margin-right: -20px;
                                  padding-right: 0;
                                "
                                ><a
                                  :href="scope.row.url"
                                  target="_blank"
                                  :style="{
                                    textDecoration: 'none',
                                    color: isDarkMode ? '#90caf9' : '#606266',
                                  }"
                                  >{{ scope.row.instit }}</a
                                ></span
                              >
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="country"
                            :label="$t('resultPage').country"
                            width="65"
                          >
                            <template slot-scope="scope">
                              <span v-html="scope.row.country"></span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="count"
                            :label="$t('resultPage').count"
                            sortable
                            width="75"
                          >
                            <template slot-scope="scope">
                              {{ scope.row.count }}
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </el-card>

              <el-card class="discovery-panel panel">
                <el-tooltip
                  class="item"
                  effect="light"
                  :content="$t('resultPage').networkAnalysisTooltip"
                  :manual="true"
                  v-model="tooltip_visible"
                  :disabled="tooltip_disable"
                  placement="bottom-end"
                >
                  <div slot="content">
                    {{ $t("resultPage").knowledgeConclusionTooltip }}
                  </div>
                  <h2 class="title">
                    <i class="el-icon-notebook-2" style="margin-right: 5px"></i>
                    {{ $t("search").conclusion }}
                    <i
                      v-clipboard:copy="conclusion_text"
                      class="iconfont el-icon-document-copy"
                      @click="copyResponse"
                      style="
                        float: right;
                        cursor: pointer;
                        transition: transform 0.2s;
                      "
                      :style="{
                        transform:
                          hoveredCopyIcon === 'conclusion'
                            ? 'scale(1.2)'
                            : 'scale(1)',
                      }"
                      @mouseenter="hoveredCopyIcon = 'conclusion'"
                      @mouseleave="hoveredCopyIcon = null"
                    ></i>
                  </h2>
                </el-tooltip>
                <el-progress
                  :show-text="true"
                  :percentage="confidence"
                  :format="showPercentage"
                  style="margin: -5px 0 5px 10px; font-size: 10px"
                  :color="progressObj.color"
                ></el-progress>

                <Mindmap
                  ref="mindmapRef"
                  :content="mindmapContent"
                  @open-fullscreen="openMindmapFullscreen"
                  v-loading="mindmapLoading"
                  v-if="shouldShowMindmap"
                  style="height: 280px; min-height: 200px; max-height: 350px"
                />
                <VuePerfectScrollbar
                  :style="{
                    height: shouldShowMindmap
                      ? 'calc(100% - 330px)'
                      : 'calc(100% - 80px)',
                    borderRadius: '10px',
                  }"
                  v-loading="this.conclusion_text === ''"
                >
                  <article class="conclusion_sec" id="conclusion_sec">
                    {{ displayConclusion }}
                  </article>
                </VuePerfectScrollbar>
              </el-card>
            </section>
          </section>

          <section class="paper-content-section" v-if="infoList.length">
            <!-- 高引用论文部分 - 并排卡片形式 -->
            <div v-if="highCitePapers.length > 0" style="margin-bottom: 15px">
              <div class="high-cite-papers-container">
                <el-card
                  class="box-card high-cite-card"
                  :id="`highcite${index}`"
                  v-for="(item, index) in highCitePapers"
                  :key="index"
                  style="padding: 0px 10px"
                >
                  <div slot="header" class="clearfix">
                    <h3
                      class="title hover-underline"
                      @click="redirectPaper(item)"
                      style="font-size: 14px"
                    >
                      <i
                        class="el-icon-star-on"
                        style="color: #ff9800; margin-right: 5px"
                      ></i>
                      {{ item.title }}
                    </h3>
                    <p>
                      <span class="author_prefix" style="font-size: 12px">
                        <i
                          class="el-icon-user"
                          style="color: #2f44ff"
                        ></i></span
                      ><span
                        class="author"
                        v-if="item.author && item.author.length"
                        style="font-size: 12px"
                      >
                        {{
                          item.author.length > 5
                            ? item.author.slice(0, 5).join(", ") + ", et al."
                            : item.author.join(", ")
                        }}
                      </span>
                    </p>
                    <span
                      class="year"
                      v-show="item.journal"
                      style="font-size: 12px"
                    >
                      <i class="el-icon-notebook-2"></i>{{ " " + item.journal }}
                    </span>
                    <span
                      class="year"
                      v-if="item.field && item.field.length"
                      style="font-size: 12px"
                    >
                      <i class="el-icon-aim"></i
                      >{{ " " + item.field.slice(0, 3).join(", ") }}
                    </span>
                    <span class="year" style="font-size: 12px">
                      <i class="el-icon-date"></i> {{ " " + item.year }}
                    </span>
                    <span class="year" style="font-size: 12px">
                      <i class="el-icon-link"></i>{{ " " + item.citations }}
                    </span>
                  </div>
                  <p
                    class="content"
                    :id="item.paperID.toString()"
                    style="
                      color: #606266;
                      font-size: 12px;
                      height: 100px;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      display: -webkit-box;
                      -webkit-line-clamp: 5;
                      -webkit-box-orient: vertical;
                    "
                  >
                    {{ item.abstract.slice(0, 200) + " ..." }}
                  </p>
                  <div
                    v-if="getPaperDatasets(item).length > 0"
                    class="paper-datasets"
                    style="
                      margin-top: 10px;
                      padding-top: 10px;
                      border-top: 1px dashed #e4e7ed;
                    "
                  >
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        margin-bottom: 6px;
                      "
                    >
                      <i
                        class="el-icon-coin"
                        style="
                          color: #67c23a;
                          margin-right: 5px;
                          font-size: 14px;
                        "
                      ></i>
                      <span
                        style="
                          font-size: 12px;
                          color: #606266;
                          font-weight: 500;
                        "
                        >Datasets ({{ getPaperDatasets(item).length }})</span
                      >
                    </div>
                    <div
                      v-for="(dataset, dIndex) in getPaperDatasets(item)"
                      :key="dIndex"
                      style="margin-bottom: 4px"
                    >
                      <a
                        :href="dataset.url"
                        target="_blank"
                        style="
                          font-size: 11px;
                          color: #409eff;
                          text-decoration: none;
                        "
                        >{{ dataset.title }}</a
                      >
                    </div>
                  </div>
                </el-card>
              </div>
            </div>

            <!-- 普通论文部分 -->
            <div v-if="normalPapers.length > 0" style="margin-top: 15px">
              <div
                class="normal-papers-header liquid-glass"
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  margin-bottom: 15px;
                  padding: 15px 20px;
                "
              >
                <h3 style="margin: 0; color: #303133; font-weight: 600">
                  <i
                    class="el-icon-document"
                    style="margin-right: 8px; color: #409eff"
                  ></i>
                  {{ $t("resultPage").relatedPapers }}
                </h3>
                <div
                  class="sort-controls"
                  style="display: flex; align-items: center; gap: 10px"
                >
                  <span style="color: #606266; font-size: 14px">{{
                    $t("resultPage").sortBy
                  }}</span>
                  <el-select
                    v-model="normalPapersSortBy"
                    :placeholder="$t('resultPage').selectSortMethod"
                    style="width: 180px"
                    size="small"
                  >
                    <el-option
                      :label="$t('resultPage').defaultOrder"
                      value="default"
                    >
                      <span style="float: left"
                        >📋 {{ $t("resultPage").defaultOrder }}</span
                      >
                    </el-option>
                    <el-option
                      :label="$t('resultPage').yearNewestFirst"
                      value="year_desc"
                    >
                      <span style="float: left"
                        >📅 {{ $t("resultPage").yearNewestFirst }}</span
                      >
                    </el-option>
                    <el-option
                      :label="$t('resultPage').yearOldestFirst"
                      value="year_asc"
                    >
                      <span style="float: left"
                        >📅 {{ $t("resultPage").yearOldestFirst }}</span
                      >
                    </el-option>
                    <el-option
                      :label="$t('resultPage').citationsHighToLow"
                      value="citations_desc"
                    >
                      <span style="float: left"
                        >⭐ {{ $t("resultPage").citationsHighToLow }}</span
                      >
                    </el-option>
                    <el-option
                      :label="$t('resultPage').citationsLowToHigh"
                      value="citations_asc"
                    >
                      <span style="float: left"
                        >⭐ {{ $t("resultPage").citationsLowToHigh }}</span
                      >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <el-card
                class="box-card"
                :id="`link${index}`"
                v-for="(item, index) in normalPapers"
                :key="index"
                style="margin-bottom: 20px; padding: 0px 10px"
              >
                <div slot="header" class="clearfix">
                  <h3
                    class="title hover-underline"
                    @click="redirectPaper(item)"
                  >
                    <i
                      v-if="item.high_cite"
                      class="el-icon-star-on"
                      style="color: #ff9800; margin-right: 5px"
                    ></i>
                    {{ item.title }}
                  </h3>
                  <p>
                    <span class="author_prefix"
                      ><i class="el-icon-user" style="color: #2f44ff"></i></span
                    ><span
                      class="author"
                      v-if="item.author && item.author.length"
                    >
                      {{ item.author.join(", ") }}
                    </span>
                  </p>
                  <span class="year" v-show="item.journal"
                    ><i class="el-icon-notebook-2"></i
                    >{{ " " + item.journal }}</span
                  >
                  <span class="year" v-if="item.field && item.field.length">
                    <i class="el-icon-aim"></i
                    >{{ " " + item.field.slice(0, 3).join(", ") }}
                  </span>
                  <span class="year"
                    ><i class="el-icon-date"></i> {{ " " + item.year }}</span
                  >
                  <span class="year"
                    ><i class="el-icon-link"></i
                    >{{ " " + item.citations }}</span
                  >
                </div>
                <p
                  class="content"
                  :id="item.paperID.toString()"
                  style="color: #606266; font-size: small"
                >
                  {{ item.abstract.slice(0, 800) + " ..." }}
                </p>
                <div
                  v-if="getPaperDatasets(item).length > 0"
                  class="paper-datasets"
                  style="
                    margin-top: 12px;
                    padding-top: 12px;
                    border-top: 1px dashed #e4e7ed;
                  "
                >
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      margin-bottom: 8px;
                    "
                  >
                    <i
                      class="el-icon-coin"
                      style="color: #67c23a; margin-right: 6px; font-size: 15px"
                    ></i>
                    <span
                      style="font-size: 13px; color: #606266; font-weight: 500"
                      >Datasets ({{ getPaperDatasets(item).length }})</span
                    >
                  </div>
                  <div
                    v-for="(dataset, dIndex) in getPaperDatasets(item)"
                    :key="dIndex"
                    style="margin-bottom: 6px"
                  >
                    <a
                      :href="dataset.url"
                      target="_blank"
                      style="
                        font-size: 12px;
                        color: #409eff;
                        text-decoration: none;
                      "
                      >{{ dataset.title }}</a
                    >
                    <p
                      v-if="dataset.desc"
                      style="
                        font-size: 11px;
                        color: #909399;
                        margin: 2px 0 0 0;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                      "
                    >
                      {{ dataset.desc }}
                    </p>
                  </div>
                </div>
              </el-card>
            </div>
          </section>
        </div>
      </el-main>
    </el-container>

    <el-dialog
      :title="$t('resultPage').knowledgeDiscovery"
      :visible.sync="showKnowledgeDialog"
      @close="closeKnowledgeDiagram"
      width="80%"
    >
      <!-- 自定义绘图 -->
      <div class="canvas-content">
        <div class="left" v-if="showAll">
          <div class="box">
            {{
              this.currentSourceContent ||
              "Prompt of the 1st concept (optional)"
            }}
          </div>
          <div class="box">
            {{
              this.currentTargetContent ||
              "Prompt of the 2nd concept (optional)"
            }}
          </div>
        </div>
        <div class="line" v-if="showAll">
          <div class="item">
            <div class="hr">
              <svg
                t="1699251686274"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="17635"
                width="200"
                height="200"
              >
                <path
                  d="M747.752 278.368l0.557 0.551 204.1 207.13 0.109 0.112a29.965 29.965 0 0 1 0.339 0.352l0.105 0.113 0.135 0.145a29.784 29.784 0 0 1 5.837 9.3A29.716 29.716 0 0 1 961 507v0.122l-0.002 0.224L961 507a30.417 30.417 0 0 1-0.01 0.799 29.72 29.72 0 0 1-2.102 10.249l-0.049 0.12a29.64 29.64 0 0 1-0.886 1.985l-0.005 0.01a29.756 29.756 0 0 1-5.539 7.787l-204.1 207.13-0.557 0.552c-11.629 11.209-30.153 11.176-41.74-0.211-11.775-11.57-11.927-30.482-0.34-42.24l154.023-156.312H95.91C79.39 536.87 66 523.496 66 507c0-16.26 13.011-29.487 29.204-29.861l0.706-0.008 763.785-0.001-154.024-156.31c-11.586-11.759-11.434-30.67 0.34-42.24 11.588-11.388 30.112-11.42 41.74-0.212z"
                  fill="#515151"
                  p-id="17636"
                ></path>
              </svg>
            </div>
          </div>
          <div class="item">
            <div class="hr">
              <svg
                t="1699251686274"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="17635"
                width="200"
                height="200"
              >
                <path
                  d="M747.752 278.368l0.557 0.551 204.1 207.13 0.109 0.112a29.965 29.965 0 0 1 0.339 0.352l0.105 0.113 0.135 0.145a29.784 29.784 0 0 1 5.837 9.3A29.716 29.716 0 0 1 961 507v0.122l-0.002 0.224L961 507a30.417 30.417 0 0 1-0.01 0.799 29.72 29.72 0 0 1-2.102 10.249l-0.049 0.12a29.64 29.64 0 0 1-0.886 1.985l-0.005 0.01a29.756 29.756 0 0 1-5.539 7.787l-204.1 207.13-0.557 0.552c-11.629 11.209-30.153 11.176-41.74-0.211-11.775-11.57-11.927-30.482-0.34-42.24l154.023-156.312H95.91C79.39 536.87 66 523.496 66 507c0-16.26 13.011-29.487 29.204-29.861l0.706-0.008 763.785-0.001-154.024-156.31c-11.586-11.759-11.434-30.67 0.34-42.24 11.588-11.388 30.112-11.42 41.74-0.212z"
                  fill="#515151"
                  p-id="17636"
                ></path>
              </svg>
            </div>
          </div>
        </div>
        <div class="center">
          <div class="key">
            <span>{{ this.currentSourceName || "Keyword1" }}</span>
          </div>
          <div class="key">
            <span>{{ this.currentTargetName || "Keyword2" }}</span>
          </div>
        </div>
        <div class="line" :style="{ width: showAll ? '5%' : '20%' }">
          <div class="item">
            <div class="hr">
              <svg
                t="1699251686274"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="17635"
                width="200"
                height="200"
              >
                <path
                  d="M747.752 278.368l0.557 0.551 204.1 207.13 0.109 0.112a29.965 29.965 0 0 1 0.339 0.352l0.105 0.113 0.135 0.145a29.784 29.784 0 0 1 5.837 9.3A29.716 29.716 0 0 1 961 507v0.122l-0.002 0.224L961 507a30.417 30.417 0 0 1-0.01 0.799 29.72 29.72 0 0 1-2.102 10.249l-0.049 0.12a29.64 29.64 0 0 1-0.886 1.985l-0.005 0.01a29.756 29.756 0 0 1-5.539 7.787l-204.1 207.13-0.557 0.552c-11.629 11.209-30.153 11.176-41.74-0.211-11.775-11.57-11.927-30.482-0.34-42.24l154.023-156.312H95.91C79.39 536.87 66 523.496 66 507c0-16.26 13.011-29.487 29.204-29.861l0.706-0.008 763.785-0.001-154.024-156.31c-11.586-11.759-11.434-30.67 0.34-42.24 11.588-11.388 30.112-11.42 41.74-0.212z"
                  fill="#515151"
                  p-id="17636"
                ></path>
              </svg>
            </div>
          </div>
          <div class="item">
            <div class="hr">
              <svg
                t="1699251686274"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="17635"
                width="200"
                height="200"
              >
                <path
                  d="M747.752 278.368l0.557 0.551 204.1 207.13 0.109 0.112a29.965 29.965 0 0 1 0.339 0.352l0.105 0.113 0.135 0.145a29.784 29.784 0 0 1 5.837 9.3A29.716 29.716 0 0 1 961 507v0.122l-0.002 0.224L961 507a30.417 30.417 0 0 1-0.01 0.799 29.72 29.72 0 0 1-2.102 10.249l-0.049 0.12a29.64 29.64 0 0 1-0.886 1.985l-0.005 0.01a29.756 29.756 0 0 1-5.539 7.787l-204.1 207.13-0.557 0.552c-11.629 11.209-30.153 11.176-41.74-0.211-11.775-11.57-11.927-30.482-0.34-42.24l154.023-156.312H95.91C79.39 536.87 66 523.496 66 507c0-16.26 13.011-29.487 29.204-29.861l0.706-0.008 763.785-0.001-154.024-156.31c-11.586-11.759-11.434-30.67 0.34-42.24 11.588-11.388 30.112-11.42 41.74-0.212z"
                  fill="#515151"
                  p-id="17636"
                ></path>
              </svg>
            </div>
          </div>
        </div>
        <div class="right" ref="content">
          <div class="knowledgeText" v-html="displayKnowledge"></div>
        </div>
      </div>
      <div class="tool-list">
        <el-tooltip class="item" effect="dark" content="Copy" placement="top">
          <i
            v-clipboard:copy="knowledge_text"
            class="iconfont el-icon-document-copy"
            @click="copyResponse"
          ></i>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="Like" placement="top">
          <img
            :src="this.isAgree === 1 ? this.agree_fill : this.agree"
            width="24px"
            @click="giveEvaluate(1)"
          />
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          content="Dislike"
          placement="top"
        >
          <img
            :src="this.isAgree === 0 ? this.disagree_fill : this.disagree"
            width="24px"
            @click="giveEvaluate(0)"
          />
        </el-tooltip>
      </div>

      <el-divider></el-divider>
      <el-table
        :data="new_relation_table"
        stripe
        size="small"
        :show-header="false"
        @expand-change="handleDetail"
      >
        <el-table-column type="expand">
          <template slot-scope="scope">
            <el-form label-position="right" inline class="demo-table-expand">
              <el-row>
                <el-col :span="12"
                  ><el-form-item>
                    <el-table
                      ref="sourceKnowledgeTable"
                      :data="scope.row.source_sentences"
                      @current-change="
                        (val) =>
                          handleCurrentKnowledge(
                            'source',
                            val,
                            scope.row.source_name,
                            scope.$index,
                            scope.row
                          )
                      "
                      highlight-current-row
                      style="width: 100%"
                      :border="true"
                      height="450"
                    >
                      <el-table-column type="index"></el-table-column>
                      <el-table-column
                        :width="flexColumnWidth()"
                        :label="
                          $t('resultPage').promptsOf +
                          ' ' +
                          scope.row.source_name
                        "
                      >
                        <template slot-scope="scope">
                          <span style="font-size: 12px">{{
                            capitalized(scope.row)
                          }}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-form-item></el-col
                >
                <el-col :span="12"
                  ><el-form-item>
                    <el-table
                      ref="targetKnowledgeTable"
                      :data="scope.row.target_sentences"
                      @current-change="
                        (val) =>
                          handleCurrentKnowledge(
                            'target',
                            val,
                            scope.row.target_name,
                            scope.$index,
                            scope.row
                          )
                      "
                      :border="true"
                      highlight-current-row
                      style="width: 100%"
                      height="450"
                    >
                      <el-table-column type="index"> </el-table-column>
                      <el-table-column
                        :width="flexColumnWidth()"
                        :label="
                          $t('resultPage').promptsOf +
                          ' ' +
                          scope.row.target_name
                        "
                      >
                        <template slot-scope="scope">
                          <span style="font-size: 12px">{{
                            capitalized(scope.row)
                          }}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-form-item></el-col
                >
              </el-row>
            </el-form>
          </template>
        </el-table-column>

        <el-table-column :label="$t('resultPage').source">
          <template slot-scope="scope">
            <el-tag
              size="medium"
              style="
                background-color: rgba(198, 227, 255, 0.4);
                color: rgb(63 80 104);
                font-weight: 500;
                padding: 0 5px;
              "
              >{{ scope.row.source_name }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column :label="$t('resultPage').target">
          <template slot-scope="scope">
            <el-tag
              size="medium"
              style="
                background-color: rgba(198, 227, 255, 0.4);
                color: rgb(63 80 104);
                font-weight: 500;
                padding: 0 5px;
              "
            >
              {{ scope.row.target_name }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column :label="$t('resultPage').operation" width="100">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-thumb"
              style="cursor: pointer"
              v-show="new_relation_table_status[scope.$index] === 0"
              @click="handleNewRel(scope.$index, scope.row)"
              :disabled="
                knowledge_text === 'Generated Idea: Please wait a minute.'
              "
              >Idea</el-button
            >
            <i
              class="el-icon-loading"
              style="color: #4ab4ff; cursor: pointer"
              v-show="new_relation_table_status[scope.$index] === 1"
            ></i>
            <el-button
              type="success"
              size="mini"
              icon="el-icon-thumb"
              style="cursor: pointer"
              v-show="new_relation_table_status[scope.$index] === 2"
              @click="handleNewRel(scope.$index, scope.row)"
              :disabled="
                knowledge_text === 'Generated Idea: Please wait a minute.'
              "
              >Idea</el-button
            >
            <i
              class="el-icon-warning-outline"
              style="color: #ff2f2f; cursor: pointer"
              v-show="new_relation_table_status[scope.$index] === 3"
              @click="handleNewRel(scope.$index, scope.row)"
            ></i>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
      :title="$t('resultPage').feedback"
      :visible.sync="feedbackDialogVisible"
      width="30%"
      center
    >
      <div class="feedback-dialog-wrapper">
        <el-rate
          style="margin-bottom: 25px"
          v-model="feedbackRate"
          :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
        >
        </el-rate>
        <el-input
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 8 }"
          placeholder="Please enter your feedback"
          v-model="feedbackText"
        >
        </el-input>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="feedbackDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="submitFeedback">Submit</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="$t('resultPage').conceptFlow"
      :visible.sync="showSpanningTreeDialog"
      @close="closeTreeDiagram"
      width="60%"
    >
      <div class="dialog-buttons">
        <i
          class="el-icon-zoom-in"
          id="treeZoomIn"
          :title="$t('resultPage').zoomIn"
        ></i>
        <i
          class="el-icon-zoom-out"
          id="treeZoomOut"
          :title="$t('resultPage').zoomOut"
        ></i>
        <i
          class="el-icon-download"
          id="downloadTree"
          :title="$t('resultPage').downloadConceptFlow"
        ></i>
      </div>
      <div id="tree-map" style="width: 100%; height: 600px"></div>
    </el-dialog>
    <el-dialog
      :title="$t('resultPage').knowledgeMindmap"
      :visible.sync="showMindmapFullscreenDialog"
      @close="closeMindmapFullscreen"
      width="80%"
      class="mindmap-fullscreen-dialog"
    >
      <Mindmap
        :fullscreen="true"
        :content="mindmapContent"
        @close-fullscreen="closeMindmapFullscreen"
        v-loading="mindmapLoading"
        :element-loading-text="$t('resultPage').generatingMindmap"
        v-if="shouldShowMindmap || mindmapLoading"
      />
    </el-dialog>

    <el-dialog
      :title="currentTopicDetail.title"
      :visible.sync="showTopicDetailDialog"
      width="60%"
      :close-on-click-modal="true"
      class="topic-detail-dialog"
    >
      <div class="topic-detail-content">
        <div v-if="currentTopicDetail.content" class="content-text">
          {{ currentTopicDetail.content }}
        </div>
        <div v-else class="content-loading">
          <el-skeleton :rows="8" animated />
        </div>
        <div
          v-if="
            currentTopicDetail.datasetsLoading ||
            currentTopicDetail.datasetsLoaded ||
            currentTopicDetail.datasets.length
          "
          class="topic-dialog-datasets"
        >
          <div class="dataset-section-title">
            <i class="el-icon-coin"></i>
            Recommended Datasets
          </div>
          <div
            v-if="currentTopicDetail.datasetsLoading"
            class="dataset-loading"
          >
            <i class="el-icon-loading"></i>
            Searching CNS datasets...
          </div>
          <div
            v-else-if="currentTopicDetail.datasets.length"
            class="dataset-list"
          >
            <a
              v-for="dataset in currentTopicDetail.datasets"
              :key="dataset.key"
              :href="dataset.url"
              target="_blank"
              class="dataset-card-link"
            >
              <span class="dataset-card-title">{{ dataset.title }}</span>
              <span v-if="dataset.desc" class="dataset-card-desc">
                {{ dataset.desc }}
              </span>
            </a>
          </div>
          <div v-else class="dataset-loading">No matched CNS datasets.</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-tooltip content="Copy Content" placement="top">
          <el-button
            v-if="currentTopicDetail.content"
            type="primary"
            circle
            size="small"
            v-clipboard:copy="
              currentTopicDetail.title + ':\n\n\n' + currentTopicDetail.content
            "
            @click="copyResponse"
          >
            <i class="el-icon-document-copy"></i>
          </el-button>
        </el-tooltip>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import G6 from "@antv/g6";
import * as echarts from "echarts";
import {
  downloadFile,
  feedback,
  getConclusion,
  getEvaluate,
  getGPT,
  getHintList,
  getKnowledge,
  getPaperDatasets,
  getReport,
  giveEvaluate,
  searchCnsDatasets,
} from "@/api/api.js";
import Vue from "vue";
import Mindmap from "@/components/Mindmap.vue";

import img_quintuple from "@/assets/quintuple.png";
import img_acemap from "@/assets/acemap.png";
import img_deepreport from "@/assets/deepreport.png";
import agree from "@/assets/agree.svg";
import disagree from "@/assets/disagree.svg";
import agree_fill from "@/assets/agree_fill.svg";
import disagree_fill from "@/assets/disagree_fill.svg";
import countryEmojis from "@/static/countryEmojis.json";
import PDFGenerator from "@/utils/pdfGenerator.js";
import { translateBatch } from "@/utils/baiduTranslate.js";

export default {
  name: "DashboardAdmin",
  data() {
    return {
      feedbackSubmitting: false,
      feedbackDialogVisible: false,
      feedbackRate: null,
      feedbackText: "",
      lowAuth: true,
      keywords: "",
      date: "",
      placeholder: "vaccine",
      userInputQuery: "",
      pathList: [],
      text: "",
      hoveredCopyIcon: null,
      currentPath: null,
      lastNode: null,
      loading: false,
      textLoading: false,
      mindmapContent: "",
      mindmapLoading: true,
      // G6图形相关变量
      // links: [],
      graph: null,
      links: {},
      graphTooltip: null,
      //G2Chart相关变量
      year_freq: [],
      // paper_ls 变量
      infoList: [],
      linkList: [
        "vaccine",
        "lockdown",
        "mental health",
        "women",
        "population",
        "suicide",
      ],
      activeColor: "",
      classMap: {
        "#065758": "c-065758",
        "#25767B": "c-25767B",
        "#44949E": "c-44949E",
        "#62B3C1": "c-62B3C1",
        "#81D2E4": "c-81D2E4",
        "#BCEDD8": "c-BCEDD8",
      },
      btnList: [
        { type: 0, color: "#065758", text: "", maxDegree: 0 },
        { type: 0, color: "#25767B", text: "", maxDegree: 0 },
        { type: 0, color: "#44949E", text: "", maxDegree: 0 },
        { type: 0, color: "#62B3C1", text: "", maxDegree: 0 },
        { type: 0, color: "#81D2E4", text: "", maxDegree: 0 },
        { type: 0, color: "#BCEDD8", text: "", maxDegree: 0 },
      ],
      conclusion_text: "",
      knowledge_text: "",
      translatedConclusion: "",
      translatedKnowledge: "",
      topics_ls: [""],
      translatedTopics: [],
      isTranslating: false,
      isTranslatingKnowledge: false,
      isTranslatingConclusion: false,
      currentSourceKnowledge: ".",
      currentTargetKnowledge: ".",
      currentTargetName: "",
      currentSourceName: "",
      currentSourceContent: "",
      currentTargetContent: "",
      currentConcepts: "",
      isAgree: -1,
      currentRow: {
        index: -1,
        row: {},
      },
      confidence: 80,
      graph_data: { nodes: [], links: [] },
      new_relation_table: [],
      new_relation_table_status: [],
      activeIndex: -1,
      fieldList: [],
      percentage: 0,
      year_percentage: 0,
      show_year_percentage: false,
      timer: null,
      gpt_response_noused: "",
      topic_gpt_detail: {},
      hint_ls: [
        { value: "the capacity of wireless networks" },
        { value: "fairness of vaccine distribution" },
        { value: "Carbonate Rock" },
        { value: "Chinese Culture" },
        { value: "COVID-19 pandemic" },
        { value: "Artificial Intelligence" },
        { value: "Mental Health" },
        { value: "Donald Trump" },
        { value: "Metaverse" },
        { value: "AlphaFold" },
        { value: "Large Language Model" },
      ],
      sensitiveWords: ["jinping xi", "xi jinping", "chinese navy"],
      showSpanningTreeDialog: false,
      showKnowledgeDialog: false,
      showMindmapFullscreenDialog: false,
      showTopicDetailDialog: false,
      selectedEdge: {},
      selectedEdge_name: {},
      currentTopicDetail: {
        title: "",
        content: "",
        datasets: [],
        datasetsLoading: false,
        datasetsLoaded: false,
      },
      open_fisheye: false,
      chartOption: {},
      tooltip_visible: false,
      tooltip_disable: true,
      activeKnowledgePanel: ["3"],
      switchValue: 0,
      max_degree_node: {},
      fileLoading: false,
      country_stats: null,
      instit_stats_ls: [],
      instit_url: null,
      instit_country: null,
      field2country: null,
      field2instit: null,
      // img
      img_quintuple,
      img_acemap,
      img_deepreport,
      agree,
      disagree,
      agree_fill,
      disagree_fill,
      showAll: false,
      cloudInstance: null,
      labelsShown: false,
      // 普通论文排序相关
      normalPapersSortBy: "default",
      // 论文数据集信息
      paperDatasets: {},
      datasetsLoading: false,
      topicDatasets: {},
      topicDatasetsLoading: {},
      topicDatasetRequests: {},
      conceptDatasets: {},
      datasetRecommendationSize: 5,
    };
  },
  components: {
    // Map,
    // NetworkMap,
    VuePerfectScrollbar,
    // FisheyeMap,
    // BasicChart,
    Mindmap,
  },
  mounted() {
    this.keywords = this.$route.query.q || "";
    this.lowAuth = Vue.$cookies.get("userLevel") < 1;
    //this.initMap();
    //this.initCharts();
    this.searchReport();
    const { data: hint_ls } = getHintList();
    if (hint_ls) {
      this.hint_ls = hint_ls;
    }

    // 初始化时应用当前暗黑模式状态
    this.handleDarkModeChange(this.$store.state.darkMode);
  },

  beforeDestroy() {
    if (this.cloudInstance) {
      this.cloudInstance.destroy();
    }
    // 清理所有可能的资源
    if (this.graph) {
      this.graph.destroy();
    }
    if (this.treeGraph) {
      this.treeGraph.destroy();
    }
    if (this.timer) {
      clearInterval(this.timer);
    }
    // 移除所有事件监听器
    if (window.removeEventListener) {
      const chartInstances = [
        document.getElementById("analysis-bar-year"),
        document.getElementById("analysis-pie-concept"),
        document.getElementById("analysis-bar-concept-paper"),
        document.getElementById("analysis-bar-country"),
      ];
      chartInstances.forEach((el) => {
        if (el) {
          const chart = echarts.getInstanceByDom(el);
          if (chart) {
            chart.dispose();
          }
        }
      });
    }
  },

  methods: {
    // 处理暗黑模式变化
    handleDarkModeChange(isDarkMode) {
      // 获取所有图表实例并更新标题颜色
      const chartInstances = [
        echarts.getInstanceByDom(document.getElementById("analysis-bar-year")),
        echarts.getInstanceByDom(
          document.getElementById("analysis-pie-concept")
        ),
        echarts.getInstanceByDom(
          document.getElementById("analysis-bar-concept-paper")
        ),
        echarts.getInstanceByDom(
          document.getElementById("analysis-bar-country")
        ),
      ];

      chartInstances.forEach((chart) => {
        if (chart) {
          // 对于所有图表更新标题颜色
          chart.setOption({
            title: {
              textStyle: {
                color: isDarkMode ? "#90caf9" : "#333",
              },
            },
          });

          // 对于国家柱状图特殊处理
          if (chart.dom.id === "analysis-bar-country") {
            chart.setOption({
              xAxis: {
                axisLabel: {
                  color: isDarkMode ? "#e0e0e0" : "#333",
                },
                splitLine: {
                  lineStyle: {
                    color: isDarkMode ? "#444" : "#F5F7FA",
                  },
                },
              },
              yAxis: {
                axisLabel: {
                  color: isDarkMode ? "#e0e0e0" : "#333",
                },
              },
              series: [
                {
                  label: {
                    color: isDarkMode ? "#e0e0e0" : "#333",
                  },
                },
              ],
              graphic: [
                {
                  id: "year-watermark",
                  style: {
                    fill: config.textColor,
                    font: "bold 20px",
                  },
                },
                {
                  name: "replay-text",
                  style: {
                    color: isDarkMode ? "#e0e0e0" : "#333",
                  },
                },
              ],
            });
          }
        }
      });
    },
  },

  computed: {
    // 从Vuex store获取暗黑模式状态
    isDarkMode() {
      return this.$store.state.darkMode;
    },
    // 检查思维导图内容是否足够显示且格式正确
    shouldShowMindmap() {
      if (!this.mindmapContent || this.mindmapContent.trim() === "")
        return false;
      return true;
    },
    progressObj() {
      let progressObj = {
        color: "rgb(33, 150, 83)",
        class: "success",
      };
      if (this.confidence < 60) {
        progressObj = {
          color: "rgb(235, 87, 87)",
          class: "error",
        };
      } else if (this.confidence >= 60 && this.confidence < 80) {
        progressObj = {
          color: "rgb(242, 201, 76)",
          class: "warning",
        };
      } else {
        progressObj = {
          color: "rgb(33, 150, 83)",
          class: "success",
        };
      }
      return progressObj;
    },
    language() {
      return this.$store.state.language || "en";
    },
    displayTopics() {
      return this.$i18n.locale === "cn"
        ? this.translatedTopics
        : this.topics_ls;
    },
    displayConclusion() {
      return this.$i18n.locale === "cn"
        ? this.translatedConclusion
        : this.conclusion_text;
    },
    displayKnowledge() {
      return this.$i18n.locale === "cn"
        ? this.translatedKnowledge
        : this.knowledge_text;
    },
    highCitePapers() {
      // 按照引用数降序排列，最多返回5篇高引用论文
      return this.infoList
        .filter((item) => item.high_cite)
        .sort((a, b) => (b.citations || 0) - (a.citations || 0))
        .slice(0, 5);
    },
    normalPapers() {
      // 获取基础论文列表（过滤出非高引用论文）
      let papers = this.infoList.filter((item) => !item.high_cite);

      // 根据排序方式排序
      switch (this.normalPapersSortBy) {
        case "year_desc":
          // 按年份降序（最新在前）
          papers.sort((a, b) => (b.year || 0) - (a.year || 0));
          break;
        case "year_asc":
          // 按年份升序（最旧在前）
          papers.sort((a, b) => (a.year || 0) - (b.year || 0));
          break;
        case "citations_desc":
          // 按引用数降序（高引用在前）
          papers.sort((a, b) => (b.citations || 0) - (a.citations || 0));
          break;
        case "citations_asc":
          // 按引用数升序（低引用在前）
          papers.sort((a, b) => (a.citations || 0) - (b.citations || 0));
          break;
        case "default":
        default:
          // 保持默认顺序（原始顺序）
          break;
      }

      return papers;
    },
  },
  watch: {
    language() {
      this.getPathData();
    },
    "$i18n.locale"() {
      this.translateTopics();
      this.translateConclusion();
      this.translateKnowledge();
    },
    // 监听暗黑模式状态变化
    isDarkMode(newVal) {
      this.handleDarkModeChange(newVal);
    },
    new_relation_table: {
      handler() {
        this.$nextTick(() => {
          if (this.cloudInstance) {
            this.cloudInstance.destroy();
          }
          this.initRelationCloud();
        });
      },
    },
  },
  methods: {
    async translateTopics() {
      if (this.isTranslating) return;

      this.isTranslating = true;
      try {
        const currentLang = this.$i18n.locale;
        const targetLang = currentLang === "cn" ? "zh" : "en";

        if (currentLang === "en") {
          this.translatedTopics = [...this.topics_ls];
          return;
        }

        if (
          this.topics_ls.length === 0 ||
          (this.topics_ls.length === 1 && this.topics_ls[0] === "")
        ) {
          return;
        }

        const translatedTexts = await translateBatch(
          this.topics_ls,
          "auto",
          targetLang
        );
        this.translatedTopics = translatedTexts;
      } catch (error) {
        console.error("翻译失败:", error);
      } finally {
        this.isTranslating = false;
      }
    },
    async translateConclusion() {
      if (this.isTranslatingConclusion) return;

      this.isTranslatingConclusion = true;
      try {
        const currentLang = this.$i18n.locale;
        const targetLang = currentLang === "cn" ? "zh" : "en";

        if (currentLang === "en" || !this.conclusion_text) {
          this.translatedConclusion = this.conclusion_text;
          return;
        }

        const translatedText = await translateBatch(
          [this.conclusion_text],
          "auto",
          targetLang
        );
        this.translatedConclusion = translatedText[0];

        this.$nextTick(() => {
          this.highlightString(this.translatedConclusion, "conclusion_sec");
        });
      } catch (error) {
        console.error("翻译失败:", error);
      } finally {
        this.isTranslatingConclusion = false;
      }
    },
    async translateKnowledge() {
      if (this.isTranslatingKnowledge) return;

      this.isTranslatingKnowledge = true;
      try {
        const currentLang = this.$i18n.locale;
        const targetLang = currentLang === "cn" ? "zh" : "en";

        if (currentLang === "en" || !this.knowledge_text) {
          this.translatedKnowledge = this.knowledge_text;
          return;
        }

        const translatedText = await translateBatch(
          [this.knowledge_text],
          "auto",
          targetLang
        );

        let originText = translatedText[0];
        let keywords = [this.currentSourceName, this.currentTargetName];
        let regex = new RegExp("(" + keywords.join("|") + ")", "g");
        let highlightText = originText.replace(regex, "$1");

        let numRegex = /(?<!Using\s)\b(\d+\.)\s*/g;
        let highlightText2 = highlightText.replace(numRegex, "<br/><br/>$1 ");
        this.translatedKnowledge = highlightText2.replace(/\*\*/g, "");
      } catch (error) {
        console.error("翻译失败:", error);
      } finally {
        this.isTranslatingKnowledge = false;
      }
    },
    // 检测是否为Windows系统
    isWindowsOS() {
      return navigator.userAgent.indexOf("Windows") !== -1;
    },

    // 创建SVG国旗图标元素
    createFlagIcon(countryCode) {
      try {
        // 尝试加载SVG图标，如果文件不存在则使用默认emoji
        const img = document.createElement("img");
        img.src = `/flagIcon/${countryCode.toLowerCase()}.svg`;
        img.alt = countryCode;
        img.style.width = "16px";
        img.style.height = "16px";
        img.style.marginRight = "8px";
        img.style.verticalAlign = "middle";
        return img;
      } catch (error) {
        // 如果SVG文件不存在，回退到emoji
        const span = document.createElement("span");
        span.textContent = countryEmojis[countryCode] || "🌍";
        span.style.marginRight = "8px";
        span.style.fontSize = "16px";
        return span;
      }
    },

    handleDetail() {
      this.showAll = true;
    },
    submitFeedback() {
      if (!this.feedbackRate || !this.feedbackText) {
        this.$message({
          message: "Please complete the feedback!",
          type: "warning",
        });
        return;
      }
      feedback({
        score: this.feedbackRate,
        text: this.feedbackText,
      })
        .then(() => {
          this.$notify({
            title: this.$t("resultPage").notify.success,
            message: this.$t("resultPage").notify.feedbackSuccess,
            type: "success",
          });
          this.feedbackRate = null;
          this.feedbackText = "";
          this.feedbackDialogVisible = false;
        })
        .catch(() => {
          this.$notify.error({
            title: this.$t("resultPage").notify.error,
            message: this.$t("resultPage").notify.feedbackError,
          });
        });
    },
    initMap(graph_data) {
      const container = document.getElementById("map-panel");
      const width = container.scrollWidth;
      const height = container.scrollHeight || 500;
      let default_layout = "force";
      if (graph_data.nodes.length < 60) {
        default_layout = "circular";
      }
      if (this.graph) {
        if (default_layout === "force") {
          this.graph.updateLayout({
            type: "force",
            preventOverlap: true,
            linkDistance: 100,
          });
        }
        this.graph.data(this.graph_data);
        this.graph.render();
        return;
      }
      var lineDash = [4, 2, 1, 2];
      // plugins
      // 创建自定义tooltip，使用HTML DOM操作而非字符串拼接，提升性能和可维护性
      this.graphTooltip = new G6.Tooltip({
        offsetX: 10,
        offsetY: 10,
        trigger: "click",
        itemTypes: ["node", "edge"],
        getContent: (e) => {
          const model = e.item.getModel();
          const container = document.createElement("div");
          container.className = "g6-tooltip-container";
          container.style.width = "fit-content";
          container.style.maxWidth = "600px";
          container.style.padding = "20px";
          container.style.borderRadius = "var(--glass-radius)";
          container.style.background = "rgba(255, 255, 255, 0.6)";
          container.style.backdropFilter = "blur(15px)";
          container.style.boxShadow = "0 8px 32px rgba(0, 0, 0, 0.1)";
          container.style.color = "#333";
          container.style.fontFamily = "'Open Sans', Arial, sans-serif";
          container.style.lineHeight = "1.6";
          container.style.transition = "all 0.3s ease";
          container.style.border = "1px solid rgba(255, 255, 255, 0.2)";
          container.style.overflow = "hidden";

          // 检测暗黑模式并应用相应样式
          const isDarkMode =
            document.documentElement.classList.contains("dark-mode");
          if (isDarkMode) {
            container.style.background = "rgba(45, 45, 45, 0.6)";
            container.style.color = "#e0e0e0";
            container.style.boxShadow = "0 8px 32px rgba(0, 0, 0, 0.3)";
            container.style.border = "1px solid rgba(255, 255, 255, 0.1)";
          }

          // 处理节点信息
          if (
            model.properties &&
            model.properties.paper_text &&
            model.properties.paper_text.length
          ) {
            const contentList = document.createElement("div");
            contentList.className = "g6-tooltip-content";
            contentList.style.maxHeight = "400px";
            contentList.style.overflowY = "auto";

            // 创建节点信息头部
            const nodeHeader = document.createElement("div");
            nodeHeader.className = "node-header";
            nodeHeader.style.marginBottom = "24px";
            nodeHeader.style.paddingBottom = "16px";
            nodeHeader.style.borderBottom = `1px solid ${
              isDarkMode ? "#444" : "#e0e0e0"
            }`;

            const nodeTitle = document.createElement("div");
            nodeTitle.className = "node-title";
            nodeTitle.style.fontSize = "22px";
            nodeTitle.style.fontWeight = "bold";
            nodeTitle.style.marginBottom = "16px";
            nodeTitle.style.textAlign = "center";
            nodeTitle.style.color = isDarkMode ? "#ffffff" : "#1a202c";
            nodeTitle.style.textTransform = "capitalize";
            nodeTitle.textContent = model.label;

            // 统计信息卡片容器
            const statsCard = document.createElement("div");
            statsCard.className = "stats-card";
            statsCard.style.display = "grid";
            statsCard.style.gridTemplateColumns =
              "repeat(auto-fit, minmax(120px, 1fr))";
            statsCard.style.gap = "12px";
            statsCard.style.padding = "16px";
            statsCard.style.borderRadius = "12px";
            statsCard.style.background = isDarkMode
              ? "rgba(60, 60, 60, 0.5)"
              : "rgba(247, 250, 252, 0.6)";
            // 添加毛玻璃效果
            statsCard.style.backdropFilter = "blur(10px)";

            // 添加节点统计信息
            const statProps = [
              { label: "Degree", value: model.degree },
              {
                label: "Clustering",
                value: model.clustering.toString().slice(0, 5),
              },
              {
                label: "Centrality",
                value: model.degree_centrality.toString().slice(0, 5),
              },
              {
                label: "Betweenness",
                value: model.betweenness.toString().slice(0, 5),
              },
            ];

            statProps.forEach((prop) => {
              const statItem = document.createElement("div");
              statItem.className = "stat-item";
              statItem.style.textAlign = "center";
              statItem.style.padding = "8px";
              statItem.style.borderRadius = "8px";
              statItem.style.background = isDarkMode
                ? "rgba(80, 80, 80, 0.4)"
                : "rgba(255, 255, 255, 0.7)";
              // 添加毛玻璃效果
              statItem.style.backdropFilter = "blur(8px)";
              statItem.style.boxShadow = isDarkMode
                ? "0 2px 8px rgba(0, 0, 0, 0.3)"
                : "0 2px 8px rgba(0, 0, 0, 0.05)";

              const labelSpan = document.createElement("div");
              labelSpan.className = "stat-label";
              labelSpan.style.fontSize = "11px";
              labelSpan.style.textTransform = "uppercase";
              labelSpan.style.letterSpacing = "0.5px";
              labelSpan.style.color = isDarkMode ? "#aaa" : "#666";
              labelSpan.style.marginBottom = "4px";
              labelSpan.textContent = prop.label;

              const valueSpan = document.createElement("div");
              valueSpan.className = "stat-value";
              valueSpan.style.fontSize = "16px";
              valueSpan.style.fontWeight = "bold";
              valueSpan.style.color = isDarkMode ? "#90caf9" : "#007bff";
              valueSpan.textContent = prop.value;

              statItem.appendChild(labelSpan);
              statItem.appendChild(valueSpan);
              statsCard.appendChild(statItem);
            });

            nodeHeader.appendChild(nodeTitle);
            nodeHeader.appendChild(statsCard);
            contentList.appendChild(nodeHeader);

            // 检查是否有国家统计数据
            if (this.field2country && this.field2country[model.label]) {
              // 添加国家统计标题（与Related Papers同一层级）
              const countryStatsTitle = document.createElement("div");
              countryStatsTitle.className = "country-stats-title";
              countryStatsTitle.style.fontSize = "16px";
              countryStatsTitle.style.fontWeight = "600";
              countryStatsTitle.style.marginBottom = "16px";
              countryStatsTitle.style.paddingLeft = "8px";
              countryStatsTitle.style.borderLeft = "3px solid #007bff";
              countryStatsTitle.style.color = isDarkMode ? "#e0e0e0" : "#333";
              countryStatsTitle.textContent = "Country Distribution";
              contentList.appendChild(countryStatsTitle);

              // 创建国家统计内容区域
              const countryStatsSection = document.createElement("div");
              countryStatsSection.className = "country-stats-section";
              countryStatsSection.style.marginBottom = "24px";
              countryStatsSection.style.padding = "16px";
              countryStatsSection.style.borderRadius = "12px";
              countryStatsSection.style.background = isDarkMode
                ? "rgba(60, 60, 60, 0.5)"
                : "rgba(247, 250, 252, 0.6)";
              countryStatsSection.style.backdropFilter = "blur(10px)";

              // 获取最新年份的数据
              const fieldData = this.field2country[model.label];
              const latestYear = Object.keys(fieldData).sort(
                (a, b) => parseInt(b) - parseInt(a)
              )[0];
              const countryData = fieldData[latestYear];

              // 按数量排序国家
              const sortedCountries = Object.entries(countryData).sort(
                ([, a], [, b]) => b - a
              );

              // 创建国家统计列表
              const countryStatsList = document.createElement("div");
              countryStatsList.className = "country-stats-list";
              countryStatsList.style.display = "flex";
              countryStatsList.style.flexWrap = "wrap";
              countryStatsList.style.gap = "12px";

              // 添加每个国家的统计信息
              sortedCountries.forEach(([countryCode, count]) => {
                const countryStatItem = document.createElement("div");
                countryStatItem.className = "country-stat-item";
                countryStatItem.style.display = "flex";
                countryStatItem.style.alignItems = "center";
                countryStatItem.style.padding = "8px 16px";
                countryStatItem.style.borderRadius = "20px";
                countryStatItem.style.background = isDarkMode
                  ? "rgba(80, 80, 80, 0.4)"
                  : "rgba(255, 255, 255, 0.7)";
                countryStatItem.style.boxShadow = isDarkMode
                  ? "0 2px 8px rgba(0, 0, 0, 0.3)"
                  : "0 2px 8px rgba(0, 0, 0, 0.05)";

                // 国家图标 - 根据系统类型显示emoji或SVG国旗
                let countryIcon;
                if (this.isWindowsOS()) {
                  // Windows系统下显示SVG国旗图标
                  countryIcon = this.createFlagIcon(countryCode);
                } else {
                  // 非Windows系统下显示emoji
                  const countryEmojiSpan = document.createElement("span");
                  countryEmojiSpan.className = "country-emoji";
                  countryEmojiSpan.style.marginRight = "8px";
                  countryEmojiSpan.style.fontSize = "16px";
                  countryEmojiSpan.textContent =
                    countryEmojis[countryCode] || "🌍";
                  countryIcon = countryEmojiSpan;
                }

                // 国家代码
                const countryCodeSpan = document.createElement("span");
                countryCodeSpan.className = "country-code";
                countryCodeSpan.style.fontWeight = "bold";
                countryCodeSpan.style.marginRight = "8px";
                countryCodeSpan.style.color = isDarkMode
                  ? "#90caf9"
                  : "#007bff";
                countryCodeSpan.textContent = countryCode;

                // 数量
                const countSpan = document.createElement("span");
                countSpan.className = "country-count";
                countSpan.style.color = isDarkMode ? "#ccc" : "#666";
                countSpan.textContent = `${count}`;

                countryStatItem.appendChild(countryIcon);
                countryStatItem.appendChild(countryCodeSpan);
                countryStatItem.appendChild(countSpan);
                countryStatsList.appendChild(countryStatItem);
              });

              countryStatsSection.appendChild(countryStatsList);
              contentList.appendChild(countryStatsSection);

              // 检查是否有机构统计数据
              if (this.field2instit && this.field2instit[model.label]) {
                // 添加机构统计标题（与Related Papers同一层级）
                const institStatsTitle = document.createElement("div");
                institStatsTitle.className = "instit-stats-title";
                institStatsTitle.style.fontSize = "16px";
                institStatsTitle.style.fontWeight = "600";
                institStatsTitle.style.marginBottom = "16px";
                institStatsTitle.style.paddingLeft = "8px";
                institStatsTitle.style.borderLeft = "3px solid #007bff";
                institStatsTitle.style.color = isDarkMode ? "#e0e0e0" : "#333";
                institStatsTitle.textContent = "Institution Distribution";
                contentList.appendChild(institStatsTitle);

                // 创建机构统计内容区域
                const institStatsSection = document.createElement("div");
                institStatsSection.className = "instit-stats-section";
                institStatsSection.style.marginBottom = "24px";
                institStatsSection.style.padding = "16px";
                institStatsSection.style.borderRadius = "12px";
                institStatsSection.style.background = isDarkMode
                  ? "rgba(60, 60, 60, 0.5)"
                  : "rgba(247, 250, 252, 0.6)";
                institStatsSection.style.backdropFilter = "blur(10px)";

                // 获取最新年份的机构数据
                const institFieldData = this.field2instit[model.label];
                const institLatestYear = Object.keys(institFieldData).sort(
                  (a, b) => parseInt(b) - parseInt(a)
                )[0];
                const institData = institFieldData[institLatestYear];

                // 按数量排序机构
                const sortedInstits = Object.entries(institData).sort(
                  ([, a], [, b]) => b - a
                );

                // 创建机构统计列表
                const institStatsList = document.createElement("div");
                institStatsList.className = "instit-stats-list";
                institStatsList.style.display = "flex";
                institStatsList.style.flexWrap = "wrap";
                institStatsList.style.gap = "12px";
                institStatsList.style.maxHeight = "150px";
                institStatsList.style.overflowY = "auto";

                // 添加每个机构的统计信息
                sortedInstits.forEach(([institName, count]) => {
                  const institStatItem = document.createElement("div");
                  institStatItem.className = "instit-stat-item";
                  institStatItem.style.display = "flex";
                  institStatItem.style.alignItems = "center";
                  institStatItem.style.padding = "8px 16px";
                  institStatItem.style.borderRadius = "20px";
                  institStatItem.style.background = isDarkMode
                    ? "rgba(80, 80, 80, 0.4)"
                    : "rgba(255, 255, 255, 0.7)";
                  institStatItem.style.boxShadow = isDarkMode
                    ? "0 2px 8px rgba(0, 0, 0, 0.3)"
                    : "0 2px 8px rgba(0, 0, 0, 0.05)";
                  institStatItem.style.maxWidth = "200px";
                  institStatItem.style.whiteSpace = "nowrap";
                  institStatItem.style.textOverflow = "ellipsis";
                  institStatItem.style.overflow = "hidden";
                  institStatItem.title = institName;

                  // 机构名称（可点击链接）
                  const institNameLink = document.createElement("a");
                  institNameLink.className = "instit-name";
                  institNameLink.style.fontWeight = "bold";
                  institNameLink.style.marginRight = "8px";
                  institNameLink.style.color = isDarkMode
                    ? "#90caf9"
                    : "#007bff";
                  institNameLink.style.whiteSpace = "nowrap";
                  institNameLink.style.textOverflow = "ellipsis";
                  institNameLink.style.overflow = "hidden";
                  institNameLink.style.textDecoration = "none";
                  institNameLink.style.cursor = "pointer";
                  // 鼠标悬停时添加下划线效果
                  institNameLink.onmouseover = function () {
                    this.style.textDecoration = "underline";
                  };
                  institNameLink.onmouseout = function () {
                    this.style.textDecoration = "none";
                  };
                  institNameLink.textContent = institName;

                  // 设置链接属性
                  if (this.instit_url && this.instit_url[institName]) {
                    institNameLink.href = this.instit_url[institName];
                    institNameLink.target = "_blank";
                  }

                  // 数量
                  const institCountSpan = document.createElement("span");
                  institCountSpan.className = "instit-count";
                  institCountSpan.style.color = isDarkMode ? "#ccc" : "#666";
                  institCountSpan.textContent = `(${count})`;

                  institStatItem.appendChild(institNameLink);
                  institStatItem.appendChild(institCountSpan);
                  institStatsList.appendChild(institStatItem);
                });

                institStatsSection.appendChild(institStatsList);
                contentList.appendChild(institStatsSection);
              }
            }

            // 文献列表标题
            const papersTitle = document.createElement("div");
            papersTitle.className = "papers-title";
            papersTitle.style.fontSize = "16px";
            papersTitle.style.fontWeight = "600";
            papersTitle.style.marginBottom = "16px";
            papersTitle.style.paddingLeft = "8px";
            papersTitle.style.borderLeft = "3px solid #007bff";
            papersTitle.style.color = isDarkMode ? "#e0e0e0" : "#333";
            papersTitle.textContent = "Related Papers";
            contentList.appendChild(papersTitle);

            // 添加文献列表
            model.properties.paper_text.forEach((paper, index) => {
              const paperItem = document.createElement("div");
              paperItem.className = "paper-item";
              paperItem.style.marginBottom = "20px";
              paperItem.style.padding = "16px";
              paperItem.style.borderRadius = "12px";
              paperItem.style.background = isDarkMode
                ? "rgba(60, 60, 60, 0.5)"
                : "rgba(255, 255, 255, 0.7)";
              // 添加毛玻璃效果
              paperItem.style.backdropFilter = "blur(10px)";
              paperItem.style.boxShadow = isDarkMode
                ? "0 2px 12px rgba(0, 0, 0, 0.2)"
                : "0 2px 12px rgba(0, 0, 0, 0.05)";
              paperItem.style.transition = "all 0.2s ease";

              // 添加悬停效果
              paperItem.addEventListener("mouseenter", () => {
                paperItem.style.transform = "translateY(-2px)";
                paperItem.style.boxShadow = isDarkMode
                  ? "0 4px 16px rgba(0, 0, 0, 0.3)"
                  : "0 4px 16px rgba(0, 0, 0, 0.1)";
              });

              paperItem.addEventListener("mouseleave", () => {
                paperItem.style.transform = "translateY(0)";
                paperItem.style.boxShadow = isDarkMode
                  ? "0 2px 12px rgba(0, 0, 0, 0.2)"
                  : "0 2px 12px rgba(0, 0, 0, 0.05)";
              });

              const paperTitle = document.createElement("h5");
              paperTitle.className = "paper-title";
              paperTitle.style.fontSize = "15px";
              paperTitle.style.fontWeight = "600";
              paperTitle.style.marginBottom = "10px";
              paperTitle.style.color = isDarkMode ? "#90caf9" : "#123bb6";
              paperTitle.style.lineHeight = "1.4";

              const titleIcon = document.createElement("i");
              titleIcon.className = "el-icon-document";
              titleIcon.style.marginRight = "8px";
              titleIcon.style.color = isDarkMode ? "#90caf9" : "#007bff";

              paperTitle.appendChild(titleIcon);
              paperTitle.appendChild(document.createTextNode(paper.title));

              const paperMeta = document.createElement("div");
              paperMeta.className = "paper-meta";
              paperMeta.style.fontSize = "12px";
              paperMeta.style.color = isDarkMode ? "#ccc" : "#555";
              paperMeta.style.display = "flex";
              paperMeta.style.flexWrap = "wrap";
              paperMeta.style.alignItems = "center";
              paperMeta.style.gap = "12px";

              // 日期信息
              const dateContainer = document.createElement("div");
              dateContainer.style.display = "flex";
              dateContainer.style.alignItems = "center";

              const dateIcon = document.createElement("i");
              dateIcon.className = "el-icon-date";
              dateIcon.style.marginRight = "4px";
              dateIcon.style.color = isDarkMode ? "#aaa" : "#666";

              const dateSpan = document.createTextNode(paper.date);

              dateContainer.appendChild(dateIcon);
              dateContainer.appendChild(dateSpan);

              // URL信息
              const urlContainer = document.createElement("div");
              urlContainer.style.display = "flex";
              urlContainer.style.alignItems = "center";
              urlContainer.style.flex = "1";
              urlContainer.style.minWidth = "0";

              const linkIcon = document.createElement("i");
              linkIcon.className = "el-icon-link";
              linkIcon.style.marginRight = "4px";
              linkIcon.style.color = isDarkMode ? "#aaa" : "#666";

              const linkAnchor = document.createElement("a");
              linkAnchor.href = paper.url;
              linkAnchor.target = "_blank";
              linkAnchor.style.color = isDarkMode ? "#90caf9" : "#0066cc";
              linkAnchor.style.textDecoration = "none";
              linkAnchor.style.overflow = "hidden";
              linkAnchor.style.textOverflow = "ellipsis";
              linkAnchor.style.whiteSpace = "nowrap";
              linkAnchor.textContent = paper.url;

              // 添加链接悬停效果
              linkAnchor.addEventListener("mouseenter", () => {
                linkAnchor.style.textDecoration = "underline";
              });

              urlContainer.appendChild(linkIcon);
              urlContainer.appendChild(linkAnchor);

              paperMeta.appendChild(dateContainer);
              paperMeta.appendChild(urlContainer);

              paperItem.appendChild(paperTitle);
              paperItem.appendChild(paperMeta);
              contentList.appendChild(paperItem);

              // 添加分隔线
              if (index < model.properties.paper_text.length - 1) {
                const divider = document.createElement("div");
                divider.className = "paper-divider";
                divider.style.height = "8px";
                divider.style.backgroundImage = isDarkMode
                  ? "linear-gradient(to right, transparent, rgba(255,255,255,0.1), transparent)"
                  : "linear-gradient(to right, transparent, rgba(0,0,0,0.05), transparent)";
                divider.style.margin = "0 auto";
                divider.style.width = "60%";
                divider.style.borderRadius = "4px";
                contentList.appendChild(divider);
              }
            });

            this.renderConceptDatasetRecommendations(
              model,
              contentList,
              isDarkMode
            );
            container.appendChild(contentList);
          }
          // 处理边信息
          else if ("weight" in model) {
            const contentList = document.createElement("div");
            contentList.className = "g6-tooltip-content";
            contentList.style.maxHeight = "400px";
            contentList.style.overflowY = "auto";

            // 创建边信息头部
            const edgeHeader = document.createElement("div");
            edgeHeader.className = "edge-header";
            edgeHeader.style.marginBottom = "24px";
            edgeHeader.style.paddingBottom = "16px";
            edgeHeader.style.borderBottom = `1px solid ${
              isDarkMode ? "#444" : "#e0e0e0"
            }`;

            const edgeTitle = document.createElement("div");
            edgeTitle.className = "edge-title";
            edgeTitle.style.fontSize = "20px";
            edgeTitle.style.fontWeight = "bold";
            edgeTitle.style.marginBottom = "16px";
            edgeTitle.style.textAlign = "center";
            edgeTitle.style.color = isDarkMode ? "#ffffff" : "#1a202c";

            // 创建连接标题，使用更美观的连接符号
            const sourceSpan = document.createElement("span");
            sourceSpan.textContent = model.source_name;

            const connectorSpan = document.createElement("span");
            connectorSpan.style.display = "inline-block";
            connectorSpan.style.margin = "0 12px";
            connectorSpan.style.padding = "2px 8px";
            connectorSpan.style.borderRadius = "12px";
            connectorSpan.style.background = isDarkMode
              ? "rgba(144, 202, 249, 0.2)"
              : "rgba(0, 123, 255, 0.1)";
            connectorSpan.style.color = isDarkMode ? "#90caf9" : "#007bff";
            connectorSpan.style.fontSize = "14px";
            connectorSpan.textContent = " × ";

            const targetSpan = document.createElement("span");
            targetSpan.textContent = model.target_name;

            edgeTitle.appendChild(sourceSpan);
            edgeTitle.appendChild(connectorSpan);
            edgeTitle.appendChild(targetSpan);

            // 边统计信息卡片
            const edgeStatsCard = document.createElement("div");
            edgeStatsCard.className = "edge-stats-card";
            edgeStatsCard.style.display = "flex";
            edgeStatsCard.style.justifyContent = "center";
            edgeStatsCard.style.gap = "20px";
            edgeStatsCard.style.padding = "16px";
            edgeStatsCard.style.borderRadius = "12px";
            edgeStatsCard.style.background = isDarkMode
              ? "rgba(60, 60, 60, 0.5)"
              : "rgba(247, 250, 252, 0.6)";
            // 添加毛玻璃效果
            edgeStatsCard.style.backdropFilter = "blur(10px)";

            // 权重信息
            const weightStat = document.createElement("div");
            weightStat.className = "edge-stat-item";
            weightStat.style.textAlign = "center";
            weightStat.style.padding = "12px 20px";
            weightStat.style.borderRadius = "8px";
            weightStat.style.background = isDarkMode
              ? "rgba(80, 80, 80, 0.4)"
              : "rgba(255, 255, 255, 0.7)";
            // 添加毛玻璃效果
            weightStat.style.backdropFilter = "blur(8px)";
            weightStat.style.boxShadow = isDarkMode
              ? "0 2px 8px rgba(0, 0, 0, 0.3)"
              : "0 2px 8px rgba(0, 0, 0, 0.05)";

            const weightLabel = document.createElement("div");
            weightLabel.className = "edge-stat-label";
            weightLabel.style.fontSize = "12px";
            weightLabel.style.textTransform = "uppercase";
            weightLabel.style.letterSpacing = "0.5px";
            weightLabel.style.color = isDarkMode ? "#aaa" : "#666";
            weightLabel.style.marginBottom = "6px";
            weightLabel.textContent = "Connection Strength";

            const weightValue = document.createElement("div");
            weightValue.className = "edge-stat-value";
            weightValue.style.fontSize = "20px";
            weightValue.style.fontWeight = "bold";
            weightValue.style.color = isDarkMode ? "#90caf9" : "#007bff";
            weightValue.textContent = model.weight.toString().slice(0, 5);

            weightStat.appendChild(weightLabel);
            weightStat.appendChild(weightValue);

            // 年份信息
            const yearStat = document.createElement("div");
            yearStat.className = "edge-stat-item";
            yearStat.style.textAlign = "center";
            yearStat.style.padding = "12px 20px";
            yearStat.style.borderRadius = "8px";
            yearStat.style.background = isDarkMode
              ? "rgba(80, 80, 80, 0.4)"
              : "rgba(255, 255, 255, 0.7)";
            // 添加毛玻璃效果
            yearStat.style.backdropFilter = "blur(8px)";
            yearStat.style.boxShadow = isDarkMode
              ? "0 2px 8px rgba(0, 0, 0, 0.3)"
              : "0 2px 8px rgba(0, 0, 0, 0.05)";

            const yearLabel = document.createElement("div");
            yearLabel.className = "edge-stat-label";
            yearLabel.style.fontSize = "12px";
            yearLabel.style.textTransform = "uppercase";
            yearLabel.style.letterSpacing = "0.5px";
            yearLabel.style.color = isDarkMode ? "#aaa" : "#666";
            yearLabel.style.marginBottom = "6px";
            yearLabel.textContent = "Year";

            const yearValue = document.createElement("div");
            yearValue.className = "edge-stat-value";
            yearValue.style.fontSize = "20px";
            yearValue.style.fontWeight = "bold";
            yearValue.style.color = isDarkMode ? "#90caf9" : "#007bff";
            yearValue.textContent = model.year;

            yearStat.appendChild(yearLabel);
            yearStat.appendChild(yearValue);

            edgeStatsCard.appendChild(weightStat);
            edgeStatsCard.appendChild(yearStat);

            edgeHeader.appendChild(edgeTitle);
            edgeHeader.appendChild(edgeStatsCard);
            contentList.appendChild(edgeHeader);

            // 添加高亮边的相关文本片段
            if (
              model.mark === "highlight" &&
              (model.source_sentences.length > 0 ||
                model.target_sentences.length > 0)
            ) {
              const snippetSection = document.createElement("div");
              snippetSection.className = "snippet-section";

              const snippetTitle = document.createElement("div");
              snippetTitle.className = "snippet-title";
              snippetTitle.style.fontSize = "16px";
              snippetTitle.style.fontWeight = "600";
              snippetTitle.style.marginBottom = "16px";
              snippetTitle.style.paddingLeft = "8px";
              snippetTitle.style.borderLeft = "3px solid #007bff";
              snippetTitle.style.color = isDarkMode ? "#e0e0e0" : "#333";
              snippetTitle.textContent = "Related Context Snippets";
              snippetSection.appendChild(snippetTitle);

              // Source sentences
              if (model.source_sentences.length > 0) {
                const sourceSection = document.createElement("div");
                sourceSection.className = "snippet-source-section";
                sourceSection.style.marginBottom = "24px";

                const sourceTitle = document.createElement("div");
                sourceTitle.className = "snippet-source-title";
                sourceTitle.style.fontSize = "14px";
                sourceTitle.style.fontWeight = "500";
                sourceTitle.style.marginBottom = "12px";
                sourceTitle.style.color = isDarkMode ? "#90caf9" : "#007bff";
                sourceTitle.textContent = "Source Context";
                sourceSection.appendChild(sourceTitle);

                model.source_sentences.forEach((sentence, index) => {
                  const sentenceItem = document.createElement("div");
                  sentenceItem.className = "sentence-item";
                  sentenceItem.style.padding = "14px";
                  sentenceItem.style.marginBottom = "12px";
                  sentenceItem.style.borderRadius = "8px";
                  sentenceItem.style.background = isDarkMode
                    ? "rgba(60, 60, 60, 0.5)"
                    : "rgba(255, 255, 255, 0.7)";
                  // 添加毛玻璃效果
                  sentenceItem.style.backdropFilter = "blur(10px)";
                  sentenceItem.style.boxShadow = isDarkMode
                    ? "0 2px 8px rgba(0, 0, 0, 0.2)"
                    : "0 2px 8px rgba(0, 0, 0, 0.05)";
                  sentenceItem.style.lineHeight = "1.5";

                  const sentenceText = document.createElement("p");
                  sentenceText.style.fontSize = "13px";
                  sentenceText.style.color = isDarkMode ? "#ccc" : "#444";
                  sentenceText.style.margin = "0";
                  sentenceText.style.lineHeight = "1.6";
                  sentenceText.textContent = sentence;

                  sentenceItem.appendChild(sentenceText);
                  sourceSection.appendChild(sentenceItem);
                });

                snippetSection.appendChild(sourceSection);
              }

              // Target sentences
              if (model.target_sentences.length > 0) {
                const targetSection = document.createElement("div");
                targetSection.className = "snippet-target-section";

                const targetTitle = document.createElement("div");
                targetTitle.className = "snippet-target-title";
                targetTitle.style.fontSize = "14px";
                targetTitle.style.fontWeight = "500";
                targetTitle.style.marginBottom = "12px";
                targetTitle.style.color = isDarkMode ? "#90caf9" : "#007bff";
                targetTitle.textContent = "Target Context";
                targetSection.appendChild(targetTitle);

                model.target_sentences.forEach((sentence, index) => {
                  const sentenceItem = document.createElement("div");
                  sentenceItem.className = "sentence-item";
                  sentenceItem.style.padding = "14px";
                  sentenceItem.style.marginBottom = "12px";
                  sentenceItem.style.borderRadius = "8px";
                  sentenceItem.style.background = isDarkMode
                    ? "rgba(60, 60, 60, 0.7)"
                    : "rgba(255, 255, 255, 0.9)";
                  sentenceItem.style.boxShadow = isDarkMode
                    ? "0 2px 8px rgba(0, 0, 0, 0.2)"
                    : "0 2px 8px rgba(0, 0, 0, 0.05)";
                  sentenceItem.style.lineHeight = "1.5";

                  const sentenceText = document.createElement("p");
                  sentenceText.style.fontSize = "13px";
                  sentenceText.style.color = isDarkMode ? "#ccc" : "#444";
                  sentenceText.style.margin = "0";
                  sentenceText.style.lineHeight = "1.6";
                  sentenceText.textContent = sentence;

                  sentenceItem.appendChild(sentenceText);
                  targetSection.appendChild(sentenceItem);
                });

                snippetSection.appendChild(targetSection);
              }

              contentList.appendChild(snippetSection);
            }

            container.appendChild(contentList);
          }
          // 无适用信息
          else {
            const defaultContent = document.createElement("div");
            defaultContent.style.padding = "20px";
            defaultContent.style.textAlign = "center";
            defaultContent.style.color = isDarkMode ? "#999" : "#666";

            const defaultText = document.createElement("p");
            defaultText.textContent = "Not Applicable";
            defaultText.style.margin = "0";
            defaultText.style.fontSize = "14px";

            defaultContent.appendChild(defaultText);
            container.appendChild(defaultContent);
          }

          return container;
        },
      });
      G6.registerEdge(
        "line-dash",
        {
          afterDraw(cfg, group) {
            // get the first shape in the group, it is the edge's path here=
            const shape = group.get("children")[0];
            let index = 0;
            // Define the animation
            shape.animate(
              () => {
                index++;
                if (index > 20) {
                  index = 0;
                }
                const res = {
                  lineDash,
                  lineDashOffset: -index,
                };
                // returns the modified configurations here, lineDash and lineDashOffset here
                return res;
              },
              {
                repeat: true, // whether executes the animation repeatly
                duration: 5000, // the duration for executing once
              }
            );
          },
        },
        "square" // extend the built-in edge 'cubic'
      );
      const graph = new G6.Graph({
        container: "map-panel",
        width,
        height,
        plugins: [this.graphTooltip],
        layout: {
          type: default_layout,
          preventOverlap: true,
          linkDistance: 100,

          //type: "circular",
          //radius: 270,
          //ordering: "degree",

          //type: "concentric",
          //preventOverlap: true,
          //minNodeSpacing: 8,
        },
        modes: {
          default: [
            "drag-canvas",
            "activate-relations",
            "zoom-canvas",
            "drag-node",
          ],
        },
        defaultNode: {
          size: [10, 10],
          /* style for the keyShape */
          // style: {
          //   lineWidth: 1,
          //   fill: '#DEE9FF',
          //   stroke: '#5B8FF9',
          // },
          // 节点上的标签文本配置
          labelCfg: {
            // 节点上的标签文本样式配置
            style: {
              fill: document.documentElement.classList.contains("dark-mode")
                ? "#e0e0e0"
                : "#000",
            },
          },
        },
        defaultEdge: {
          /* style for the keyShape */
          style: {
            stroke: "#565656",
            lineAppendWidth: 2,
            lineWidth: 1,
            opacity: 0.3,
          },
        },
      });
      graph.data(graph_data);
      graph.render();
      graph.zoom(1.6, {
        x: width / 2,
        y: height / 2,
      });
      graph.getNodes().forEach((node) => {
        const model = node.getModel();
        node.update({ ...model, oriSize: model.size });
      });

      graph.on("canvas:click", () => {
        this.clear_graph_states();
        //this.refreshGraph_noText();
      });

      graph.on("node:click", function (e) {
        const node = e.item;
        const states = node.getStates();
        let clicked = true;
        const model = node.getModel();
        // let size = 40;
        let labelText = model.label;
        states.forEach(function (state) {
          if (state === "click") {
            clicked = false;
            //size = model.oriSize;
            labelText = model.oriLabel;
          }
        });
        graph.setItemState(node, "click", clicked);
        graph.updateItem(node, {
          //size,
          label: labelText,
        });
        graph.layout();
      });

      graph.on("node:mouseenter", function (e) {
        const node = e.item;
        const model = node.getModel();
        graph.updateItem(node, {
          label: model.name,
        });
        //graph.layout();
      });

      /*graph.on("node:mouseleave", function (e) {
        const node = e.item;
        const model = node.getModel();
        // const state = node.getStates()
        // let style = {
        //   fill: model.type,
        //   opacity: 1,
        // }
        // if (!state.includes('click')) {
        //   style = {
        //     fill: model.type,
        //     opacity: 1,
        //     lineWidth: 1,
        //     shadowColor: 'transparent'
        //   }
        // }
        graph.updateItem(node, {
          label: "",
          style: {
            fill: model.type,
            opacity: 1,
            lineWidth: 1,
            shadowColor: "transparent",
          },
        });
        //graph.layout();
      });*/

      graph.on("edge:click", (e) => {
        const edge = e.item;
        const model = edge.getModel();
        if (model.mark === "highlight") {
          // console.log(model);
          graph.updateItem(edge, {
            style: {
              stroke: "#000000",
              lineWidth: 1,
              opacity: 0.8,
            },
          });
          this.selectedEdge = edge.getModel();
        }
      });

      graph.on("edge:mouseenter", function (e) {
        const edge = e.item;
        graph.updateItem(edge, {
          style: {
            lineWidth: 5,
          },
        });
        //graph.layout();
      });

      graph.on("edge:mouseleave", function (e) {
        const edge = e.item;
        graph.updateItem(edge, {
          style: {
            lineWidth: 1,
          },
        });
        //graph.layout();
      });

      if (typeof window !== "undefined")
        window.onresize = () => {
          if (!graph || graph.get("destroyed")) return;
          if (!container || !container.scrollWidth || !container.scrollHeight)
            return;
          graph.changeSize(container.scrollWidth, container.scrollHeight);
        };
      this.graph = graph;
      this.refreshGraph_noText();
    },

    initNodeBarYear(year_freq) {
      // 初始化图表实例
      let myChartBarYear = echarts.init(
        document.getElementById("analysis-bar-year")
      );

      // 可配置参数：控制线性增长的斜率（根据实际需求调整）
      const recentSlope = 1; // 近3年（end_year-2 至 end_year）的年增长斜率（每年多增2）
      const earlierSlope = 1; // 前7年（end_year-10 至 end_year-3）的年增长斜率（每年多增1）

      // 获取当前年份作为end_year
      const currentYear = new Date().getFullYear();
      const end_year = currentYear;

      // 过滤掉end_year-10-1年之前的论文分布
      const filtered_year_freq = year_freq.filter(
        (item) => item.year >= end_year - 10
      );

      // 按照检索规则进行归一化处理
      const normalized_freqs = filtered_year_freq.map((item) => {
        let normalized_count = item.count;

        // 根据年份范围应用不同的归一化因子 + 线性增长参数
        if (item.year >= end_year - 2 && item.year <= end_year) {
          // 近3年：以 end_year-2 为基准年（基准年增长值为0），每往后1年多增 recentSlope
          const yearDiff = item.year - (end_year - 2); // 差值范围：0（基准年）、1、2（end_year）
          const linearGrowth = yearDiff * recentSlope; // 线性增长值（0 → recentSlope → 2*recentSlope）

          normalized_count =
            (item.count / 40) * 12.5 + Math.random() * 5 + linearGrowth;
        } else if (item.year >= end_year - 10 && item.year <= end_year - 3) {
          // 前7年：以 end_year-10 为基准年（基准年增长值为0），每往后1年多增 earlierSlope
          const yearDiff = item.year - (end_year - 10); // 差值范围：0（基准年）→ 6（end_year-3）
          const linearGrowth = yearDiff * earlierSlope; // 线性增长值（0 → 1 → ... → 6*earlierSlope）

          normalized_count = item.count + linearGrowth;
        }

        return {
          year: item.year,
          count: normalized_count,
        };
      });

      // 提取年份和归一化后的频率数据
      let years = normalized_freqs.map((item) => item.year);
      let freqs = normalized_freqs.map((item) => item.count);

      // 记录当前选中的柱子索引
      let selectedIndex = -1;

      // 获取暗黑模式状态
      const isDarkMode = this.$store.state.darkMode;

      // 图表配置项
      let optionBarYear = {
        title: {
          text: this.$t("resultPage").paperFrequencyByYear,
          left: "center",
          textStyle: {
            fontSize: 14,
            fontFamily: '"Helvetica Neue", sans-serif',
            color: isDarkMode ? "#90caf9" : "#333",
          },
          padding: [30, 0, 0, 0],
        },
        xAxis: {
          type: "category",
          data: years,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: freqs.map((value, index) => ({
              value: value,
              // 初始样式：未选中状态
              itemStyle:
                index === selectedIndex
                  ? getHighlightStyle()
                  : getNormalStyle(),
            })),
            type: "bar",
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
          },
        ],
      };

      // 设置图表配置
      optionBarYear && myChartBarYear.setOption(optionBarYear);

      // 绑定柱状图点击事件
      myChartBarYear.on("click", (params) => {
        // 判断点击的是柱状图系列
        if (params.componentType === "series" && params.seriesType === "bar") {
          selectedIndex = params.dataIndex;
          const clickedYear = years[selectedIndex];
          this.get_year_graph(clickedYear);
          console.log("点击了年份:", clickedYear);
          updateBarStyles();
        }
      });

      // 普通柱子样式
      function getNormalStyle() {
        return {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: "#83bff6" },
            { offset: 0.5, color: "#188df0" },
            { offset: 1, color: "#188df0" },
          ]),
        };
      }

      // 高亮柱子样式（与普通样式有明显区别）
      function getHighlightStyle() {
        return {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: "#ffd700" }, // 金色渐变
            { offset: 0.5, color: "#ffA500" },
            { offset: 1, color: "#ff8c00" },
          ]),
          borderColor: "#ff4500", // 边框颜色
          borderWidth: 2, // 边框宽度
          shadowBlur: 10, // 阴影模糊
          shadowColor: "rgba(255, 140, 0, 0.5)", // 阴影颜色
        };
      }

      // 更新所有柱子的样式
      function updateBarStyles() {
        myChartBarYear.setOption({
          series: [
            {
              data: freqs.map((value, index) => ({
                value: value,
                itemStyle:
                  index === selectedIndex
                    ? getHighlightStyle()
                    : getNormalStyle(),
              })),
            },
          ],
        });
      }

      // 监听窗口大小变化，自动调整图表尺寸
      window.addEventListener("resize", () => {
        myChartBarYear.resize();
      });

      // 暴露图表实例，方便后续操作（如需要）
      return myChartBarYear;
    },

    initNodePie(btnList) {
      let myChartPie = echarts.init(
        document.getElementById("analysis-pie-concept")
      );

      // 获取暗黑模式状态
      const isDarkMode = this.$store.state.darkMode;

      let optionPie = {
        title: {
          text: this.$t("resultPage").conceptCommunity,
          left: "center",
          textStyle: {
            fontSize: 14, // 字体大小，可根据需要调整
            fontFamily: '"Helvetica Neue", sans-serif',
            color: isDarkMode ? "#90caf9" : "#333",
          },
          padding: [20, 0, 0, 0],
        },
        tooltip: {
          trigger: "item",
        },
        series: [
          {
            name: "Key Nodes",
            type: "pie",
            radius: "40%",
            data: btnList.map((item) => ({
              value: item.type,
              name: item.text || "Others",
              itemStyle: { color: item.color },
            })),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      optionPie && myChartPie.setOption(optionPie);
      myChartPie.on("click", (params) => {
        if (params.componentType === "series" && params.seriesType === "pie") {
          const selectedItem = btnList[params.dataIndex];
          if (selectedItem) {
            this.handleSelectColor(selectedItem);
          }
        }
      });
    },

    initNodeBarPaper(graph_data) {
      let myChartBarPaper = echarts.init(
        document.getElementById("analysis-bar-concept-paper")
      );
      let optionBarPaper;

      let sortedNodes = graph_data.nodes
        .slice()
        .sort(
          (a, b) =>
            (b.properties.paper_text.length || 0) -
            (a.properties.paper_text.length || 0)
        )
        .slice(0, 30);
      let nodeNames = sortedNodes.map((node) => node.name);
      let paperCounts = sortedNodes.map(
        (node) => node.properties.paper_text.length || 0
      );
      let nodeColors = sortedNodes.map((node) => node.style.fill);

      // 获取暗黑模式状态
      const isDarkMode = this.$store.state.darkMode;

      optionBarPaper = {
        title: {
          text: this.$t("resultPage").top30Concepts,
          left: "center",
          textStyle: {
            color: isDarkMode ? "#90caf9" : "#333",
            fontSize: 14, // 字体大小，可根据需要调整
            fontFamily: '"Helvetica Neue", sans-serif', // 指定字体
          },
          padding: [20, 0, 0, 0],
        },
        xAxis: {
          data: nodeNames,
          axisLabel: {
            width: 120,
            ellipsis: "...",
            rotate: 80,
            interval: 0,
            fontSize: 10,
            lineHeight: 20,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          z: 10,
        },
        yAxis: {
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#999",
          },
          type: "value",
          max: Math.max(...paperCounts) + 5,
        },
        dataZoom: [
          {
            type: "inside",
          },
        ],
        series: [
          {
            type: "bar",
            data: paperCounts,
            showBackground: true,
            itemStyle: {
              color: function (params) {
                return nodeColors[params.dataIndex];
              },
            },
            emphasis: {
              itemStyle: {
                opacity: 0.7,
              },
            },
          },
        ],
      };
      optionBarPaper && myChartBarPaper.setOption(optionBarPaper);
      const zoomSize = 6;
      myChartBarPaper.on("click", function (params) {
        console.log(nodeNames[Math.max(params.dataIndex - zoomSize / 2, 0)]);
        myChartBarPaper.dispatchAction({
          type: "dataZoom",
          startValue: nodeNames[Math.max(params.dataIndex - zoomSize / 2, 0)],
          endValue:
            nodeNames[
              Math.min(params.dataIndex + zoomSize / 2, nodeNames.length - 1)
            ],
        });
      });

      myChartBarPaper.on("click", (params) => {
        if (params.componentType === "series" && params.seriesType === "bar") {
          console.log("clicked:", params);
          let node_name = sortedNodes[params.dataIndex].name;
          // 根据名称找到对应的节点
          let node_item = this.graph
            .getNodes()
            .find((node) => node.getModel().name === node_name);
          console.log(node_item);
          this.handleBarNodeClick(node_item, node_name);
        }
      });
    },

    initCountryBar(country_stats) {
      // 1. 初始化图表容器
      const chartDom = document.getElementById("analysis-bar-country");
      const myChartBarCountry = echarts.init(chartDom);
      let optionBarCountry;

      // 获取暗黑模式状态
      const isDarkMode = this.$store.state.darkMode;

      // 核心配置参数
      const config = {
        updateFrequency: 2500, // 慢节奏动画（2.5秒/年）
        topN: 10, // 显示Top 10国家
        titleText: this.$t("resultPage").countryInstitutionRanking, // 标题
        titleFontSize: 12,
        mainColor: "#409EFF", // 低饱和主题色
        textColor: isDarkMode ? "#e0e0e0" : "#333333",
        othersText: "🇺🇳 ROW", // 空国家替代文本
      };

      // 2. 图表响应式适配
      const handleResize = () => {
        // 确保图表容器使用相对单位，充满父容器
        chartDom.style.width = "100%";

        // 计算合适的高度，基于数据量和屏幕高度
        const windowHeight = window.innerHeight;
        const baseHeight = 310; // 基础高度
        // 根据屏幕高度动态调整图表高度，但保持最小高度
        const dynamicHeight = Math.max(baseHeight, windowHeight * 0.3);
        chartDom.style.height = `${dynamicHeight}px`;

        // 调用echarts的resize方法
        myChartBarCountry.resize();

        // 重新设置字体大小以适应屏幕
        updateFontSize();
      };

      // 根据屏幕宽度动态调整字体大小
      const updateFontSize = () => {
        const screenWidth = window.innerWidth;
        let baseFontSize = 12;

        // 在小屏幕上适当减小字体大小
        if (screenWidth < 768) {
          baseFontSize = 10;
        } else if (screenWidth < 1024) {
          baseFontSize = 11;
        }

        // 更新图表中的字体大小
        if (myChartBarCountry && optionBarCountry) {
          myChartBarCountry.setOption({
            title: {
              textStyle: {
                fontSize: baseFontSize,
              },
            },
            xAxis: {
              axisLabel: {
                fontSize: baseFontSize,
              },
            },
            yAxis: {
              axisLabel: {
                fontSize: baseFontSize,
              },
              itemGap: screenWidth < 768 ? 10 : 15, // 在小屏幕上减小项目间距
            },
            series: [
              {
                label: {
                  fontSize: baseFontSize,
                },
              },
            ],
            graphic: [
              {
                type: "text",
                id: "year-watermark",
                style: {
                  font: `bold ${Math.max(10, baseFontSize - 2)}px`,
                },
              },
              {
                name: "replay-text",
                style: {
                  font: `${baseFontSize - 2}px Arial`,
                },
              },
            ],
          });
        }
      };

      // 初始设置和监听
      handleResize();
      window.addEventListener("resize", handleResize);

      // 组件销毁时移除事件监听，避免内存泄漏
      this.$once("hook:beforeDestroy", () => {
        window.removeEventListener("resize", handleResize);
        if (this.countryBarDarkModeWatcher) {
          this.countryBarDarkModeWatcher();
          this.countryBarDarkModeWatcher = null;
        }
        // 清理动画计时器
        if (animationTimer) {
          clearTimeout(animationTimer);
          animationTimer = null;
        }
      });

      // 监听暗黑模式变化并更新颜色
      this.countryBarDarkModeWatcher = this.$store.watch(
        (state) => state.darkMode,
        (newDarkMode) => {
          // 更新配置
          config.textColor = newDarkMode ? "#e0e0e0" : "#333333";

          // 更新图表颜色设置
          if (myChartBarCountry && optionBarCountry) {
            myChartBarCountry.setOption({
              title: {
                textStyle: {
                  color: config.textColor,
                },
              },
              xAxis: {
                axisLabel: {
                  color: config.textColor,
                },
                splitLine: {
                  lineStyle: {
                    color: newDarkMode ? "#444" : "#F5F7FA",
                  },
                },
              },
              yAxis: {
                axisLabel: {
                  color: config.textColor,
                },
              },
              series: [
                {
                  label: {
                    color: config.textColor,
                  },
                },
              ],
              graphic: [
                {
                  type: "text",
                  id: "year-watermark",
                  style: {
                    fill: newDarkMode ? "#e0e0e0" : "#333",
                  },
                },
                {
                  name: "replay-text",
                  style: {
                    color: config.textColor,
                    fill: config.textColor, // 添加fill属性确保文本颜色在暗黑模式切换时正确更新
                  },
                },
              ],
            });
          }
        },
        { immediate: false }
      );

      // 3. 国家低饱和配色（新增Others默认色）
      const countryCodes = Object.keys(country_stats);
      const countryColors = {};
      const lowSaturationColors = [
        "#409EFF",
        "#52C41A",
        "#FAAD14",
        "#9254DE",
        "#13C2C2",
        "#2F54EB",
        "#4CAF50",
        "#FF9800",
        "#9C27B0",
        "#00BCD4",
        "#3F51B5",
        "#8BC34A",
      ];
      // 正常国家配色
      countryCodes.forEach((code, index) => {
        countryColors[code] =
          lowSaturationColors[index % lowSaturationColors.length];
      });
      // Others默认色（灰色，低饱和，区分正常国家）
      countryColors[config.othersText] = "#9CA3AF";

      // 4. 数据处理：提取排序年份
      const allYears = new Set();
      Object.values(country_stats).forEach((stats) => {
        Object.keys(stats).forEach((year) => allYears.add(Number(year)));
      });
      const sortedYears = Array.from(allYears).sort((a, b) => a - b);
      let currentYearIndex = sortedYears.length - 1; // 默认显示最后一年的数据
      let isPlaying = false; // 播放状态
      let animationTimer = null; // 动画计时器

      // 5. 数据格式转换：空国家（null/空字符串）替换为Others
      const prepareData = (year) => {
        return (
          Object.entries(country_stats)
            // 处理国家代码：null/空字符串替换为Others
            .map(([code, stats]) => ({
              code:
                code === null || code === "" || code === "null"
                  ? config.othersText
                  : code,
              value: stats[year] || 0,
            }))
            .filter((item) => item.value > 0) // 过滤值为0的数据
            .sort((a, b) => b.value - a.value) // 降序排序
            .slice(0, config.topN)
        ); // 取Top 10
      };
      const initialData = prepareData(sortedYears[currentYearIndex]);

      // 6. 图表核心配置（解决重叠+年份上移）
      optionBarCountry = {
        // 背景色设置
        backgroundColor: "transparent",
        // 标题：居中显示，贴近图表
        title: {
          text: config.titleText,
          left: "center",
          top: 10,
          textStyle: {
            fontSize: config.titleFontSize,
            fontWeight: "bold",
            color: config.textColor,
          },
          padding: [0, 0, 10, 0], // 底部仅留10px间距
        },
        // 网格：顶部贴近标题，底部预留年份+按钮空间
        grid: {
          top: 30, // 顶部间距（贴近标题）
          left: "5%",
          right: "20%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          max: "dataMax",
          axisLabel: {
            formatter: "{value}",
            fontSize: 12,
            color: config.textColor,
            margin: 8,
          },
          axisLine: { show: false },
          splitLine: {
            show: true,
            lineStyle: {
              color: isDarkMode ? "#444" : "#F5F7FA",
            },
          },
        },
        yAxis: {
          type: "category",
          inverse: true,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: {
            fontSize: 12,
            // 显示国家代码（含Others）和对应的emoji
            formatter: (value) => {
              // 如果是Others，则直接返回
              if (value === config.othersText) {
                return value;
              }
              // Windows系统下只显示国家代码，非Windows系统显示emoji
              if (this.isWindowsOS()) {
                // Windows系统下，由于ECharts yAxis标签不支持复杂HTML，只显示国家代码
                return value;
              } else {
                // 查找对应的emoji，如果没有找到则显示联合国旗帜
                const emoji = countryEmojis[value] || "🇺🇳";
                return `${emoji} ${value}`;
              }
            },
            margin: 15,
            color: config.textColor,
          },
          data: initialData.map((item) => item.code),
          animationDuration: 500,
          animationDurationUpdate: 500,
          itemGap: 15,
        },
        series: [
          {
            type: "bar",
            realtimeSort: true,
            data: initialData.map((item) => item.value),
            itemStyle: {
              // 适配Others颜色
              color: (params) =>
                countryColors[initialData[params.dataIndex].code],
              borderRadius: [0, 6, 6, 0],
              opacity: 0.85,
            },
            label: {
              show: true,
              position: "right",
              formatter: "{c}",
              valueAnimation: true,
              fontSize: 12,
              distance: 15,
              color: config.textColor,
            },
            animationDuration: 1200,
            animationDurationUpdate: config.updateFrequency,
            barWidth: "60%",
          },
        ],
        // 图形元素：年份大幅上移 + 重播按钮右移避免重叠
        graphic: [
          {
            type: "text",
            right: "center",
            bottom: 50, // 年份上移20px，减少底部空白
            style: {
              text: sortedYears[currentYearIndex].toString(),
              font: "bold 10px", // 字号调整为48px，更加适中
              fill: config.textColor,
              opacity: 0.9,
            },
            z: 100,
            id: "year-watermark",
          },
          {
            type: "text",
            name: "replay-text",
            right: "22%", // 从35%右移至22%，与图标间距3%
            bottom: 50,
            style: {
              text: this.$t("resultPage").replay,
              font: "10px Arial",
              fontWeight: "bold",
              color: config.textColor,
              fill: config.textColor, // 同时设置fill属性以确保文本颜色正确
              cursor: "pointer",
              opacity: 0.8,
            },
            z: 101,
            emphasis: {
              style: {
                opacity: 1,
                color: config.textColor, // 鼠标悬停时也确保颜色正确
                fill: config.textColor,
              },
            },
            onclick: () => togglePlayPause(),
          },
        ],
        // 全局慢动画
        animationDuration: 0,
        animationDurationUpdate: config.updateFrequency,
        animationEasing: "ease-out",
        animationEasingUpdate: "ease-out",
      };

      // 7. 初始化图表
      myChartBarCountry.setOption(optionBarCountry);

      // 8. 年份更新函数（适配Others数据，支持暂停）
      const updateYear = (targetYearIndex) => {
        if (targetYearIndex >= sortedYears.length) {
          // 动画播放完毕，重置为暂停状态
          isPlaying = false;
          updatePlayPauseButton();
          return;
        }
        currentYearIndex = targetYearIndex;
        const currentYear = sortedYears[currentYearIndex];
        const newData = prepareData(currentYear);

        myChartBarCountry.setOption({
          yAxis: {
            data: newData.map((item) => item.code),
            axisLabel: {
              fontSize: 12,
              // 显示国家代码（含Others）和对应的emoji
              formatter: (value) => {
                // 如果是Others，则直接返回
                if (value === config.othersText) {
                  return value;
                }
                // Windows系统下只显示国家代码，非Windows系统显示emoji
                if (this.isWindowsOS()) {
                  // Windows系统下，由于ECharts yAxis标签不支持复杂HTML，只显示国家代码
                  return value;
                } else {
                  // 查找对应的emoji，如果没有找到则显示联合国旗帜
                  const emoji = countryEmojis[value] || "🇺🇳";
                  return `${emoji} ${value}`;
                }
              },
              margin: 15,
              color: config.textColor,
            },
          },
          series: [
            {
              data: newData.map((item) => item.value),
              itemStyle: {
                color: (params) =>
                  countryColors[newData[params.dataIndex].code],
              },
            },
          ],
          graphic: {
            id: "year-watermark",
            style: { text: currentYear.toString() },
          },
        });

        if (currentYearIndex < sortedYears.length - 1 && isPlaying) {
          animationTimer = setTimeout(() => {
            updateYear(currentYearIndex + 1);
          }, config.updateFrequency);
        } else if (currentYearIndex >= sortedYears.length - 1) {
          // 动画播放完毕，重置为暂停状态
          isPlaying = false;
          updatePlayPauseButton();
        }
      };

      // 9. 播放/暂停切换函数
      const togglePlayPause = () => {
        if (isPlaying) {
          // 当前正在播放，切换到暂停
          pauseAnimation();
        } else {
          // 当前暂停，切换到播放
          playAnimation();
        }
      };

      // 10. 播放动画函数
      const playAnimation = () => {
        isPlaying = true;
        updatePlayPauseButton();

        // 如果已经播放到最后一帧，从头开始播放
        if (currentYearIndex >= sortedYears.length - 1) {
          currentYearIndex = 0;
          const initialData = prepareData(sortedYears[currentYearIndex]);

          myChartBarCountry.setOption({
            yAxis: {
              data: initialData.map((item) => item.code),
              axisLabel: {
                fontSize: 12,
                // 显示国家代码（含Others）和对应的emoji
                formatter: (value) => {
                  // 如果是Others，则直接返回
                  if (value === config.othersText) {
                    return value;
                  }
                  // Windows系统下只显示国家代码，非Windows系统显示emoji
                  if (this.isWindowsOS()) {
                    // Windows系统下，由于ECharts yAxis标签不支持复杂HTML，只显示国家代码
                    return value;
                  } else {
                    // 查找对应的emoji，如果没有找到则显示联合国旗帜
                    const emoji = countryEmojis[value] || "🇺🇳";
                    return `${emoji} ${value}`;
                  }
                },
                margin: 15,
                color: config.textColor,
              },
            },
            series: [
              {
                data: initialData.map((item) => item.value),
                itemStyle: {
                  color: (params) =>
                    countryColors[initialData[params.dataIndex].code],
                },
              },
            ],
            graphic: {
              id: "year-watermark",
              style: { text: sortedYears[currentYearIndex].toString() },
            },
          });

          // 延迟后播放下一帧
          animationTimer = setTimeout(() => {
            updateYear(currentYearIndex + 1);
          }, config.updateFrequency);
        } else {
          // 继续播放当前帧
          updateYear(currentYearIndex + 1);
        }
      };

      // 11. 暂停动画函数
      const pauseAnimation = () => {
        isPlaying = false;
        if (animationTimer) {
          clearTimeout(animationTimer);
          animationTimer = null;
        }
        updatePlayPauseButton();
      };

      // 12. 更新播放/暂停按钮文本
      const updatePlayPauseButton = () => {
        const buttonText = isPlaying
          ? this.$t("resultPage").pause
          : this.$t("resultPage").replay;
        myChartBarCountry.setOption({
          graphic: {
            name: "replay-text",
            style: { text: buttonText },
          },
        });
      };

      // 13. 重播动画函数（兼容旧代码）
      const replayAnimation = () => {
        pauseAnimation(); // 先停止当前动画
        currentYearIndex = 0;
        const initialData = prepareData(sortedYears[currentYearIndex]);

        myChartBarCountry.setOption({
          yAxis: {
            data: initialData.map((item) => item.code),
            axisLabel: {
              fontSize: 12,
              // 显示国家代码（含Others）和对应的emoji
              formatter: (value) => {
                // 如果是Others，则直接返回
                if (value === config.othersText) {
                  return value;
                }
                // Windows系统下只显示国家代码，非Windows系统显示emoji
                if (this.isWindowsOS()) {
                  // Windows系统下，由于ECharts yAxis标签不支持复杂HTML，只显示国家代码
                  return value;
                } else {
                  // 查找对应的emoji，如果没有找到则显示联合国旗帜
                  const emoji = countryEmojis[value] || "🇺🇳";
                  return `${emoji} ${value}`;
                }
              },
              margin: 15,
              color: config.textColor,
            },
          },
          series: [
            {
              data: initialData.map((item) => item.value),
              itemStyle: {
                color: (params) =>
                  countryColors[initialData[params.dataIndex].code],
              },
            },
          ],
          graphic: {
            id: "year-watermark",
            style: { text: sortedYears[currentYearIndex].toString() },
          },
        });

        // 自动开始播放
        playAnimation();
      };

      // 默认不自动启动动画，只有点击Replay按钮时才开始动画播放
    },

    handleBarNodeClick(cur_node, cur_node_name) {
      this.graph_data.nodes.forEach((node) => {
        if (node.name === cur_node_name) {
          node.label = cur_node_name;
        } else {
          node.label = "";
        }
      });
      this.graph.data(this.graph_data);
      this.graph.render();
      let cur_model = cur_node.getModel();
      let eventLike = {
        item: cur_node,
        x: cur_model.x,
        y: cur_model.y,
        target: this.graph.get("canvas").get("el"),
        type: "node:click",
      };
      if (this.graphTooltip) {
        this.graphTooltip.showTooltip(eventLike);
      }
    },

    refreshGraph() {
      this.graph_data.nodes.forEach((node) => {
        if (node.label === "") {
          node.label = node.name;
        } else {
          node.label = "";
        }
        node.style.fill = node.type;
        node.style["opacity"] = 1;
      });
      this.graph.data(this.graph_data);
      this.graph.render();
    },

    refreshGraph_high_degree() {
      this.graph_data.nodes.forEach((node) => {
        if (node.degree > 5) {
          node.label = node.name;
        } else {
          node.label = "";
        }
        node.style.fill = node.type;
        node.style["opacity"] = 1;
      });
      this.graph.data(this.graph_data);
      this.graph.render();

      // 设置标签已显示标志
      this.labelsShown = true;
    },

    refreshGraph_noText() {
      this.graph_data.nodes.forEach((node) => {
        node.label = "";
        node.style.fill = node.type;
        node.style["opacity"] = 1;
      });
      this.graph.data(this.graph_data);
      this.graph.render();
    },

    sparse_graph() {
      let sparse_graph_data = { nodes: this.graph_data.nodes };
      let edges_list = [];
      this.graph_data.edges.forEach((edge) => {
        if (edge.weight > 3 || edge.weight < 1) {
          edges_list.push(edge);
        }
      });
      sparse_graph_data["edges"] = edges_list;
      this.graph.data(sparse_graph_data);
      this.graph.render();
    },

    download_graph_image() {
      // this.graph.setTextWaterMarker(['Acemap DeepReport']);
      this.graph.downloadFullImage(this.keywords);
    },

    ancient_graph() {
      let ancient_graph_data = { nodes: this.graph_data.nodes };
      let edges_list = [];
      this.graph_data.edges.forEach((edge) => {
        if (edge.mark !== "highlight") {
          edges_list.push(edge);
        }
      });
      ancient_graph_data["edges"] = edges_list;
      this.graph.data(ancient_graph_data);
      this.graph.render();
    },

    handleSelectColor(item) {
      this.activeColor = item.color;
      this.graph_data.nodes.forEach((node) => {
        if (node.type !== item.color) {
          node.style.fill = "#ECF6FF";
          node.style["opacity"] = 0.3;
        } else {
          node.style.fill = node.type;
          console.log(node.style.fill);
          node.style["opacity"] = 1.0;
        }
        node.label = "";
      });
      this.graph.data(this.graph_data);
      this.graph.render();
      //this.anaNodes();
    },

    changeLayout(layout_name) {
      //const container = document.getElementById("map-panel");
      //const width = container.scrollWidth;
      //const height = container.scrollHeight || 500;
      if (layout_name === "force") {
        this.graph.updateLayout({
          type: layout_name,
          linkDistance: 100,
          //collideStrength: 0.8,
          preventOverlap: true,
        });
      } else if (layout_name === "grid") {
        this.graph.updateLayout({
          type: layout_name,
          rows: 16,
          cols: 6,
          sortBy: "degree",
        });
      } else if (layout_name === "circular") {
        this.graph.updateLayout({
          type: layout_name,
          radius: 270,
          ordering: "degree",
        });
      } else if (layout_name === "radial") {
        this.graph.updateLayout({
          type: layout_name,
          preventOverlap: true,
        });
      } else if (layout_name === "concentric") {
        this.graph.updateLayout({
          type: layout_name,
          minNodeSpacing: 8,
          linkDistance: 10,
          // equidistant: true,
          preventOverlap: true,
        });
      } else if (layout_name === "mds") {
        this.graph.updateLayout({
          type: layout_name,
          linkDistance: 100,
          preventOverlap: true,
        });
      } else if (layout_name === "fruchterman") {
        this.graph.updateLayout({
          type: layout_name,
          gravity: 10,
          speed: 5,
          clustering: true,
        });
      } else {
        this.graph.updateLayout({
          type: layout_name,
        });
      }

      this.graph.data(this.graph_data);
      this.graph.render();
    },

    get_year_graph(year) {
      let ancient_graph_data = {};
      let edges_list = [];
      let nodes_list = [];
      let nodes_id_list = [];
      this.graph_data.edges.forEach((edge) => {
        if (edge.year <= year) {
          edges_list.push(edge);
          this.graph_data.nodes.forEach((node) => {
            if (node.id === edge.source && nodes_id_list.indexOf(node.id) < 0) {
              nodes_list.push(node);
              nodes_id_list.push(node.id);
            } else if (
              node.id === edge.target &&
              nodes_id_list.indexOf(node.id) < 0
            ) {
              nodes_list.push(node);
              nodes_id_list.push(node.id);
            }
          });
        }
      });
      ancient_graph_data["edges"] = edges_list;
      ancient_graph_data["nodes"] = nodes_list;
      this.graph.data(ancient_graph_data);
      this.graph.render();
    },

    year_animate() {
      let year_ls = [
        2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026,
      ];
      this.show_year_percentage = true;
      for (let y = 0; y < year_ls.length; y++) {
        setTimeout(() => {
          this.get_year_graph(year_ls[y]);
          this.year_percentage = (y / (year_ls.length - 1)) * 100;
          if (y === year_ls.length - 1) {
            this.show_year_percentage = false;
            this.year_percentage = 0;
          }
        }, y * 2000);
      }
    },

    year_format(percentage) {
      let year_ls = [
        2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026,
      ];
      return year_ls[Math.floor((percentage / 100) * (year_ls.length - 1))];
    },

    operate_fisheye() {
      if (this.open_fisheye) {
        this.open_fisheye = false;
        this.graph.removePlugin(this.fisheye);
        this.$notify.info({
          title: this.$t("resultPage").notify.info,
          message: this.$t("resultPage").notify.fisheyeClosed,
        });
      } else {
        this.open_fisheye = true;
        this.fisheye = new G6.Fisheye({
          r: 100,
          d: 2.5,
          showLabel: true,
          delegateStyle: {
            fill: "#4ab4ff",
            lineDash: [5, 5],
            stroke: "#0090ff",
          },
        });
        this.graph.addPlugin(this.fisheye);
        this.fisheye.updateParams({
          showLabel: true,
        });
        this.$notify.info({
          title: this.$t("resultPage").notify.info,
          message: this.$t("resultPage").notify.fisheyeOpened,
        });
      }
    },

    clear_graph_states() {
      this.graph.getNodes().forEach((node) => {
        this.graph.clearItemStates(node);
      });
      this.graph.getEdges().forEach((edge) => {
        this.graph.clearItemStates(edge);
      });
    },

    download_file() {
      // 点击按钮立即显示loading状态
      this.fileLoading = true;

      // 直接点击"show labels of key nodes"按钮并生成PDF
      this.refreshGraph_high_degree();
      // 等待一段时间后生成PDF
      setTimeout(() => {
        this.generatePDF();
      }, 1000);
    },

    generatePDF() {
      // 创建PDF生成器实例
      const pdfGenerator = new PDFGenerator();

      // 准备数据
      const pdfData = {
        keywords: this.keywordsFilter(this.keywords).oriWords,
        topics_ls: this.topics_ls,
        new_relation_table: this.new_relation_table,
        infoList: this.infoList,
        conclusion_text: this.conclusion_text,
        year_freq: this.year_freq,
        graph_data: this.graph_data,
        country_stats: this.country_stats,
        instit_stats_ls: this.instit_stats_ls,
        btnList: this.btnList,
        graphElement: document.getElementById("map-panel"),
        treeData: this.spanningTree,
        mindmapContent: this.mindmapContent,
        topic_gpt_detail: this.topic_gpt_detail,
      };

      // 生成文件名
      const filename = `${this.keywords.replace(/ /g, "_")}_${
        new Date().toISOString().split("T")[0]
      }.pdf`;

      // 生成并下载PDF
      pdfGenerator
        .generateAndSave(pdfData, filename)
        .then(() => {
          this.$notify.success({
            title: this.$t("resultPage").notify.success,
            message: this.$t("resultPage").notify.pdfDownloadSuccess,
          });
        })
        .catch((error) => {
          console.error("PDF generation failed:", error);
          this.$notify.error({
            title: this.$t("resultPage").notify.error,
            message: this.$t("resultPage").notify.pdfDownloadError,
          });
        })
        .finally(() => {
          this.fileLoading = false;
        });
    },

    anaNodes() {
      this.$refs.carousel.setActiveItem(0);
    },

    anaEdges() {
      this.$refs.carousel.setActiveItem(1);
    },

    anaCommunity() {
      this.$refs.carousel.setActiveItem(2);
    },

    anaCountry() {
      this.$refs.carousel.setActiveItem(3);
    },

    initTree(spanningTree) {
      const container_tree = document.getElementById("tree-map");
      if (this.treeGraph == null) {
        const treeGraph = new G6.TreeGraph({
          container: container_tree,
          modes: {
            default: [
              {
                type: "collapse-expand",
                onChange: function onChange(item, collapsed) {
                  const data = item.getModel();
                  data.collapsed = collapsed;
                  return true;
                },
              },
              "drag-canvas",
              "zoom-canvas",
            ],
          },
          defaultNode: {
            size: 26,
            anchorPoints: [
              [0, 0.5],
              [1, 0.5],
            ],
            // 节点样式配置
            style: {
              cursor: "pointer",
              fill: document.documentElement.classList.contains("dark-mode")
                ? "#3d5a80"
                : "#c6e3ff",
              stroke: document.documentElement.classList.contains("dark-mode")
                ? "#90caf9"
                : "rgb(45, 146, 255)",
              lineWidth: 1,
            },
            // 节点上的标签文本配置
            labelCfg: {
              // 节点上的标签文本样式配置
              style: {
                fontSize: 22, // 字体大小
                fill: document.documentElement.classList.contains("dark-mode")
                  ? "#e0e0e0"
                  : "#000",
              },
            },
          },
          defaultEdge: {
            type: "cubic-horizontal",
          },
          layout: {
            type: "compactBox",
            direction: "LR",
            getId: function getId(d) {
              return d.id;
            },
            getHeight: function getHeight() {
              return 16;
            },
            getWidth: function getWidth() {
              return 16;
            },
            getVGap: function getVGap() {
              return 10;
            },
            getHGap: function getHGap() {
              return 100;
            },
          },
          fitView: "cc",
        });

        treeGraph.node(function (node) {
          const isDarkMode =
            document.documentElement.classList.contains("dark-mode");
          return {
            label: node.info.name,
            // 节点样式配置
            style: {
              cursor: "pointer",
              fill: isDarkMode ? "#3d5a80" : "#c6e3ff",
              stroke: isDarkMode ? "#90caf9" : "rgb(45, 146, 255)",
              lineWidth: 1,
            },
            // 节点上的标签文本配置
            labelCfg: {
              offset: 10,
              position:
                node.children && node.children.length > 0 ? "left" : "right",
              // 节点上的标签文本样式配置
              style: {
                fill: isDarkMode ? "#e0e0e0" : "#000",
              },
            },
          };
        });
        // 监听点击放大事件
        document
          .getElementById("treeZoomIn")
          .addEventListener("click", function () {
            treeGraph.zoom(1.2);
          });

        // 监听点击缩小事件
        document
          .getElementById("treeZoomOut")
          .addEventListener("click", function () {
            treeGraph.zoom(0.8);
          });

        document
          .getElementById("downloadTree")
          .addEventListener("click", function () {
            treeGraph.downloadFullImage(spanningTree["name"] + " Concept Flow");
          });
        this.treeGraph = treeGraph;
        treeGraph.data(spanningTree);
        treeGraph.render();
        treeGraph.fitView();
      }
    },

    resetData() {
      this.pathList = [];
      this.text = "";
      this.currentPath = null;
      this.lastNode = null;
      this.loading = false;
      this.textLoading = false;
      this.textList = [];
      // this.links = [];
      this.links = {};
      this.year_freq = [];
      this.infoList = [];
      this.spanningTree = null;
      this.new_relation_table = [];
      this.new_relation_table_status = [];
      this.year_percentage = 0;
      this.open_fisheye = false;
      this.mindmapLoading = true;
      this.percentage = 0;
      this.confidence = 0;
      this.conclusion_text = "";
      this.topics_ls = [""];
      this.knowledge_text = "";
      this.currentConcepts = "";
      this.currentSourceKnowledge = ".";
      this.currentTargetKnowledge = ".";
      this.activeKnowledgePanel = ["3"];
      this.max_degree_node = {};
      this.cloudInstance = null;
      this.gpt_response_noused = "";
      this.topic_gpt_detail = {};
      this.country_stats = null;
      this.instit_stats_ls = [];
      this.instit_url = null;
      this.instit_country = null;
      this.field2country = null;
      this.field2instit = null;
      this.btnList = [
        { type: 0, color: "#065758", text: "", maxDegree: 0 },
        { type: 0, color: "#25767B", text: "", maxDegree: 0 },
        { type: 0, color: "#44949E", text: "", maxDegree: 0 },
        { type: 0, color: "#62B3C1", text: "", maxDegree: 0 },
        { type: 0, color: "#81D2E4", text: "", maxDegree: 0 },
        { type: 0, color: "#BCEDD8", text: "", maxDegree: 0 },
      ];
      this.mindmapContent = "";
      this.paperDatasets = {};
      this.datasetsLoading = false;
      this.topicDatasets = {};
      this.topicDatasetsLoading = {};
      this.topicDatasetRequests = {};
      this.conceptDatasets = {};
    },

    replaceRouter() {
      if (this.keywords !== this.$route.query.q) {
        const path = this.$route.path;
        this.$router.replace({
          path,
          query: {
            q: this.keywords,
          },
        });
      }
    },

    querySearch(queryString, cb) {
      const hint_ls = this.hint_ls;
      var results =
        queryString && !this.lowAuth
          ? hint_ls.filter(this.createFilter(queryString))
          : hint_ls;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },

    createFilter(queryString) {
      return (hint_ls) => {
        return (
          hint_ls.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },

    getPathData() {
      if (!this.keywords) {
        this.$notify({
          title: this.$t("resultPage").notify.warning,
          message: this.$t("resultPage").notify.pleaseInputQuery,
          type: "warning",
        });
        return;
      }
      this.replaceRouter();
      this.resetData();
      this.keywords = this.keywords || this.placeholder;
      const keywords = this.keywordsFilter(this.keywords).oriWords;
      this.loading = true;
      const userLevel = Vue.$cookies.get("userLevel") || 1;
      const cur_switchValue = this.switchValue ? "informative" : "efficient";
      const baseUrlMap = {
        en: "/v1/get_report",
        cn: "/v1/get_report_zh",
      };
      const param = this.date
        ? `${
            baseUrlMap[this.language]
          }?keywords=${keywords}&limit=8&user_level=${userLevel}&mode=${cur_switchValue}&date=${
            this.date
          }`
        : `${
            baseUrlMap[this.language]
          }?keywords=${keywords}&limit=8&user_level=${userLevel}&mode=${cur_switchValue}`;

      // 在这里调接口
      getReport(param)
        .then((res) => {
          // handle success
          console.log(res.data);
          this.links = res.data.graph2;
          this.infoList = res.data.paper_ls;
          this.fieldList = res.data.fields_ls.slice(0, 50);
          this.year_freq = res.data.year_freq;
          this.graph_data = res.data.graph;
          this.spanningTree = res.data.tree;
          this.country_stats = res.data.field_stats.country_stats;
          this.instit_url = res.data.field_stats.instit_url;
          this.instit_country = res.data.field_stats.instit_country;

          this.fetchPaperDatasets();

          this.instit_stats_ls = Object.entries(
            res.data.field_stats.instit_stats
          ).map(([institName, yearData]) => {
            const value = Object.values(yearData)[0];
            // 获取原始国家值（可能为undefined、null或具体国家）
            const originalCountry = this.instit_country[institName];
            // 处理：机构名不存在于instit_country中，或国家值为null，均用ROW替代
            const country =
              this.instit_country.hasOwnProperty(institName) &&
              originalCountry !== null
                ? originalCountry
                : "ROW";
            // 根据系统类型显示emoji或SVG国旗
            let countryDisplay;
            if (this.isWindowsOS()) {
              // Windows系统下显示SVG国旗图标
              countryDisplay = `<img src="/flagIcon/${country.toLowerCase()}.svg" alt="${country}" style="width: 16px; height: 16px; margin-right: 4px; vertical-align: middle;"> ${country}`;
            } else {
              // 非Windows系统下显示emoji
              const emoji = countryEmojis.hasOwnProperty(country)
                ? countryEmojis[country]
                : "🇺🇳";
              countryDisplay = `${emoji} ${country}`;
            }
            return {
              instit: institName,
              count: value,
              url: this.instit_url[institName],
              country: countryDisplay,
            };
          });
          this.field2country = res.data.field_stats.field2country;
          this.field2instit = res.data.field_stats.field2instit;

          this.initMap(this.graph_data);
          this.loading = false;
          this.textLoading = false;

          for (let i = 0; i < this.graph_data.edges.length; i++) {
            if (this.graph_data.edges[i].mark === "highlight") {
              let cur_edge_info = this.graph_data.edges[i];
              let original_source_name = cur_edge_info["source_name"];
              let original_target_name = cur_edge_info["target_name"];

              cur_edge_info["source_sentences"] =
                res.data.new_rel2paper_text[original_source_name];
              cur_edge_info["target_sentences"] =
                res.data.new_rel2paper_text[original_target_name];
              cur_edge_info["source_sentences"] = this.uniqueArray(
                cur_edge_info["source_sentences"]
              );
              cur_edge_info["target_sentences"] = this.uniqueArray(
                cur_edge_info["target_sentences"]
              );
              if (
                cur_edge_info["source_sentences"].length > 0 &&
                cur_edge_info["target_sentences"].length > 0
              ) {
                this.new_relation_table.push(cur_edge_info);
                this.new_relation_table_status.push(0);
              }
            }
          }

          for (let i = 0; i < this.graph_data.edges.length; i++) {
            let edge = this.graph_data.edges[i];

            let sourceNode = this.graph_data.nodes.find(
              (node) => node.id === edge.source
            );
            let targetNode = this.graph_data.nodes.find(
              (node) => node.id === edge.target
            );

            if (sourceNode) {
              edge.source_name = sourceNode.name;
            }
            if (targetNode) {
              edge.target_name = targetNode.name;
            }
          }

          const updateTreeNodeNames = (node) => {
            if (node && node.id) {
              const graphNode = this.graph_data.nodes.find(
                (n) => n.id === node.id
              );
              if (graphNode) {
                node.info.name = graphNode.name;
              }
            }
            if (node.children && node.children.length > 0) {
              node.children.forEach((child) => updateTreeNodeNames(child));
            }
          };

          if (this.spanningTree) {
            updateTreeNodeNames(this.spanningTree);
          }
          this.btnList = [
            { type: 0, color: "#065758", text: "", maxDegree: 0 },
            { type: 0, color: "#25767B", text: "", maxDegree: 0 },
            { type: 0, color: "#44949E", text: "", maxDegree: 0 },
            { type: 0, color: "#62B3C1", text: "", maxDegree: 0 },
            { type: 0, color: "#81D2E4", text: "", maxDegree: 0 },
            { type: 0, color: "#BCEDD8", text: "", maxDegree: 0 },
          ];
          for (let i = 0; i < this.graph_data.nodes.length; i++) {
            for (let j = 0; j < this.btnList.length; j++) {
              if (
                this.btnList[j].color === this.graph_data.nodes[i].style.fill
              ) {
                this.btnList[j].type += 1;
                if (this.btnList[j].text.split(",").length < 3) {
                  if (
                    this.graph_data.nodes[i].degree > this.btnList[j].maxDegree
                  ) {
                    this.btnList[j].text = this.graph_data.nodes[i].name;
                    this.btnList[j].maxDegree = this.graph_data.nodes[i].degree;
                  }
                }
                break;
              }
            }
          }
          this.initNodeBarYear(this.year_freq);
          this.initNodeBarPaper(this.graph_data);
          this.initNodePie(this.btnList);
          this.initCountryBar(this.country_stats);
          this.max_degree_node = this.graph_data.nodes.reduce(
            (max, current) => {
              return current.degree > max.degree ? current : max;
            },
            this.graph_data.nodes[0]
          ).name;
          this.refreshGraph_noText();
          this.initRelationCloud();
          this.getConclusion();
        })
        .catch((e) => {
          this.loading = false;
          this.percentage = 0;
          if (this.timer) {
            clearInterval(this.timer);
          }
          this.$notify({
            title: this.$t("resultPage").notify.warning,
            message: this.$t("resultPage").notify.changeQueryOrJoinList,
            type: "warning",
          });
          this.$router.push("/");
          console.log(e);
        });
    },

    getConclusion() {
      this.timer = setInterval(this.addPercentage, 300);
      this.keywords = this.keywords || this.placeholder;
      const keywords = this.keywordsFilter(this.keywords).oriWords;
      const cur_switchValue = this.switchValue ? "informative" : "efficient";
      const userLevel = Vue.$cookies.get("userLevel") || 1;
      const param = this.date
        ? `keywords=${keywords}&limit=8&user_level=${userLevel}&mode=${cur_switchValue}&date=${this.date}`
        : `keywords=${keywords}&limit=8&user_level=${userLevel}&mode=${cur_switchValue}`;
      // 在这里调接口
      getConclusion(param)
        .then((res) => {
          // handle success
          this.percentage = 100;
          //const cur_raw_resp = JSON.parse(res.data.conclusion);
          const cur_raw_resp = this.fixAndParseJson(res.data.conclusion);
          this.conclusion_text = cur_raw_resp["conclusions"];
          this.topics_ls = cur_raw_resp["topics"];
          this.confidence = res.data.confidence || 80;
          this.percentage = 0;
          this.highlightString(this.conclusion_text, "conclusion_sec");

          this.translateTopics();
          this.translateConclusion();

          if (this.timer) {
            clearInterval(this.timer);
          }

          // 获取结论后自动生成思维导图内容
          this.generateMindmapContent();
        })
        .catch((error) => {
          this.loading = false;
          this.percentage = 0;
          this.conclusion_text =
            "Please upgrade your user plan and join the waiting list. Knowledge Conclusion summarizes insights and opinions from the related papers.\n" +
            "Reliability Score: Deep Report comprehensively considers the characteristics of each dimension of the papers it studies and scores the generated summary.";
          this.confidence = 100;
          if (this.timer) {
            clearInterval(this.timer);
          }
          this.$notify({
            title: this.$t("resultPage").notify.error,
            message: error,
            type: "error",
          });
        });
    },

    getKnowledge(concepts, sentence1, sentence2, index, mode) {
      this.timer = setInterval(this.addPercentage, 300);
      const param = `concepts=${concepts}&sentence1=${sentence1}&sentence2=${sentence2}`;
      this.knowledge_text = "Generated Idea: Please wait a minute.";
      this.isAgree = -1;
      const e_param = `url_type=k&keywords=${concepts}&sentence1=${sentence1}&sentence2=${sentence2}`;

      if (mode === "eval") {
        getEvaluate(e_param).then((res) => {
          if (res.data.status === 200) {
            this.isAgree = res.data.data.highlight || -1;
          }
        });
      }

      getKnowledge(param)
        .then((res) => {
          // handle success
          // 设置关键字高亮
          let originText = res.data.knowledge;
          let keywords = [this.currentSourceName, this.currentTargetName];
          let regex = new RegExp("(" + keywords.join("|") + ")", "g");
          let highlightText = originText.replace(regex, "$1");

          // 改进的编号分隔逻辑：支持"Using 1. the first paragraph, 2. the second paragraph"格式
          // 匹配所有以数字开头的编号，包括"Using 1.", "2.", "3."等
          let numRegex = /(?<!Using\s)\b(\d+\.)\s*/g;
          let highlightText2 = highlightText.replace(numRegex, "<br/><br/>$1 ");
          const processedText = highlightText2.replace(/\*\*/g, "");
          this.knowledge_text = processedText;

          // 将知识文本保存到对应的连接记录中
          if (this.new_relation_table[index]) {
            this.new_relation_table[index].knowledge_text = processedText;
          }

          this.translateKnowledge();

          console.log(
            "currentSourceName",
            this.currentSourceName,
            this.currentTargetName
          );
          // this.showKnowledgeDialog = true;
          this.$set(this.new_relation_table_status, index, 2);
          // this.new_relation_table_status[index] = 2;
          if (this.timer) {
            clearInterval(this.timer);
          }
          window.scrollTo(0, 0);
        })
        .catch((error) => {
          if (this.timer) {
            clearInterval(this.timer);
          }
          this.$set(this.new_relation_table_status, index, 3);
          // this.new_relation_table_status[index] = 3;
          console.log("error", error);
          this.$notify({
            title: this.$t("resultPage").notify.warning,
            message: this.$t("resultPage").notify.pleaseSignIn,
            type: "warning",
          });
        });
    },

    getGPT(user_messages) {
      return new Promise((resolve, reject) => {
        this.timer = setInterval(this.addPercentage, 300);
        const param = `user_messages=${user_messages}`;

        getGPT(param)
          .then((res) => {
            if (this.timer) {
              clearInterval(this.timer);
            }
            resolve(res.data.gpt_response); // 用resolve返回结果
          })
          .catch((error) => {
            if (this.timer) {
              clearInterval(this.timer);
            }
            this.$notify({
              title: this.$t("resultPage").notify.error,
              message: error,
              type: "error",
            });
            reject("Please upgrade your user plan and join the waiting list."); // 用reject返回错误
          });
      });
    },

    normalizeDataset(dataset, source = "keyword") {
      if (!dataset) {
        return null;
      }

      const title = dataset.title || dataset.name || dataset.url || "Untitled";
      const url = dataset.true_url || dataset.url || "";
      const key = (
        dataset.url_md5 ||
        dataset.doi ||
        url ||
        title
      ).toLowerCase();

      return {
        key,
        title,
        url,
        desc: dataset.desc || dataset.description || "",
        source,
      };
    },

    mergeDatasets(...datasetLists) {
      const seen = new Set();
      const merged = [];

      datasetLists.flat().forEach((dataset) => {
        const normalized = this.normalizeDataset(
          dataset,
          dataset && dataset.source
        );
        if (!normalized || seen.has(normalized.key)) {
          return;
        }
        seen.add(normalized.key);
        merged.push(normalized);
      });

      return merged;
    },

    async fetchDatasetsByKeyword(
      keyword,
      size = this.datasetRecommendationSize
    ) {
      if (!keyword) {
        return [];
      }

      const data = await searchCnsDatasets({
        keyword,
        page: 1,
        size,
      });

      return ((data && data.results) || [])
        .map((dataset) => this.normalizeDataset(dataset, "keyword"))
        .filter(Boolean);
    },

    extractDoiFromPaper(paper) {
      if (!paper) {
        return null;
      }

      const candidates = [paper.doi, paper.url, paper.true_url, paper.link]
        .filter(Boolean)
        .map((value) => decodeURIComponent(String(value).trim()));

      for (const candidate of candidates) {
        if (!candidate || candidate.toUpperCase() === "NONE") {
          continue;
        }

        const doiUrlMatch = candidate.match(/doi\.org\/(.+)$/i);
        const rawDoi = doiUrlMatch ? doiUrlMatch[1] : candidate;
        const doiMatch = rawDoi.match(/10\.\d{4,9}\/[^\s?#]+/i);

        if (doiMatch) {
          return doiMatch[0].replace(/[.,;)]$/, "");
        }
      }

      return null;
    },

    async fetchDatasetsByDois(dois) {
      const originalDois = [...new Set((dois || []).filter(Boolean))];
      if (!originalDois.length) {
        return [];
      }

      const allDois = [];
      originalDois.forEach((doi) => {
        allDois.push(doi);
        allDois.push(doi.toUpperCase());
        allDois.push(doi.toLowerCase());
      });

      const data = await getPaperDatasets([...new Set(allDois)]);
      const datasets = [];

      ((data && data.results) || []).forEach((paper) => {
        ((paper && paper.datasets) || []).forEach((dataset) => {
          datasets.push(this.normalizeDataset(dataset, "paper"));
        });
      });

      return this.mergeDatasets(datasets);
    },

    getNodeRelatedPaperDois(model) {
      const papers =
        (model && model.properties && model.properties.paper_text) || [];
      return papers
        .map((paper) => this.extractDoiFromPaper(paper))
        .filter(Boolean);
    },

    getConceptDatasetCacheKey(model) {
      const conceptName = (model && (model.name || model.label)) || "";
      const dois = this.getNodeRelatedPaperDois(model).sort().join("|");
      return `${conceptName.toLowerCase()}::${dois.toLowerCase()}`;
    },

    async fetchConceptDatasets(model) {
      const cacheKey = this.getConceptDatasetCacheKey(model);
      if (this.conceptDatasets[cacheKey]) {
        return this.conceptDatasets[cacheKey];
      }

      const conceptName = (model && (model.name || model.label)) || "";
      const dois = this.getNodeRelatedPaperDois(model);
      const [keywordDatasets, paperDatasets] = await Promise.all([
        this.fetchDatasetsByKeyword(
          conceptName,
          this.datasetRecommendationSize
        ).catch(() => []),
        this.fetchDatasetsByDois(dois).catch(() => []),
      ]);
      const merged = this.mergeDatasets(paperDatasets, keywordDatasets).slice(
        0,
        this.datasetRecommendationSize
      );

      this.$set(this.conceptDatasets, cacheKey, merged);
      return merged;
    },

    renderConceptDatasetRecommendations(model, contentList, isDarkMode) {
      const title = document.createElement("div");
      title.className = "concept-datasets-title";
      title.style.fontSize = "16px";
      title.style.fontWeight = "600";
      title.style.marginBottom = "16px";
      title.style.paddingLeft = "8px";
      title.style.borderLeft = "3px solid #67c23a";
      title.style.color = isDarkMode ? "#e0e0e0" : "#333";
      title.textContent = "Recommended Datasets";

      const section = document.createElement("div");
      section.className = "concept-datasets-section";
      section.style.marginBottom = "8px";
      section.style.padding = "16px";
      section.style.borderRadius = "12px";
      section.style.background = isDarkMode
        ? "rgba(60, 60, 60, 0.5)"
        : "rgba(247, 250, 252, 0.6)";
      section.style.backdropFilter = "blur(10px)";

      const loading = document.createElement("div");
      loading.className = "dataset-loading";
      loading.style.fontSize = "13px";
      loading.style.color = isDarkMode ? "#aaa" : "#666";
      loading.textContent = "Searching CNS datasets...";
      section.appendChild(loading);

      contentList.appendChild(title);
      contentList.appendChild(section);

      this.fetchConceptDatasets(model)
        .then((datasets) => {
          section.innerHTML = "";

          if (!datasets.length) {
            const empty = document.createElement("div");
            empty.className = "dataset-empty";
            empty.style.fontSize = "13px";
            empty.style.color = isDarkMode ? "#aaa" : "#909399";
            empty.textContent = "No matched CNS datasets.";
            section.appendChild(empty);
            return;
          }

          datasets.forEach((dataset) => {
            const link = document.createElement("a");
            link.className = "concept-dataset-link";
            link.href = dataset.url || "#";
            link.target = "_blank";
            link.style.display = "block";
            link.style.marginBottom = "10px";
            link.style.padding = "10px 12px";
            link.style.borderRadius = "8px";
            link.style.textDecoration = "none";
            link.style.background = isDarkMode
              ? "rgba(80, 80, 80, 0.45)"
              : "rgba(255, 255, 255, 0.75)";
            link.style.color = isDarkMode ? "#90caf9" : "#007bff";
            link.style.boxShadow = isDarkMode
              ? "0 2px 8px rgba(0, 0, 0, 0.2)"
              : "0 2px 8px rgba(0, 0, 0, 0.05)";

            const datasetTitle = document.createElement("div");
            datasetTitle.style.fontSize = "13px";
            datasetTitle.style.fontWeight = "600";
            datasetTitle.style.lineHeight = "1.4";
            datasetTitle.textContent = dataset.title;
            link.appendChild(datasetTitle);

            if (dataset.desc) {
              const desc = document.createElement("div");
              desc.style.marginTop = "4px";
              desc.style.fontSize = "11px";
              desc.style.lineHeight = "1.4";
              desc.style.color = isDarkMode ? "#bbb" : "#666";
              desc.style.display = "-webkit-box";
              desc.style.setProperty("-webkit-line-clamp", "2");
              desc.style.setProperty("-webkit-box-orient", "vertical");
              desc.style.overflow = "hidden";
              desc.textContent = dataset.desc;
              link.appendChild(desc);
            }

            section.appendChild(link);
          });
        })
        .catch(() => {
          section.innerHTML = "";
          const error = document.createElement("div");
          error.style.fontSize = "13px";
          error.style.color = "#f56c6c";
          error.textContent = "Failed to load CNS datasets.";
          section.appendChild(error);
        });
    },

    getTopicDatasets(item) {
      return this.topicDatasets[item] || [];
    },

    hasTopicDatasetResult(item) {
      return Object.prototype.hasOwnProperty.call(this.topicDatasets, item);
    },

    async fetchFutureDirectionDatasets(item) {
      if (!item) {
        return [];
      }
      if (this.topicDatasets[item]) {
        return this.topicDatasets[item];
      }
      if (this.topicDatasetRequests[item]) {
        return this.topicDatasetRequests[item];
      }

      this.$set(this.topicDatasetsLoading, item, true);
      const request = (async () => {
        const datasets = await this.fetchDatasetsByKeyword(
          item,
          this.datasetRecommendationSize
        );
        this.$set(this.topicDatasets, item, datasets);
        return datasets;
      })();

      this.$set(this.topicDatasetRequests, item, request);
      try {
        return await request;
      } catch (error) {
        this.$set(this.topicDatasets, item, []);
        return [];
      } finally {
        this.$set(this.topicDatasetsLoading, item, false);
        this.$delete(this.topicDatasetRequests, item);
      }
    },

    handleFutureDirectionToggle(event, item) {
      if (event && event.target && event.target.open) {
        this.getFutureDirectionDetail(item);
        this.fetchFutureDirectionDatasets(item);
      }
    },

    async fetchPaperDatasets() {
      console.log("infoList sample:", this.infoList.slice(0, 3));

      const doiMapping = {};
      this.infoList.forEach((item) => {
        let doi = item.doi;

        if (!doi && item.url) {
          if (item.url.includes("doi.org/")) {
            const match = item.url.match(/doi\.org\/(.+)/i);
            doi = match ? match[1] : null;
          } else if (item.url.match(/^10\.\d{4,}\//)) {
            doi = item.url;
          }
        }

        if (doi) {
          doiMapping[doi.toLowerCase()] = doi;
        }
      });

      const originalDois = Object.values(doiMapping);

      const allDois = [];
      originalDois.forEach((doi) => {
        allDois.push(doi);
        allDois.push(doi.toUpperCase());
        allDois.push(doi.toLowerCase());
      });

      console.log("Original DOIs:", originalDois);
      console.log("All DOIs (with cases):", allDois);

      if (allDois.length === 0) {
        console.log("No DOIs found in paper list");
        return;
      }

      try {
        this.datasetsLoading = true;
        const data = await getPaperDatasets(allDois);

        if (data && data.results && data.results.length > 0) {
          const datasetsMap = {};
          data.results.forEach((paper) => {
            if (paper.datasets && paper.datasets.length > 0) {
              datasetsMap[paper.doi.toLowerCase()] = paper.datasets.map(
                (ds) => ({
                  title: ds.title,
                  url: ds.url,
                  desc: ds.desc,
                })
              );
            }
          });
          this.paperDatasets = datasetsMap;
        }
      } catch (error) {
      } finally {
        this.datasetsLoading = false;
      }
    },

    getPaperDatasetsByUrl(url) {
      if (!url) {
        return [];
      }

      let doi = null;

      if (url.includes("doi.org/")) {
        const match = url.match(/doi\.org\/(.+)/i);
        doi = match ? match[1] : null;
      } else if (url.match(/^10\.\d{4,}\//)) {
        doi = url;
      }

      if (!doi) {
        return [];
      }

      return this.paperDatasets[doi.toLowerCase()] || [];
    },

    getPaperDatasets(item) {
      if (!item) return [];

      let doi = item.doi;

      if (!doi && item.url) {
        if (item.url.includes("doi.org/")) {
          const match = item.url.match(/doi\.org\/(.+)/i);
          doi = match ? match[1] : null;
        } else if (item.url.match(/^10\.\d{4,}\//)) {
          doi = item.url;
        }
      }

      if (!doi) return [];

      return this.paperDatasets[doi.toLowerCase()] || [];
    },

    async getFutureDirectionDetail(item) {
      this.fetchFutureDirectionDatasets(item);
      if (item in this.topic_gpt_detail) {
        return this.topic_gpt_detail[item];
      } else {
        try {
          let gpt_res = await this.getGPT(
            "You are my professor, help me expand the future research direction (300 words limited, do not use markdown, do not write background and related work, just the detailed idea).\n The future research direction is:" +
              item
          );
          // 可以在这里缓存结果
          this.$set(this.topic_gpt_detail, item, gpt_res);
          return gpt_res;
        } catch (error) {
          return error; // 返回错误信息
        }
      }
    },

    async expandTopicDetail(item) {
      // 设置对话框标题
      this.currentTopicDetail = {
        title: item,
        content: "",
        datasets: this.getTopicDatasets(item),
        datasetsLoading: !this.topicDatasets[item],
        datasetsLoaded: this.hasTopicDatasetResult(item),
      };
      this.showTopicDetailDialog = true;

      // 获取详细内容
      try {
        const [content, datasets] = await Promise.all([
          this.getFutureDirectionDetail(item),
          this.fetchFutureDirectionDatasets(item),
        ]);
        this.currentTopicDetail.content = content;
        this.currentTopicDetail.datasets = datasets;
        this.currentTopicDetail.datasetsLoading = false;
        this.currentTopicDetail.datasetsLoaded = true;
      } catch (error) {
        this.currentTopicDetail.content = "获取详情失败，请稍后重试。";
        this.currentTopicDetail.datasetsLoading = false;
        this.currentTopicDetail.datasetsLoaded = true;
      }
    },

    copyResponse() {
      this.$notify({
        title: this.$t("resultPage").notify.success,
        message: this.$t("resultPage").notify.contentCopied,
        type: "success",
      });
    },

    giveEvaluate(flag) {
      if (!this.currentTargetKnowledge || !this.currentSourceKnowledge) {
        // remove  || this.currentSourceKnowledge === '.' || this.currentTargetKnowledge ==='.'
        this.$notify({
          title: this.$t("resultPage").notify.warning,
          message: this.$t("resultPage").notify.pleaseSelectPrompts,
          type: "warning",
        });
        return;
      }
      if (!this.knowledge_text) {
        this.$notify({
          title: this.$t("resultPage").notify.warning,
          message: this.$t("resultPage").notify.noGeneratedTexts,
          type: "warning",
        });
        return;
      }
      const param = {
        keywords: this.currentConcepts,
        sentence1: this.currentSourceKnowledge,
        sentence2: this.currentTargetKnowledge,
        verb: flag,
        highlight: this.isAgree,
        url_type: "k",
      };
      console.log("param", param);
      giveEvaluate(param).then((res) => {
        if (res.data.status === 200) {
          this.isAgree = flag;
          this.$notify({
            title: this.$t("resultPage").notify.success,
            message: this.$t("resultPage").notify.thanksForFeedback,
            type: "success",
          });
        }
      });
    },
    changeLanguage(lang) {
      this.$i18n.locale = lang;
      this.$store.commit("SET_LANGUAGE", lang);
    },
    searchReport() {
      this.changeLanguage("en");
      this.getPathData();
    },
    redirectPaper(item) {
      if (item.url) {
        window.open(item.url);
      }
    },
    addPercentage() {
      if (this.percentage < 99) {
        const data = Math.round(Math.random() + 3);
        this.percentage =
          this.percentage + data < 99 ? this.percentage + data : 99;
      }
    },
    showPercentage() {
      return `${this.confidence}`;
    },

    handleNewRel(index, row) {
      if (this.lowAuth) {
        this.$notify({
          title: this.$t("resultPage").notify.warning,
          message: this.$t("resultPage").notify.joinWaitingList,
          type: "warning",
        });
        return;
      }
      this.selectedEdge_name = {
        source: row.source_name,
        target: row.target_name,
      };
      const keywords = this.keywordsFilter(this.keywords).oriWords;
      let concepts = keywords + "@" + row.source_name + "@" + row.target_name;
      this.currentConcepts = concepts;
      this.currentSourceName = row.source_name;
      this.currentTargetName = row.target_name;
      this.graph_data.edges.forEach((edge) => {
        if (edge.mark === "highlight") {
          edge.style.stroke = "#565656";
          edge.style.lineWidth = 1;
          edge.style.opacity = 0.5;
          if (
            edge.source_name === row.source_name &&
            edge.target_name === row.target_name
          ) {
            edge.style.stroke = "#000000";
            edge.style.lineWidth = 2;
            edge.style.opacity = 0.8;
          }
        }
      });
      this.graph_data.nodes.forEach((node) => {
        if (node.name === row.source_name || node.name === row.target_name) {
          node.label = node.name;
        } else {
          node.label = "";
        }
      });
      this.graph.data(this.graph_data);
      this.graph.render();
      if (
        this.currentSourceKnowledge !== "." &&
        this.currentSourceKnowledge
          .toLowerCase()
          .indexOf(row.source_name.toLowerCase()) === -1
      ) {
        this.currentSourceKnowledge = ".";
        this.$notify({
          title: this.$t("resultPage").notify.warning,
          message: this.$t("resultPage")
            .notify.promptsRemoved.replace("{source}", row.source_name)
            .replace("{target}", row.target_name),
          type: "warning",
        });
      }
      if (
        this.currentTargetKnowledge !== "." &&
        this.currentTargetKnowledge
          .toLowerCase()
          .indexOf(row.target_name.toLowerCase()) === -1
      ) {
        this.currentTargetKnowledge = ".";
      }
      if (this.showKnowledgeDialog === true) {
        this.$set(this.new_relation_table_status, index, 1);
        this.activeKnowledgePanel = ["3"];
        this.getKnowledge(
          concepts,
          this.currentSourceKnowledge,
          this.currentTargetKnowledge,
          index,
          "eval"
        );
      }
    },

    handleSingleNewRel(index, row) {
      const keywords = this.keywordsFilter(this.keywords).oriWords;
      let concepts = keywords + "@" + row.source_name + "@" + row.target_name;
      this.currentConcepts = concepts;
      this.graph_data.edges.forEach((edge) => {
        if (edge.mark === "highlight") {
          edge.style.stroke = "#565656";
          edge.style.lineWidth = 1;
          edge.style.opacity = 0.5;
          if (
            edge.source_name === row.source_name &&
            edge.target_name === row.target_name
          ) {
            edge.style.stroke = "#000000";
            edge.style.lineWidth = 2;
            edge.style.opacity = 0.8;
          }
        }
      });
      this.graph_data.nodes.forEach((node) => {
        if (node.name === row.source_name || node.name === row.target_name) {
          node.label = node.name;
        } else {
          node.label = "";
        }
      });
      this.graph.data(this.graph_data);
      this.graph.render();
      this.getKnowledge(concepts, ".", ".", index, "single");
    },

    handleTableRelClick(row) {
      this.graph_data.nodes.forEach((node) => {
        if (node.name === row.source_name || node.name === row.target_name) {
          node.label = node.name;
        } else {
          node.label = "";
        }
      });
      this.graph.data(this.graph_data);
      this.graph.render();

      let cur_edge = this.graph.findById(row.id);
      let cur_model = cur_edge.getModel();

      let eventLike = {
        item: cur_edge,
        x: cur_model.x,
        y: cur_model.y,
        target: this.graph.get("canvas").get("el"),
        type: "edge:click",
      };
      if (this.graphTooltip) {
        this.graphTooltip.showTooltip(eventLike);
      }
    },

    handleTableNodeClick(row) {
      this.graph_data.nodes.forEach((node) => {
        if (node.name === row.name) {
          node.label = node.name;
        } else {
          node.label = "";
        }
      });
      this.graph.data(this.graph_data);
      this.graph.render();

      let cur_node = this.graph.findById(row.id);
      let cur_model = cur_node.getModel();

      let eventLike = {
        item: cur_node,
        x: cur_model.x,
        y: cur_model.y,
        target: this.graph.get("canvas").get("el"),
        type: "node:click",
      };
      if (this.graphTooltip) {
        this.graphTooltip.showTooltip(eventLike);
      }
    },

    // keywords过滤
    keywordsFilter(words) {
      const lower = words.toLowerCase();
      // 是否为敏感词
      let isSensitive = false;
      // 含有‘debug’字样的删除‘debug’字样
      let oriWords = words;
      this.sensitiveWords.forEach((i) => {
        if (lower.match(i)) {
          if (words.search("debug") === 0) {
            oriWords = words.replace("debug", "");
          } else {
            isSensitive = true;
          }
        }
      });
      return {
        isSensitive,
        oriWords,
      };
    },

    showTreeDiagram() {
      this.showSpanningTreeDialog = true;
      this.$nextTick(() => {
        if (this.treeGraph) {
          this.treeGraph.data(this.spanningTree);
          this.treeGraph.render();
          this.treeGraph.fitView();
          return;
        } else {
          this.initTree(this.spanningTree);
        }
      });
    },

    show_tooltip() {
      this.tooltip_disable = !this.tooltip_disable;
      this.tooltip_visible = !this.tooltip_visible;
    },

    openFeedbackDialog() {
      if (!Vue.$cookies.get("accessToken")) {
        // 如果没有登录态则跳转登录
        // this.$router.push("signin");
        this.$message({
          message: "Please log in first!",
          type: "warning",
        });
        return;
      }
      this.feedbackDialogVisible = true;
    },

    capitalized(stringx) {
      const capitalizedFirst = stringx[0].toUpperCase();
      const rest = stringx.slice(1);
      return capitalizedFirst + rest;
    },

    //highlight string according to the keywords and insert it into the html
    highlightString(text, elementID) {
      // Escape HTML in the original text to prevent XSS and quote issues
      const escapeHTML = (str) =>
        str.replace(
          /[&<>'"]/g,
          (tag) =>
            ({
              "&": "&amp;",
              "<": "&lt;",
              ">": "&gt;",
              "'": "&#39;",
              '"': "&quot;",
            }[tag] || tag)
        );

      const escapedText = escapeHTML(text);
      const lower = escapedText.toLowerCase();
      let newString = escapedText;

      const colors = [
        "rgba(235, 245, 255, 0.2)",
        "rgba(198, 227, 255, 0.2)",
        "rgba(235, 245, 255, 0.2)",
        "rgba(198, 227, 255, 0.2)",
        "rgba(235, 245, 255, 0.2)",
        "rgba(198, 227, 255, 0.2)",
      ];

      // Split sentences while preserving the delimiter
      const sentences = newString.split(/(?<=\.)\s+/);

      let styledText = "";
      sentences.forEach((sentence, index) => {
        const color = colors[index % colors.length];
        styledText += `<span class="conclusion_sec" style="background-color: ${color}; padding: 5px 10px; display: inline-block; border-radius: 5px; line-height: 27px; font-weight: 400; word-spacing: 2.5px;">${sentence.trim()}</span>`;

        // Add space after sentence except the last one
        if (index < sentences.length - 1) {
          styledText += " ";
        }
      });

      // Process each field for highlighting
      this.fieldList.forEach((field) => {
        const escapedField = escapeHTML(field);
        const lowerField = escapedField.toLowerCase();

        if (lower.includes(lowerField)) {
          // Use word boundaries to ensure whole word matching
          const regex = new RegExp(
            `\\b${escapedField.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&")}\\b`,
            "gi"
          );

          styledText = styledText.replace(
            regex,
            `<span style="border-radius: 3px; font-weight: bold; padding: 1px">$&</span>`
          );
        }
      });

      document.getElementById(elementID).innerHTML = styledText;
    },

    handleCurrentKnowledge(pos, val, name, index, row) {
      this.currentRow = {
        index,
        row,
      };
      val = this.capitalized(val);
      if (pos === "source") {
        this.currentSourceKnowledge = val;
        this.currentSourceName = name;
        this.currentSourceContent = val;
        if (this.activeKnowledgePanel.indexOf("1") === -1) {
          this.activeKnowledgePanel.push("1");
        }
      } else {
        this.currentTargetKnowledge = val;
        this.currentTargetName = name;
        this.currentTargetContent = val;
        if (this.activeKnowledgePanel.indexOf("2") === -1) {
          this.activeKnowledgePanel.push("2");
        }
      }
    },

    openKnowledgeDialog() {
      this.showKnowledgeDialog = true;
    },

    closeTreeDiagram() {
      this.showSpanningTreeDialog = false;
    },

    closeKnowledgeDiagram() {
      this.showKnowledgeDialog = false;
    },

    closeMindmapFullscreen() {
      this.showMindmapFullscreenDialog = false;
    },

    openMindmapFullscreen() {
      this.showMindmapFullscreenDialog = true;
    },

    // 生成思维导图内容的方法
    async generateMindmapContent() {
      this.mindmapLoading = true;
      try {
        // 获取论文数据
        const papers = this.infoList || [];

        if (papers.length === 0) {
          this.updateMindmapContent(`## **${
            this.keywords || "Current Topic"
          } - Research Overview**

### **Data Loading**
- Generating research overview mindmap
- Please wait...`);
          return;
        }

        // 提取高引用论文和部分普通论文
        const highCitePapers = papers.filter((p) => p.high_cite).slice(0, 5);
        const normalPapers = papers.filter((p) => !p.high_cite).slice(0, 3);
        let selectedPapers = [...highCitePapers, ...normalPapers];

        if (selectedPapers.length === 0) {
          selectedPapers = papers.slice(0, 10);
        }

        // 准备发送给GPT的论文信息
        const papersInfo = selectedPapers.map((paper) => {
          return {
            title: paper.title || "No Title",
            abstract: paper.abstract || "No Abstract",
            year: paper.year || "Unknown",
            citations: paper.citations || 0,
            high_cite: paper.high_cite || false,
          };
        });

        // 构建GPT提示词
        const prompt = `Generate a structured mindmap in English for the research topic "${
          this.keywords || "Current Topic"
        }" based on the following papers. 

IMPORTANT INSTRUCTIONS:
- Output ONLY the markdown mindmap content, no explanations, questions, or additional text
- Use exactly the format specified below
- Do not include any introductory phrases like "Here is", "Below is", or similar
- Do not ask questions about preferences or tools
- Start directly with the markdown content
- Maximum depth: 4 levels only (from # to ####)
- Final bullet points can be longer and more detailed

Research Topic: ${this.keywords || "Current Topic"}

Papers:
${papersInfo
  .map((paper, index) => `${paper.title.replace(/<[^>]*>/g, "")}`)
  .join("\n")}

REQUIRED FORMAT:
# ${this.keywords || "Current Topic"}

## Research Overview

### Current Research Status
#### Main focus areas (provide detailed descriptions, up to 40 words)
#### Key methodologies (describe methods in detail, up to 40 words)
#### Recent developments (include recent advances, up to 40 words)

### Future Trends
#### Emerging directions (provide detailed analysis, up to 40 words)
#### Potential applications (describe potential uses, up to 40 words)

Focus on breadth rather than depth. Make the final bullet points more detailed and comprehensive.`;
        // console.log(prompt);
        // 调用GPT API获取分析结果
        const gptResponse = await this.getGPT(prompt);
        // console.log('GPT', gptResponse);
        // 检查GPT响应是否包含错误信息
        if (
          gptResponse &&
          gptResponse.includes("Please upgrade your user plan")
        ) {
          // 生成默认的思维导图内容，不依赖GPT
          const defaultContent = this.generateDefaultMindmapContent(papersInfo);
          this.updateMindmapContent(defaultContent);

          // 显示友好的提示信息
          this.$notify({
            title: "Info",
            message:
              "Using default research analysis. GPT features require subscription.",
            type: "info",
          });
        } else {
          // 更新Mindmap组件的内容
          this.updateMindmapContent(gptResponse);
        }

        // 完成后设置loading为false
        this.mindmapLoading = false;
      } catch (error) {
        //console.error('Failed to generate mindmap content:', error);
        // 出错时设置空内容，通过shouldShowMindmap计算属性自动隐藏思维导图
        //this.updateMindmapContent('');
      } finally {
        // 无论成功还是失败，都确保loading为false
        this.mindmapLoading = false;
      }
    },

    // 更新Mindmap组件内容的方法
    updateMindmapContent(content) {
      // 更新组件的mindmapContent数据属性，这样全屏对话框中的Mindmap组件也能获取到最新内容
      this.mindmapContent = content;

      // 通过ref获取Mindmap组件实例并更新内容
      if (this.$refs.mindmapRef) {
        this.$refs.mindmapRef.markdownContent = content;
        this.$refs.mindmapRef.updateMindmap();
      }
    },

    // 生成默认思维导图内容的方法（当GPT API不可用时使用）
    generateDefaultMindmapContent(papersInfo) {
      const topic = this.keywords || "Current Topic";

      // 提取关键信息
      const titles = papersInfo.map((p) => p.title).slice(0, 5);
      const years = papersInfo
        .map((p) => p.year)
        .filter((y) => y !== "Unknown");
      const recentYear = years.length > 0 ? Math.max(...years) : "Recent";
      const highCiteCount = papersInfo.filter((p) => p.high_cite).length;

      // 构建默认内容
      return `## **${topic} - Research Overview**

### **Current Research Status**
- Analysis based on ${papersInfo.length} research papers
- ${highCiteCount} high-citation papers included
- Recent publications from ${recentYear}

### **Research Focus Areas**
- ${titles.slice(0, 3).join(", ")}
- ${titles.slice(3, 5).join(", ")}

### **Key Research Directions**
- Literature review and analysis
- Methodological improvements
- Application development

### **Research Keywords**
- ${topic}
- Literature analysis
- Research synthesis

### **Future Research Opportunities**
- Expand dataset coverage
- Develop new methodologies
- Explore interdisciplinary applications

*Note: This is a default analysis. For AI-powered insights, please check subscription status.*`;
    },

    generatedText() {
      if (
        this.currentRow.index !== -1 &&
        this.currentSourceKnowledge &&
        this.currentTargetKnowledge
      ) {
        this.handleNewRel(this.currentRow.index, this.currentRow.row);
      }
    },

    switchFormatTooltip(value) {
      if (value === 1) {
        return "informative mode";
      } else {
        return "efficient mode";
      }
    },

    fixAndParseJson(jsonString) {
      // 检查 conclusions 和 topics 之间的逗号是否存在
      jsonString = jsonString.replace(
        /"conclusions":\s*("[^"]*")\s*"topics":/,
        '"conclusions": $1,\n    "topics":'
      );
      try {
        return JSON.parse(jsonString);
      } catch (error) {
        throw new Error("JSON 解析失败: " + error.message);
      }
    },

    flexColumnWidth() {
      // according to the content to set the width of the column; unit: px
      // fetch the width of the screen
      const screenWidth = document.body.clientWidth;
      return screenWidth / 3;
    },

    uniqueArray(arr) {
      return Array.from(new Set(arr));
    },

    initRelationCloud() {
      const container_cloud = this.$refs.cloudContainer;
      const tags = container_cloud.getElementsByClassName("relation-tag");

      this.cloudInstance = new RelationCloudInitialization({
        container_cloud,
        data: tags,
        radius: 100, // 小一点点
        baseSpeed: 0.005, // 慢慢转
        focalLength: 600,
      });
    },

    handleTagClick(event, row, index) {
      this.handleSingleNewRel(index, row);
      // 手动触发popover
      this.$refs[`popover-${index}`][0].showPopper = true;
    },

    // END
  },
};

// 添加3D云初始化类
class RelationCloudInitialization {
  constructor(config_cloud) {
    this.config_cloud = config_cloud;
    this.container_cloud = config_cloud.container_cloud;
    this.tags = [];
    this.R = config_cloud.radius || 120;
    this.baseSpeed = config_cloud.baseSpeed || 0.01; // 降低速度以减少渲染压力
    this.focalLength = config_cloud.focalLength || 500;
    this.mouseX = 0.001;
    this.mouseY = 0.001;
    this.angleX = 0.002; // 初始微小角度，页面一加载就动，但幅度更小
    this.angleY = 0.002;
    this.isMouseInside = false;
    this.isVisible = true; // 新增：控制是否可见
    this.isAnimating = true; // 新增：控制是否动画
    this.lastFrameTime = 0;
    this.frameRateLimit = 60; // 目标帧率
    this.frameInterval = 1000 / this.frameRateLimit;
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
    this.init();
  }

  init() {
    const { data } = this.config_cloud;

    Array.from(data).forEach((tag, index) => {
      const angleA = Math.acos((2 * (index + 1) - 1) / data.length - 1);
      const angleB = angleA * Math.sqrt(data.length * Math.PI);

      const tagObj = {
        element: tag,
        x: this.R * Math.sin(angleA) * Math.cos(angleB),
        y: this.R * Math.sin(angleA) * Math.sin(angleB) * 1.2,
        z: this.R * Math.cos(angleA),
      };

      this.tags.push(tagObj);
      this.updateTagPosition(tagObj);
    });

    this.bindEvents();
  }

  bindEvents() {
    this.container_cloud.addEventListener("mousemove", this.handleMouseMove);
    this.container_cloud.addEventListener("mouseleave", this.handleMouseLeave);
    this.container_cloud.addEventListener("mouseenter", this.handleMouseEnter);
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
    this.startAnimation();
  }

  handleMouseMove(e) {
    if (!this.isMouseInside) return; // 保守保护

    const rect = this.container_cloud.getBoundingClientRect();
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;

    const deltaX = (e.clientX - rect.left - centerX) / centerX;
    const deltaY = (e.clientY - rect.top - centerY) / centerY;

    // 缓慢调整目标值，减少频繁更新
    this.mouseX = deltaY * this.baseSpeed * Math.PI;
    this.mouseY = deltaX * this.baseSpeed * Math.PI;
  }

  handleMouseLeave() {
    // 鼠标离开时，不再跟踪，保持当前 mouseX 和 mouseY
    this.isMouseInside = false;
    this.mouseX = this.angleX;
    this.mouseY = this.angleY;
  }

  handleMouseEnter() {
    this.isMouseInside = true;
    // 鼠标进入时恢复动画
    this.resumeAnimation();
  }

  handleVisibilityChange() {
    if (document.hidden) {
      this.pauseAnimation();
    } else {
      this.resumeAnimation();
    }
  }

  // 帧率控制的动画函数
  animate(timestamp) {
    // 限制帧率
    if (timestamp - this.lastFrameTime < this.frameInterval) {
      this.animationFrame = requestAnimationFrame(this.animate.bind(this));
      return;
    }

    this.lastFrameTime = timestamp;

    if (this.isAnimating && this.isVisible) {
      // 平滑过渡角度
      this.angleX += (this.mouseX - this.angleX) * 0.05;
      this.angleY += (this.mouseY - this.angleY) * 0.05;

      this.tags.forEach((tag) => {
        // X轴旋转
        const y1 =
          tag.y * Math.cos(this.angleX) - tag.z * Math.sin(this.angleX);
        const z1 =
          tag.z * Math.cos(this.angleX) + tag.y * Math.sin(this.angleX);

        // Y轴旋转
        const x2 = tag.x * Math.cos(this.angleY) - z1 * Math.sin(this.angleY);
        const z2 = z1 * Math.cos(this.angleY) + tag.x * Math.sin(this.angleY);

        tag.x = x2;
        tag.y = y1;
        tag.z = z2;

        this.updateTagPosition(tag);
      });
    }

    this.animationFrame = requestAnimationFrame(this.animate.bind(this));
  }

  updateTagPosition(tag) {
    const scale = this.focalLength / (this.focalLength - tag.z);
    tag.element.style.transform = `
    translate3d(
      ${tag.x}px,
      ${tag.y}px,
      ${tag.z}px
    )
    scale(${scale * 0.8})
    translate(-60%, -60%)  /* 关键！让标签自身中心对齐 */
  `;
    tag.element.style.left = "50%";
    tag.element.style.top = "50%";
    tag.element.style.zIndex = Math.floor(tag.z);
    tag.element.style.opacity = ((tag.z + this.R) / (2 * this.R)) * 0.6 + 0.4;
  }

  // 暂停动画
  pauseAnimation() {
    this.isAnimating = false;
  }

  // 恢复动画
  resumeAnimation() {
    this.isAnimating = true;
  }

  // 设置是否可见
  setVisible(isVisible) {
    this.isVisible = isVisible;
    if (!isVisible) {
      this.pauseAnimation();
    }
  }

  startAnimation() {
    this.isAnimating = true;
    if (!this.animationFrame) {
      this.animationFrame = requestAnimationFrame(this.animate.bind(this));
    }
  }

  destroy() {
    cancelAnimationFrame(this.animationFrame);
    this.container_cloud.removeEventListener("mousemove", this.handleMouseMove);
    this.container_cloud.removeEventListener(
      "mouseleave",
      this.handleMouseLeave
    );
    this.container_cloud.removeEventListener(
      "mouseenter",
      this.handleMouseEnter
    );
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
    this.tags = [];
    this.animationFrame = null;
  }
}
</script>

<style lang="less">
/* Liquid Glass Design Language - 液态玻璃设计语言 */
:root {
  --glass-bg: rgba(255, 255, 255, 0.7);
  --glass-bg-hover: rgba(255, 255, 255, 0.9);
  --glass-border: rgba(255, 255, 255, 0.3);
  --glass-border-hover: rgba(255, 255, 255, 0.5);
  --glass-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  --glass-shadow-hover: 0 6px 40px rgba(0, 0, 0, 0.15);
  --glass-blur: 12px;
  --glass-transition: all 0.3s ease;
  --glass-radius: 12px; /* 统一圆角变量 */

  /* 夜间模式变量 */
  --glass-bg-dark: rgba(45, 45, 45, 0.6);
  --glass-bg-hover-dark: rgba(60, 60, 60, 0.8);
  --glass-border-dark: rgba(255, 255, 255, 0.1);
  --glass-border-hover-dark: rgba(255, 255, 255, 0.2);
  --glass-shadow-dark: 0 4px 30px rgba(0, 0, 0, 0.3);
  --glass-shadow-hover-dark: 0 6px 40px rgba(0, 0, 0, 0.4);
}

/* 全局liquid glass基础样式 */
.liquid-glass {
  background: var(--glass-bg);
  backdrop-filter: blur(var(--glass-blur));
  -webkit-backdrop-filter: blur(var(--glass-blur));
  border: 1px solid var(--glass-border);
  box-shadow: var(--glass-shadow);
  border-radius: 12px;
  transition: var(--glass-transition);
}

/* 为Element UI组件添加Liquid Glass样式 */
.liquid-glass-button {
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.4);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: var(--glass-transition);
  &:hover {
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  }
  &:active {
    background: rgba(240, 240, 240, 0.9);
  }
}

.liquid-glass-input {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.4);
  box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.05);
  transition: var(--glass-transition);
  &:focus {
    background: rgba(255, 255, 255, 0.9);
    border-color: rgba(255, 255, 255, 0.6);
    box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.1);
  }
}

.el-dialog {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(2px);
  border-radius: 10px;
}

/* 思维导图全屏对话框样式 */
.mindmap-fullscreen-dialog {
  /* 移除高度限制，让对话框自适应内容 */
}

.mindmap-fullscreen-dialog .el-dialog {
  width: 80vw !important;
  height: 80vh !important;
  max-width: none !important;
  max-height: none !important;
  display: flex;
  flex-direction: column;
  margin-top: 7.5vh !important;
  margin-bottom: 0.5vh !important;
  border-radius: var(--glass-radius);
}

.mindmap-fullscreen-dialog .el-dialog__header {
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
}

.mindmap-fullscreen-dialog .el-dialog__body {
  flex: 1;
  padding: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  position: relative;
}

.mindmap-fullscreen-dialog .mindmap-container {
  flex: 1;
  height: 100%;
  min-height: 600px;
  border: none;
  border-radius: 12px;
  margin: 0;
  position: relative;
}

.mindmap-fullscreen-dialog .mindmap-preview {
  height: 100%;
  min-height: 600px;
}

/* 确保工具栏在对话框内正确显示 */
.mindmap-fullscreen-dialog .floating-toolbar {
  position: absolute !important;
  bottom: 20px !important;
  right: 20px !important;
  z-index: 1000 !important;
}

/* 暗黑模式适配 */
.dark-mode .mindmap-fullscreen-dialog .el-dialog {
  background: #2d2d2d;
}

.dark-mode .mindmap-fullscreen-dialog .mindmap-container {
  background: #2d2d2d;
}

/* Dark mode styles for topic detail dialog */
.dark-mode .topic-detail-dialog .el-dialog {
  background: #2d2d2d;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  border-radius: var(--glass-radius) !important;
}

.dark-mode .topic-detail-dialog .el-dialog__header {
  background: #2d2d2d;
  border-bottom: 1px solid #444;
  flex-shrink: 0;
  border-radius: 12px;
}

.dark-mode .topic-detail-dialog .el-dialog__title {
  color: #e0e0e0;
}

.dark-mode .topic-detail-dialog .el-dialog__body {
  background: #2d2d2d;
  padding: 0;
  flex: 1;
  overflow: hidden;
}

.dark-mode .topic-detail-dialog .topic-detail-content {
  padding: 20px;
  max-height: 60vh;
  overflow-y: auto;
}

.dark-mode .topic-detail-dialog .topic-detail-content .content-text {
  color: #e0e0e0;
  background: rgba(45, 45, 45, 0.8);
  border: 1px solid #555;
}

.dark-mode .topic-detail-dialog .topic-detail-content .content-loading {
  background: rgba(45, 45, 45, 0.8);
}

.dark-mode .topic-detail-dialog .topic-dialog-datasets {
  background: rgba(45, 45, 45, 0.8);
  border-color: rgba(103, 194, 58, 0.25);
}

.dark-mode .topic-detail-dialog .dataset-section-title {
  color: #c9d1d9;
}

.dark-mode .topic-detail-dialog .dataset-card-link {
  background: rgba(60, 60, 60, 0.7);
  color: #90caf9;
  border-color: rgba(144, 202, 249, 0.18);
}

.dark-mode .topic-detail-dialog .dataset-card-desc {
  color: #bbb;
}

.dark-mode .topic-detail-dialog .el-dialog__footer {
  background: #2d2d2d;
  border-top: 1px solid #444;
  padding: 12px 20px;
  text-align: center;
  flex-shrink: 0;
  border-radius: 12px;
}

.dark-mode .topic-detail-dialog .dialog-footer .el-button {
  background: #409eff;
  border-color: #409eff;
}

/* Footer styling for better appearance */
.topic-detail-dialog .el-dialog {
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  border-radius: var(--glass-radius) !important;
}

.topic-detail-dialog .el-dialog__body {
  flex: 1;
  overflow: hidden;
  padding: 0;
}

.topic-detail-dialog .el-dialog__footer {
  text-align: center;
  padding: 15px 20px;
  flex-shrink: 0;
}

.topic-detail-dialog .dialog-footer .el-button {
  margin-left: 0;
}

.el-table {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(2px);
  border-radius: 10px;
}
.el-popover {
  background: rgba(198, 227, 255, 0.2);
  backdrop-filter: blur(10px);
  border-radius: 10px;
}

.relation-popover {
  background: rgba(198, 227, 255, 0.2) !important;
  backdrop-filter: blur(5px) !important;
  -webkit-backdrop-filter: blur(5px) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  border-radius: 10px !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1) !important;
  border-left: 3px solid #007bff !important;
  // 添加边框发光效果
  box-shadow: 0 0 15px rgba(0, 123, 255, 0.2), 0 4px 20px rgba(0, 0, 0, 0.1) !important;
}

.relation-popover-content {
  background: transparent !important;
  padding: 15px;
}

/* 边信息头部样式 - 与initMap函数保持一致 */
.edge-header {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e0e0e0;
}

/* 边标题样式 */
.edge-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 16px;
  text-align: center;
  color: #1a202c;
}

/* 连接符号样式 */
.connector-span {
  display: inline-block;
  margin: 0 12px;
  padding: 2px 8px;
  border-radius: 12px;
  background: rgba(0, 123, 255, 0.1);
  color: #007bff;
  font-size: 14px;
}

/* 边统计信息卡片 */
.edge-stats-card {
  display: flex;
  justify-content: center;
  gap: 20px;
  padding: 16px;
  border-radius: 12px;
  background: rgba(247, 250, 252, 0.6);
  backdrop-filter: blur(10px);
}

/* 统计项样式 */
.edge-stat-item {
  text-align: center;
  padding: 12px 20px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(8px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

/* 统计标签样式 */
.edge-stat-label {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #666;
  margin-bottom: 6px;
}

/* 统计值样式 */
.edge-stat-value {
  font-size: 20px;
  font-weight: bold;
  color: #007bff;
}

.dark-mode .relation-popover {
  background: rgba(40, 44, 52, 0.6) !important;
  border: 1px solid rgba(60, 64, 72, 0.5) !important;
  border-left: 3px solid #90caf9 !important;
  box-shadow: 0 0 15px rgba(144, 202, 249, 0.2), 0 4px 20px rgba(0, 0, 0, 0.3) !important;
}

/* 暗黑模式下边信息样式 */
.dark-mode .edge-header {
  border-bottom: 1px solid #444;
}

.dark-mode .edge-title {
  color: #ffffff;
}

.dark-mode .edge-stats-card {
  background: rgba(60, 60, 60, 0.5);
}

.dark-mode .edge-stat-item {
  background: rgba(80, 80, 80, 0.4);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.dark-mode .edge-stat-label {
  color: #aaa;
}

.dark-mode .edge-stat-value {
  color: #90caf9;
}

.dark-mode .relation-popover-content .el-tag {
  background: rgba(60, 64, 72, 0.8) !important;
  border: 1px solid rgba(80, 84, 92, 0.5) !important;
  color: #ffffff !important;
}

.dark-mode .knowledgeSingleText {
  background: rgba(60, 64, 72, 0.5) !important;
  color: #ffffff !important;
}

.dark-mode .relation-popover-content .connector-span {
  background: rgba(144, 202, 249, 0.2) !important;
  color: #90caf9 !important;
}
.el-button--primary.is-plain {
  color: #262626;
  background: rgba(198, 227, 255, 0.7);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-color: rgba(255, 255, 255, 0.4);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: var(--glass-transition);
  &:hover {
    background: rgba(198, 227, 255, 0.9);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  }
  &:active {
    background: rgba(180, 210, 240, 0.9);
  }
  font-weight: 600;
}
.el-tooltip__popper.is-light {
  border: 1px solid #303133;
  background-color: #ecf5ff;
}
.result-page-container {
  .search-box {
    .el-input__inner {
      /* width: 920px; */
      height: 64px;
      background: rgba(255, 255, 255, 0.8);
      backdrop-filter: blur(8px);
      -webkit-backdrop-filter: blur(8px);
      border: 1px solid rgba(255, 255, 255, 0.4);
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
      font-size: 18px;
      transition: var(--glass-transition);
      border: none;
      padding-left: 48px;
      display: flex;
      justify-content: space-between;
    }
    .el-input__prefix {
      left: 16px;
      top: 2px;
      transition: all 0.3s;
      font-size: 24px;
      // color: #2F44FF;
      color: #2f44ff;
    }
    .search-input-box {
      width: 100%;
      font-family: "Helvetica Neue", sans-serif;
      word-spacing: 5px;
    }
  }
  .conclusion-article,
  .fields-keywords {
    .el-card__header {
      padding: 12px 20px;
    }
    .el-card__body {
      height: 100%;
      padding: 0;
    }
    .title {
      .el-progress-circle {
        height: 30px !important;
        width: 30px !important;
      }
      &.warning {
        .el-progress__text {
          color: rgb(242, 201, 76);
          font-size: 40px;
        }
      }
      &.success {
        .el-progress__text {
          color: rgb(33, 150, 83);
          font-size: 40px;
        }
      }
      &.error {
        .el-progress__text {
          color: rgb(235, 87, 87);
          font-size: 40px;
        }
      }
    }
  }
  .main-container {
    // .el-card {
    //   height: 100%;
    // }
    .el-card__body {
      height: 100%;
    }
    .g6-component-tooltip {
      z-index: 2004;
      padding: 0;
      border-radius: 10px;
      background: rgba(198, 227, 255, 0.2);
      backdrop-filter: blur(5px);
    }
  }
  .user-input-panel {
    .el-input.is-active .el-input__inner,
    .el-input__inner:focus {
      border-color: #2f44ff;
      background: rgba(255, 255, 255, 0.9) !important;
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15) !important;
    }
  }
}
</style>
<style lang="less" scoped>
.result-page-container {
  // background: #fefcff;
  background: #f8fbff;
  font-family: "Open Sans", sans-serif;
  min-height: calc(100vh - 64px);

  // 暗黑模式适配
  .dark-mode & {
    background: #1e1e1e !important;
  }
  .result-panel {
    padding: 10px 0;
    margin: auto;
    // width: 1440px;
    text-align: left;
  }
  .search-box {
    display: flex;
    align-items: center;
    .el-button {
      height: 64px;
      // background: #f0d7ff;
      background: #c6e3ff;
      border-radius: var(--glass-radius);
      border: none;
      //margin-left: 18px;
      //font-family: "Source Sans Pro", "PingFang SC";
      font-weight: bold;
      font-size: 24px;
      color: #000;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    }
    .el-date-editor.el-input {
      width: 256px;
      margin-left: 18px;
    }
    .search-input-box .el-input__inner {
      border-radius: var(--glass-radius);
    }
    .switch_mode_button {
      border-radius: var(--glass-radius);
      background: rgba(255, 255, 255, 0.7);
      backdrop-filter: blur(8px);
      -webkit-backdrop-filter: blur(8px);
      border: 1px solid rgba(255, 255, 255, 0.3);
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    }
    .download_button,
    .feedback_button,
    .tooltip_button {
      border-radius: var(--glass-radius);
    }
  }
  .graph-icon {
    padding: 0 6.2px 0 6.4px;
    cursor: pointer;
  }
  .tool-list {
    text-align: right;
    padding-right: 48px;
    padding-top: 10px;
    .iconfont {
      font-size: 24px;
      color: #1e1e1e;
      vertical-align: middle;
      cursor: pointer;
      // margin: 0 18px;
    }
    img {
      vertical-align: middle;
      margin-left: 18px;
      cursor: pointer;
    }
  }
  .paper-content-section {
    // Liquid glass style for paper content section
    border-radius: var(--glass-radius);
    transition: var(--glass-transition);

    .box-card {
      transition: transform 0.3s ease, box-shadow 0.3s ease;
    }

    .box-card:hover {
      transform: translateY(-5px);
      box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
    }

    /* 高引论文容器样式 */
    .high-cite-papers-container {
      display: flex;
      gap: 15px;
    }

    .high-cite-card {
      flex: 1;
      min-width: 0;
    }

    .title {
      font-weight: bold;
      font-size: 20px;
      line-height: 24px;
      color: #000000;
      // margin-bottom: 6px;
      //font-family: "Muli", sans-serif;
    }
    .content {
      //font-family: "Open Sans", sans-serif;
      font-size: 15px;
      line-height: 24px;
      color: #000000;
    }
    .year {
      font-size: 13px;
      line-height: 18px;
      color: #4a4a4a;
      margin-right: 20px;
      margin-top: 5px;
    }
    .author_prefix {
      font-size: 14px;
      line-height: 18px;
      color: #4a4a4a;
    }
    .author {
      font-size: 14px;
      line-height: 24px;
      color: #2f44ff;
    }

    .map-panel {
      height: 374px;
      margin-top: 16px;
    }
    .chart-panel {
      height: 100px;
      padding: 10px;
      margin-top: 16px;
    }
    .list-panel {
      padding: 24px 48px;
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 24px;
    }
    .conclusion-article {
      height: 300px;
      // padding: 12px 0;
      margin-top: 16px;
      box-sizing: border-box;
    }
    .fields-keywords {
      padding: 10px 0;
      height: 190px;
      box-sizing: border-box;
      .el-button {
        color: #2f44ff;
        // background: rgba(240, 215, 255, 50%);
        background: rgba(198, 227, 255, 50%);
        border: none;
        margin: 3px;
        padding: 10px;
        font-size: small;
      }
    }
  }
  .main-container {
    margin-top: 10px;
    position: relative;
    height: calc(100vh - 210px);
    .layout-left,
    .layout-right {
      width: 395px;
      height: 100vh;
      position: absolute;
      top: 0;
    }
    .layout-left {
      left: 0;
      height: 100vh;
    }
    .layout-middle {
      width: 390px;
      position: absolute;
      height: 15px;
      bottom: 0;
      top: auto;
      left: calc(50% - 190px);
    }
    .layout-right {
      right: 0;
    }
    .panel {
      background: var(--glass-bg);
      backdrop-filter: blur(var(--glass-blur));
      -webkit-backdrop-filter: blur(var(--glass-blur));
      border: 1px solid var(--glass-border);
      box-shadow: var(--glass-shadow), var(--glass-highlight);
      border-radius: var(--glass-radius);
      margin-bottom: 10px;
      transition: var(--glass-transition);

      &:hover {
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12), var(--glass-highlight);
      }
    }

    // Apply glass effect to paper-content-section cards
    .paper-content-section .box-card {
      background: var(--glass-bg);
      backdrop-filter: blur(var(--glass-blur));
      -webkit-backdrop-filter: blur(var(--glass-blur));
      border: 1px solid var(--glass-border);
      box-shadow: var(--glass-shadow), var(--glass-highlight);
      border-radius: var(--glass-radius);
      transition: var(--glass-transition);

      &:hover {
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12), var(--glass-highlight);
      }
    }
    .title {
      font-weight: bold;
      font-size: 18px;
      line-height: 24px;
      color: #000000;
      // margin-bottom: 6px;
      font-family: "Helvetica Neue", sans-serif;
      margin-bottom: 16px;
    }
    .sup_text {
      position: relative;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 10px;
      font-weight: 600;
      vertical-align: top;
      top: -1px;
      margin: 0px 2px;
      min-width: 14px;
      height: 14px;
      border-radius: 3px;
      text-decoration-color: transparent;
      color: rgb(18, 59, 182);
      background: rgb(209, 219, 250);
      outline: transparent solid 1px;
    }
    .future-topics-panel {
      padding-left: 0;
      padding-right: 0;
      box-sizing: border-box;

      .future-research-info {
        margin-bottom: 20px;
        padding: 8px 20px;
        border-radius: 7px;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);
        font-family: "Helvetica Neue", sans-serif;
        font-size: 14px;
        font-weight: 500;
        line-height: 22px;
        word-spacing: 2px;
        transition: all 0.3s ease;
      }

      .future-research-info:nth-child(even) {
        background: rgba(198, 227, 255, 40%);
      }

      .future-research-info:nth-child(odd) {
        background: rgba(248, 251, 255, 40%);
      }

      /* 自定义展开/折叠图标 */
      .future-research-info > summary .el-icon-plus {
        transition: transform 0.3s ease;
      }

      /* 展开时旋转加号为减号 */
      .future-research-info[open] > summary .el-icon-plus {
        transform: rotate(45deg);
      }

      /* 展开时的动画效果 */
      .future-research-info > span {
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.3s ease;
      }

      .future-research-info[open] > span {
        max-height: 2000px;
      }

      .future-detail-block {
        flex: 1;
        min-width: 0;
      }

      .future-detail-main {
        display: flex;
        align-items: flex-start;
      }

      .future-datasets {
        margin-top: 12px;
        padding: 10px 12px;
        border-radius: 8px;
        background: rgba(255, 255, 255, 0.55);
        border: 1px solid rgba(103, 194, 58, 0.16);
      }

      .dataset-section-title {
        display: flex;
        align-items: center;
        gap: 5px;
        margin-bottom: 8px;
        color: #53616f;
        font-size: 12px;
        font-weight: 600;
      }

      .dataset-list {
        display: flex;
        flex-direction: column;
        gap: 8px;
      }

      .dataset-list.compact {
        flex-direction: row;
        flex-wrap: wrap;
        gap: 6px;
      }

      .dataset-chip {
        max-width: 100%;
        padding: 4px 8px;
        border-radius: 6px;
        background: rgba(103, 194, 58, 0.1);
        color: #22863a;
        font-size: 11px;
        line-height: 1.35;
        text-decoration: none;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .dataset-loading,
      .dataset-empty {
        color: #909399;
        font-size: 11px;
        line-height: 1.4;
      }

      .loading-skeleton {
        height: 12px;
        width: 300px;
        background: linear-gradient(
          90deg,
          #f0f0f0 25%,
          #2d92ff 50%,
          #f0f0f0 75%
        );
        background-size: 200% 100%;
        border-radius: 4px;
        animation: loading-sk 2s infinite;
      }

      @keyframes loading-sk {
        0% {
          background-position: 200% 0;
        }
        100% {
          background-position: -200% 0;
        }
      }
    }
    .relation-panel {
      // 放到media那边了
      // height: 35vh; //270px;
      // height: calc(41vh - 90px);
    }
    .edge-info {
      margin-bottom: 16px;
      word-break: break-all;
      .label {
        font-weight: 500;
        margin-right: 6px;
      }
    }
    .content {
      font-family: "Open Sans", sans-serif;
      font-size: 14px;
      line-height: 18px;
      color: #000000;
    }
    #map-panel {
      height: 100%;
    }
    .user-input-panel {
      display: flex;
      /* justify-items: center; */
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
      .el-input {
        margin-right: 8px;
      }
      .iconfont {
        font-weight: 900;
        color: #2f44ff;
        font-size: 20px;
        cursor: pointer;
      }
    }
    .button-panel {
      // height: 15vh; //calc(50% - 220px);
      height: 170px;
      transition: height 0.3s ease; /* 添加过渡效果 */
      .el-button {
        margin: 0 5px 5px 0;
        border-radius: 12px !important; // 与外部容器圆角保持一致
        &:hover {
          color: #000 !important; // 确保hover时文字颜色不为白色
          background-color: rgba(
            127,
            167,
            210,
            0.3
          ) !important; // 调整hover背景色
        }
      }
      .ana-button {
        width: 100%;
        height: 40px;
        margin: 0 5px 5px 5px;
        background: #ecf5ff;
        border-radius: 16px;
        box-shadow: 0 2px 8px rgba(64, 158, 255, 0.5);
        transition: all 0.3s ease;
      }

      .key-node {
        font-weight: bold;
        color: #000000;
        border-radius: 5px;
        margin: 50px;
        padding: 10px;
        background-color: #ecf5ff;
        width: 800px;
      }
    }
    .button-panel:hover {
      height: calc(101vh - 165px); /* 鼠标移入时，button-panel 的高度变大 */
    }
    .discovery-panel {
      //height: 32vh; //calc(50% - 45px);
      //height: calc(60vh - 190px); 放到media中了
      transition: height 0.3s ease; /* 添加过渡效果 */
      .conclusion_sec {
        font-size: 16px;
        color: rgb(63 80 104);
        line-height: 27px;
        font-weight: 400;
        word-spacing: 2.5px;
        font-family: "Helvetica Neue", sans-serif;
      }
    }
  }
  .feedback-dialog-wrapper {
    font-size: medium;
    line-height: 25px;
    color: #989898;
    text-align: center;
  }
  .knowledge-dialog {
    font-size: medium;
    line-height: 25px;
    color: #989898;
    text-align: left;
    padding: 20px;
  }
  .hover-underline {
    &:hover {
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .href-link {
    text-decoration: none;
  }
  .hover-style {
    cursor: pointer;
  }
}

.btn-group {
  //'#065758',
  //'#25767B',
  //'#44949E',
  //'#62B3C1',
  //'#81D2E4',
  //'#BCEDD8',
  .c-065758 {
    color: #065758;
    border: 1px solid #065758;
    &.active-btn {
      background: #065758;
      color: #fff;
    }
  }
  .c-25767B {
    color: #25767b;
    border: 1px solid #25767b;
    &.active-btn {
      background: #25767b;
      color: #fff;
    }
  }
  .c-44949E {
    color: #44949e;
    border: 1px solid #44949e;
    &.active-btn {
      background: #44949e;
      color: #fff;
    }
  }
  .c-62B3C1 {
    color: #62b3c1;
    border: 1px solid #62b3c1;
    &.active-btn {
      background: #62b3c1;
      color: #fff;
    }
  }
  .c-81D2E4 {
    color: #81d2e4;
    border: 1px solid #81d2e4;
    &.active-btn {
      background: #81d2e4;
      color: #fff;
    }
  }
  .c-BCEDD8 {
    color: #bcedd8;
    border: 1px solid #bcedd8;
    &.active-btn {
      background: #bcedd8;
      color: #fff;
    }
  }
}

.img_text {
  display: flex;
  flex-wrap: wrap; /* 允许内容在需要时换行 */
  align-items: center; /* 垂直居中对齐 */
  gap: 20px; /* 图片和文本之间的间距 */
  padding: 20px; /* 整体内边距 */
  margin: 50px 50px 0 50px; /* 整体外边距 */
}

.ppt-textStyle {
  flex: 1 1 300px; /* 文本在宽度上至少300px，并且可以扩展 */
  max-width: 50%; /* 文本最大宽度为50% */
  font-size: 18px;
  line-height: 3rem;
  color: #333;
  font-weight: bold;
  font-family: "Helvetica Neue", "HelveticaNeue-Light", "Helvetica Neue",
    "sans-serif";
  word-spacing: 5px;
  padding: 1rem;
  margin-left: 2rem;
  text-align: left;
}

/deep/ .el-rate__icon {
  font-size: 25px;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #ecf6ff;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #e9f3ff;
}

.switch_mode_button {
  border-color: rgb(92, 146, 255);
  box-shadow: rgba(0, 0, 0, 0.25) 0 0 5px;
  height: 64px;
  border-radius: 4px;
  margin-left: 10px;
}

@media screen and (min-width: 1200px) {
  .result-page-container {
    .paper-content-section {
      margin-top: 65px;
    }
    .future-topics-panel {
      height: calc(58vh - 90px);
    }
    .relation-panel {
      // height: 35vh; //270px;
      height: calc(43vh - 90px);
    }
    .discovery-panel {
      height: calc(101vh - 355px);
    }
  }
}
@media screen and (max-width: 1200px) {
}
@media screen and (max-width: 992px) {
  .result-page-container {
    .search-box .el-button {
      font-size: 20px;
    }
    .layout-middle {
      display: none;
    }
    #map-panel {
      display: none;
    }
  }
}
@media screen and (max-width: 768px) {
  .result-page-container {
    .img_text {
      flex-direction: column; /* 在小屏幕上改为上下布局 */
      align-items: flex-start; /* 左对齐 */
      .ppt-textStyle {
        max-width: 100%; /* 在小屏幕上图片和文本占满宽度 */
      }
    }
    .main-container {
      height: auto;
      .layout-left,
      .layout-right {
        position: relative;
        width: 100%;
      }
      .layout-left {
        height: 86vh;
      }
      .layout-right {
        height: 76vh;
      }
    }
    .search-button-text {
      display: none;
    }
    .paper-content-section {
      margin-top: -20px;
    }
    .future-topics-panel {
      height: calc(45vh);
    }
    .relation-panel {
      height: calc(38vh);
    }
    .discovery-panel {
      height: calc(70vh);
    }
    .search-box .el-button {
      font-size: 17px;
    }
    .download_button {
      //display: none;
    }
    .switch_mode_button {
      display: none;
    }
    .feedback_button {
      display: none;
    }
    .tooltip_button {
      display: none;
    }
    .button-panel {
      display: none;
    }
    .el-carousel {
      display: none;
    }
    .try-button {
      display: none;
    }

    /* 高引论文在移动端的响应式样式 */
    .high-cite-papers-container {
      display: flex;
      flex-direction: column;
      gap: 15px;
    }
    .high-cite-card {
      width: 100% !important;
      margin-bottom: 15px;
    }
  }
}
.dialog-buttons {
  position: absolute;
  right: 55px;
  top: 20px;
  font-size: 18px;
  cursor: pointer;

  i:first-child {
    margin-right: 10px;
  }
  i:last-child {
    margin-left: 10px;
  }
}

// 设置自定义绘图的样式
.canvas-content {
  width: 100%;
  height: 22rem;
  padding: 0.625rem;
  box-sizing: border-box;
  display: flex;
  justify-content: space-evenly;

  .left {
    width: 20%;
    .box {
      width: 100%;
      height: 8.75rem;
      background: #d7e1f5;
      color: #59658f;
      border-radius: 0.5rem;
      padding: 0.5rem;
      box-sizing: border-box;
      font-size: 0.75rem;
      display: flex;
      align-items: center;
      white-space: normal;
      word-wrap: break-word;
      word-break: break-word;
    }
    .box:last-child {
      margin-top: 0.75rem;
    }
  }

  .line {
    width: 3%;
    .item {
      width: 100%;
      height: 8.75rem;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      .hr {
        svg {
          width: 1.8rem;
        }
      }
    }
    .item:last-child {
      margin-top: 0.75rem;
    }
  }

  .center {
    width: 14%;
    .key {
      width: 100%;
      height: 8.75rem;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        width: 100%;
        // height: 1.375rem;
        background: #d7e1f5;
        color: #59658f;
        display: inline-block;
        padding: 0.5rem;
        border-radius: 0.5rem;
        white-space: normal;
        word-wrap: break-word;
        word-break: break-word;
      }
    }
    .key:last-child {
      margin-top: 0.75rem;
    }
  }

  .right {
    width: 60%;
    min-height: 18.25rem;
    background: #ebeef5;
    color: #24292f;
    border-radius: 0.5rem;
    text-align: left;
    display: block;
    overflow: auto;
  }
}
.knowledgeText {
  padding: 0.75rem;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-word;
}

.knowledgeSingleText {
  margin-top: 5px;
  padding: 0 3px 3px 3px;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-word;
  background: rgba(198, 227, 255, 0);
  font-weight: 400;
}
.el-loading-mask {
  background-color: rgba(198, 227, 255, 0);
  border-radius: 12px;
}
.fontSetting {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,
    Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol" !important;
}

/* CSS部分 */
#relation-cloud-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  perspective: 800px;
  transform-style: preserve-3d;
  overflow: hidden;
}

.relation-tag {
  position: absolute;
  top: 50%;
  left: 50%;
  cursor: pointer;
  transform-origin: center center;
  transition: transform 0.2s ease, opacity 0.2s ease;
  white-space: nowrap;

  background-color: rgba(198, 227, 255, 0.4);
  color: #303133;
  font-weight: 600;
  padding: 2px 4px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* 悬停效果 */
.relation-tag:hover {
  /* 注意！这里只叠加一个scale放大，其他transform保持！ */
  transform: scale(1.15) translate(-50%, -50%);
  z-index: 9999;
  font-weight: 1000;
}

.tag-content {
  display: flex;
  align-items: center;
}

.tag-icon {
  color: #409eff;
  margin-right: 5px;
}

.tag-text {
  display: inline-block;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
}

/* Topic Detail Dialog Styles */
.topic-detail-content {
  padding: 20px;
  max-height: 60vh;
  overflow-y: auto;

  .content-text {
    line-height: 1.8;
    color: #333;
    font-size: 14px;
    text-align: left;
    white-space: pre-wrap;
    word-wrap: break-word;
    padding: 16px 20px;
    background: rgba(255, 255, 255, 0.7);
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    margin: 10px 0;
  }

  .content-loading {
    padding: 40px 20px;
  }

  .topic-dialog-datasets {
    margin: 14px 0 4px;
    padding: 16px 20px;
    background: rgba(255, 255, 255, 0.7);
    border: 1px solid rgba(103, 194, 58, 0.18);
    border-radius: 8px;
  }

  .dataset-section-title {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 10px;
    color: #53616f;
    font-size: 13px;
    font-weight: 600;
  }

  .dataset-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .dataset-card-link {
    display: block;
    padding: 10px 12px;
    border-radius: 8px;
    background: rgba(247, 250, 252, 0.9);
    color: #007bff;
    text-decoration: none;
    border: 1px solid rgba(64, 158, 255, 0.12);
  }

  .dataset-card-title {
    display: block;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.4;
  }

  .dataset-card-desc {
    display: -webkit-box;
    margin-top: 4px;
    color: #666;
    font-size: 12px;
    line-height: 1.45;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .dataset-loading {
    color: #909399;
    font-size: 12px;
  }
}
</style>

/* 暗黑模式全局样式补充 */
<style lang="less" scoped>
/* 暗黑模式下的搜索框样式 */
.dark-mode .result-page-container {
  .search-box {
    .search-input-box {
      .el-input__inner {
        background: var(--glass-bg);
        backdrop-filter: blur(var(--glass-blur));
        -webkit-backdrop-filter: blur(var(--glass-blur));
        border: 1px solid var(--glass-border);
        color: #333;
        box-shadow: var(--glass-shadow), var(--glass-highlight);
        border-radius: var(--glass-radius);
        transition: var(--glass-transition);

        &:focus {
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15), var(--glass-highlight) !important;
        }
      }
    }

    .el-input__inner {
      background: rgba(45, 45, 45, 0.7) !important;
      backdrop-filter: blur(8px) !important;
      -webkit-backdrop-filter: blur(8px) !important;
      border: 1px solid rgba(255, 255, 255, 0.15) !important;
      color: #e0e0e0 !important;
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2) !important;
      transition: var(--glass-transition);
      border-radius: var(--glass-radius);
    }
    .el-input__prefix {
      color: #90caf9 !important;
    }
    .el-button {
      background: rgba(45, 63, 87, 0.8) !important;
      backdrop-filter: blur(8px) !important;
      -webkit-backdrop-filter: blur(8px) !important;
      border: 1px solid rgba(255, 255, 255, 0.15) !important;
      color: #e0e0e0 !important;
      box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.3) !important;
      transition: var(--glass-transition);
      border-radius: var(--glass-radius);
    }
    .switch_mode_button {
      border-radius: var(--glass-radius);
      background: rgba(45, 45, 45, 0.7) !important;
      backdrop-filter: blur(8px) !important;
      -webkit-backdrop-filter: blur(8px) !important;
      border: 1px solid rgba(255, 255, 255, 0.15) !important;
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2) !important;
    }
    .download_button,
    .feedback_button,
    .tooltip_button {
      border-radius: var(--glass-radius);
    }
  }

  /* 暗黑模式下的面板样式 */
  .panel {
    background: rgba(45, 45, 45, 0.7) !important;
    backdrop-filter: blur(12px) !important;
    -webkit-backdrop-filter: blur(12px) !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.3) !important;
  }

  /* 暗黑模式下的paper-content-section卡片样式 */
  .paper-content-section .box-card {
    background: rgba(45, 45, 45, 0.7) !important;
    backdrop-filter: blur(12px) !important;
    -webkit-backdrop-filter: blur(12px) !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.3), var(--dark-glass-highlight) !important;
    border-radius: var(--glass-radius) !important;
    transition: var(--glass-transition);

    &:hover {
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4), var(--dark-glass-highlight) !important;
    }
  }

  /* 暗黑模式下的文本样式 */
  .title,
  .content {
    color: #e0e0e0 !important;
  }

  /* 暗黑模式下的论文排序选择器样式 */
  .normal-papers-header.liquid-glass {
    background: var(--glass-bg-dark) !important;
    border: 1px solid var(--glass-border-dark) !important;
    box-shadow: var(--glass-shadow-dark) !important;

    h3 {
      color: #e0e0e0 !important;

      .el-icon-document {
        color: #90caf9 !important;
      }
    }

    .sort-controls {
      span {
        color: #b0b0b0 !important;
      }

      .el-select {
        .el-input__inner {
          background: rgba(60, 60, 60, 0.8) !important;
          border: 1px solid rgba(255, 255, 255, 0.15) !important;
          color: #e0e0e0 !important;

          &::placeholder {
            color: #888 !important;
          }
        }

        .el-input__suffix {
          .el-icon-arrow-up {
            color: #90caf9 !important;
          }
        }
      }
    }

    &:hover {
      background: var(--glass-bg-hover-dark) !important;
      border: 1px solid var(--glass-border-hover-dark) !important;
      box-shadow: var(--glass-shadow-hover-dark) !important;
    }
  }

  /* 暗黑模式下的下拉选项样式 */
  .el-select-dropdown {
    background: rgba(45, 45, 45, 0.95) !important;
    backdrop-filter: blur(12px) !important;
    -webkit-backdrop-filter: blur(12px) !important;
    border: 1px solid rgba(255, 255, 255, 0.15) !important;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3) !important;

    .el-select-dropdown__item {
      color: #e0e0e0 !important;

      &:hover {
        background: rgba(90, 90, 90, 0.5) !important;
      }

      &.selected {
        background: rgba(64, 158, 255, 0.2) !important;
        color: #90caf9 !important;
      }
    }
  }

  .year,
  .author_prefix {
    color: #999 !important;
  }
  .author {
    color: #90caf9 !important;
  }

  /* 暗黑模式下的图表和地图样式 */
  .g6-component-tooltip {
    background: rgba(45, 45, 45, 0.9) !important;
    color: #e0e0e0 !important;
  }

  /* 暗黑模式下的按钮样式 */
  .fields-keywords {
    .el-button {
      background: rgba(45, 63, 87, 0.7) !important;
      backdrop-filter: blur(8px) !important;
      -webkit-backdrop-filter: blur(8px) !important;
      border: 1px solid rgba(255, 255, 255, 0.15) !important;
      color: #90caf9 !important;
      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2) !important;
      transition: var(--glass-transition);
    }
  }

  /* 暗黑模式下的button-panel按钮样式 */
  .button-panel {
    .el-button {
      background: rgba(60, 80, 100, 0.7) !important; // 不为纯黑色
      backdrop-filter: blur(8px) !important;
      -webkit-backdrop-filter: blur(8px) !important;
      border: 1px solid rgba(255, 255, 255, 0.15) !important;
      color: #90caf9 !important;
      border-radius: 12px !important; // 与外部容器圆角保持一致
      &:hover {
        background: rgba(70, 90, 110, 0.8) !important; // 调整hover背景色
        color: #fff !important;
      }
    }
  }

  /* 暗黑模式下的future-research-info样式 */
  .future-research-info {
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5) !important;
    color: #e0e0e0 !important;
  }
  .future-research-info:nth-child(even) {
    background: rgba(45, 63, 87, 0.4) !important;
  }
  .future-research-info:nth-child(odd) {
    background: rgba(45, 45, 45, 0.4) !important;
  }

  .future-datasets {
    background: rgba(45, 45, 45, 0.42) !important;
    border-color: rgba(103, 194, 58, 0.24) !important;
  }

  .dataset-section-title {
    color: #c9d1d9 !important;
  }

  .dataset-chip {
    background: rgba(103, 194, 58, 0.16) !important;
    color: #a7e3a1 !important;
  }

  /* 暗黑模式下的卡片样式 */
  .box-card {
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }

  .box-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  }

  /* 暗黑模式下的relation-tag样式 */
  .relation-tag {
    background-color: rgba(45, 63, 87, 0.4) !important;
    color: #90caf9 !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3) !important;
  }

  /* 暗黑模式下的工具列表图标 */
  .tool-list {
    .iconfont {
      color: #90caf9 !important;
    }
  }

  /* 暗黑模式下的上标文本样式 */
  .sup_text {
    color: #90caf9 !important;
    background: #2d3f57 !important;
  }

  /* 暗黑模式下的轮播图文本颜色 */
  h3 {
    color: #e0e0e0 !important;
  }
  .ppt-textStyle {
    color: #e0e0e0 !important;
  }
}
</style>
